import { css as y, LitElement as w, html as l, svg as De } from "lit";
import { property as f, customElement as b, state as $ } from "lit/decorators.js";
import { ConfigCtrl as j, OptionsCtrl as p, ExplorerCtrl as S, ClientCtrl as L, ModalCtrl as _, CoreUtil as W, ToastCtrl as D, RouterCtrl as I } from "@web3modal/core";
import { classMap as T } from "lit/directives/class-map.js";
import { svg as k } from "lit-html";
import { animate as V, spring as Ce } from "motion";
import { ifDefined as B } from "lit/directives/if-defined.js";
import Ot from "qrcode";

var It = Object.defineProperty,
    st = Object.getOwnPropertySymbols,
    Et = Object.prototype.hasOwnProperty,
    Mt = Object.prototype.propertyIsEnumerable,
    ct = (e, t, a) => t in e ? It(e, t, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: a
}) : e[t] = a,
    dt = (e, t) => {
  for (var a in t || (t = {})) Et.call(t, a) && ct(e, a, t[a]);

  if (st) for (var a of st(t)) Mt.call(t, a) && ct(e, a, t[a]);
  return e;
};

function ht() {
  return {
    default: {
      light: {
        inverse: "rgb(255,255,255)",
        foreground: "rgb(51,150,255)",
        background: "rgb(232,242,252)"
      },
      dark: {
        inverse: "rgb(255,255,255)",
        foreground: "rgb(71,161,255)",
        background: "rgb(21,38,55)"
      }
    },
    magenta: {
      light: {
        inverse: "rgb(255,255,255)",
        foreground: "rgb(198,83,128)",
        background: "rgb(244,221,230)"
      },
      dark: {
        inverse: "rgb(255,255,255)",
        foreground: "rgb(203,77,140)",
        background: "rgb(57,35,43)"
      }
    },
    blue: {
      light: {
        inverse: "rgb(255,255,255)",
        foreground: "rgb(61,92,245)",
        background: "rgb(232,235,252)"
      },
      dark: {
        inverse: "rgb(255,255,255)",
        foreground: "rgb(81,109,251)",
        background: "rgb(28,33,59)"
      }
    },
    orange: {
      light: {
        inverse: "rgb(255,255,255)",
        foreground: "rgb(234,140,46)",
        background: "rgb(244,236,221)"
      },
      dark: {
        inverse: "rgb(0,0,0)",
        foreground: "rgb(255,166,76)",
        background: "rgb(57,50,34)"
      }
    },
    green: {
      light: {
        inverse: "rgb(255,255,255)",
        foreground: "rgb(38,181,98)",
        background: "rgb(218,246,218)"
      },
      dark: {
        inverse: "rgb(0,0,0)",
        foreground: "rgb(38,217,98)",
        background: "rgb(35,52,40)"
      }
    },
    purple: {
      light: {
        inverse: "rgb(255,255,255)",
        foreground: "rgb(121,76,255)",
        background: "rgb(225,218,246)"
      },
      dark: {
        inverse: "rgb(255,255,255)",
        foreground: "rgb(144,110,247)",
        background: "rgb(36,31,51)"
      }
    },
    teal: {
      light: {
        inverse: "rgb(255,255,255)",
        foreground: "rgb(43,182,182)",
        background: "rgb(217,242,238)"
      },
      dark: {
        inverse: "rgb(0,0,0)",
        foreground: "rgb(54,226,226)",
        background: "rgb(29,48,52)"
      }
    },
    blackWhite: {
      light: {
        inverse: "rgb(255,255,255)",
        foreground: "rgb(20,20,20)",
        background: "rgb(255,255,255)"
      },
      dark: {
        inverse: "rgb(0,0,0)",
        foreground: "rgb(255,255,255)",
        background: "rgb(20,20,20)"
      }
    }
  };
}

function Wt() {
  return {
    light: {
      foreground: {
        1: "rgb(20,20,20)",
        2: "rgb(121,134,134)",
        3: "rgb(158,169,169)"
      },
      background: {
        1: "rgb(255,255,255)",
        2: "rgb(241,243,243)",
        3: "rgb(228,231,231)"
      },
      overlay: "rgba(0,0,0,0.1)"
    },
    dark: {
      foreground: {
        1: "rgb(228,231,231)",
        2: "rgb(148,158,158)",
        3: "rgb(110,119,119)"
      },
      background: {
        1: "rgb(20,20,20)",
        2: "rgb(39,42,42)",
        3: "rgb(59,64,64)"
      },
      overlay: "rgba(255,255,255,0.1"
    }
  };
}

function At() {
  return {
    default: {
      1: "#B6B9C9",
      2: "#C653C6",
      3: "#794DFF",
      4: "#2EB8B8"
    },
    blue: {
      1: "#E8EBFD",
      2: "#C653C6",
      3: "#2DD2C5",
      4: "#3D5CF5"
    },
    magenta: {
      1: "#F4DDE6",
      2: "#E0D452",
      3: "#F09475",
      4: "#D1618D"
    },
    orange: {
      1: "#F4ECDD",
      2: "#B4EB47",
      3: "#3075E8",
      4: "#EB9947"
    },
    green: {
      1: "#DAF6DA",
      2: "#E06B92",
      3: "#99E54D",
      4: "#26B562"
    },
    purple: {
      1: "#E1DAF6",
      2: "#EB9947",
      3: "#E06B92",
      4: "#794DFF"
    },
    teal: {
      1: "#D9F2EE",
      2: "#F09475",
      3: "#794DFF",
      4: "#2EB8B8"
    },
    blackWhite: {
      1: "#E3E8E8",
      2: "#98AEAE",
      3: "#516767",
      4: "#242E2E"
    }
  };
}

const u = {
  color() {
    var e, t;
    const a = (e = j.state.themeColor) != null ? e : "default",
          n = (t = j.state.themeMode) != null ? t : "dark",
          o = ht()[a][n],
          r = Wt()[n],
          i = At()[a];
    return {
      foreground: dt({
        accent: o.foreground,
        inverse: o.inverse
      }, r.foreground),
      background: dt({
        accent: o.background
      }, r.background),
      gradient: i,
      overlay: r.overlay,
      error: "rgb(242, 90, 103)"
    };
  },

  setTheme() {
    const e = document.querySelector(":root"),
          {
      themeZIndex: t
    } = j.state;

    if (e) {
      const a = {
        "--w3m-color-fg-accent": u.color().foreground.accent,
        "--w3m-color-fg-inverse": u.color().foreground.inverse,
        "--w3m-color-fg-1": u.color().foreground[1],
        "--w3m-color-fg-2": u.color().foreground[2],
        "--w3m-color-fg-3": u.color().foreground[3],
        "--w3m-color-bg-1": u.color().background[1],
        "--w3m-color-bg-2": u.color().background[2],
        "--w3m-color-bg-3": u.color().background[3],
        "--w3m-color-overlay": u.color().overlay,
        "--w3m-color-err": u.color().error,
        "--w3m-color-success": ht().green.light.foreground,
        "--w3m-gradient-1": u.color().gradient[1],
        "--w3m-gradient-2": u.color().gradient[2],
        "--w3m-gradient-3": u.color().gradient[3],
        "--w3m-gradient-4": u.color().gradient[4],
        "--w3m-modal-z-index": `${t}`
      };
      Object.entries(a).forEach(_ref => {
        let [n, o] = _ref;
        return e.style.setProperty(n, o);
      });
    }
  },

  globalCss: y`*,::after,::before{margin:0;padding:0;box-sizing:border-box;font-style:normal;text-rendering:optimizeSpeed;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-tap-highlight-color:transparent;backface-visibility:hidden}button{cursor:pointer;display:flex;justify-content:center;align-items:center;position:relative;border:none;background-color:transparent}button::after{content:'';position:absolute;inset:0;transition:background-color,.2s ease}button:disabled{cursor:not-allowed}button svg,button w3m-text{position:relative;z-index:1}input{border:none;outline:0;appearance:none}img{display:block}::selection{color:var(--w3m-color-fg-inverse);background:var(--w3m-color-fg-accent)}`
},
      Lt = y`button{display:flex;border-radius:10px;flex-direction:column;transition:background-color .2s ease;justify-content:center;padding:5px;width:100px}button:hover{background-color:var(--w3m-color-overlay)}button>div{display:flex;justify-content:center;align-items:center;width:32px;height:32px;box-shadow:inset 0 0 0 1px var(--w3m-color-overlay);background-color:var(--w3m-color-fg-accent);border-radius:50%;margin-bottom:4px}button path{fill:var(--w3m-color-fg-inverse)}`;

var jt = Object.defineProperty,
    St = Object.getOwnPropertyDescriptor,
    ke = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? St(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && jt(t, a, o), o;
};

let te = class extends w {
  constructor() {
    super(...arguments), this.icon = void 0, this.label = "", this.onClick = () => null;
  }

  render() {
    return l`<button @click="${this.onClick}"><div>${this.icon}</div><w3m-text variant="xsmall-normal" color="accent">${this.label}</w3m-text></button>`;
  }

};
te.styles = [u.globalCss, Lt], ke([f()], te.prototype, "icon", 2), ke([f()], te.prototype, "label", 2), ke([f()], te.prototype, "onClick", 2), te = ke([b("w3m-box-button")], te);
const Pt = y`button{border-radius:28px;height:28px;padding:0 10px;background-color:var(--w3m-color-fg-accent)}button path{fill:var(--w3m-color-fg-inverse)}button::after{border-radius:inherit;border:1px solid var(--w3m-color-overlay)}button:disabled::after{background-color:transparent}.w3m-icon-left svg{margin-right:5px}.w3m-icon-right svg{margin-left:5px}button:hover::after{background-color:var(--w3m-color-overlay)}button:disabled{background-color:var(--w3m-color-bg-3)}`;

var _t = Object.defineProperty,
    Dt = Object.getOwnPropertyDescriptor,
    le = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Dt(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && _t(t, a, o), o;
};

let G = class extends w {
  constructor() {
    super(...arguments), this.disabled = !1, this.iconLeft = void 0, this.iconRight = void 0, this.onClick = () => null;
  }

  render() {
    const e = {
      "w3m-icon-left": this.iconLeft !== void 0,
      "w3m-icon-right": this.iconRight !== void 0
    };
    return l`<button class="${T(e)}" ?disabled="${this.disabled}" @click="${this.onClick}">${this.iconLeft}<w3m-text variant="small-normal" color="inverse"><slot></slot></w3m-text>${this.iconRight}</button>`;
  }

};
G.styles = [u.globalCss, Pt], le([f()], G.prototype, "disabled", 2), le([f()], G.prototype, "iconLeft", 2), le([f()], G.prototype, "iconRight", 2), le([f()], G.prototype, "onClick", 2), G = le([b("w3m-button")], G);
const Tt = y`:host{display:inline-block}button{padding:0 15px 1px;height:40px;border-radius:10px;color:var(--w3m-color-fg-inverse);background-color:var(--w3m-color-fg-accent)}button::after{content:'';inset:0;position:absolute;background-color:transparent;border-radius:inherit;transition:background-color .2s ease;border:1px solid var(--w3m-color-overlay)}button:hover::after{background-color:var(--w3m-color-overlay)}button:disabled{padding-bottom:0;background-color:var(--w3m-color-bg-3);color:var(--w3m-color-fg-3)}.w3m-secondary{color:var(--w3m-color-fg-accent);background-color:transparent}.w3m-secondary::after{display:none}`;

var Nt = Object.defineProperty,
    Rt = Object.getOwnPropertyDescriptor,
    Te = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Rt(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Nt(t, a, o), o;
};

let se = class extends w {
  constructor() {
    super(...arguments), this.disabled = !1, this.variant = "primary";
  }

  render() {
    const e = {
      "w3m-secondary": this.variant === "secondary"
    };
    return l`<button ?disabled="${this.disabled}" class="${T(e)}"><slot></slot></button>`;
  }

};
se.styles = [u.globalCss, Tt], Te([f()], se.prototype, "disabled", 2), Te([f()], se.prototype, "variant", 2), se = Te([b("w3m-button-big")], se);
let Bt = class {
  constructor() {
    this.angle = 0, this.t = 1253106, this.last = 0, this.height = 500, this.amp = 300, this.seed = 15, this.freqX = 14e-5, this.freqY = 29e-5, this.freqDelta = 1e-5, this.activeColors = [1, 1, 1, 1], this.isMetaKey = !1, this.playing = !1, mt(this, "resize", () => {
      this.width = window.innerWidth, this.minigl.setSize(this.width, this.height), this.minigl.setOrthographicCamera(), this.xSegCount = Math.ceil(this.width * this.conf.density[0]), this.ySegCount = Math.ceil(this.height * this.conf.density[1]), this.mesh.geometry.setTopology(this.xSegCount, this.ySegCount), this.mesh.geometry.setSize(this.width, this.height), this.mesh.material.uniforms.u_shadow_power.value = this.width < 550 ? 5 : 6;
    }), mt(this, "animate", a => {
      if (this.playing) {
        if (this.shouldSkipFrame(a) || (this.t += Math.min(a - this.last, 1e3 / 15), this.last = a, this.mesh.material.uniforms.u_time.value = this.t, this.minigl.render()), this.last !== 0 && this.isStatic) return this.minigl.render();
        requestAnimationFrame(this.animate);
      }
    });
  }

  play(t) {
    this.el = t, this.connect();
  }

  stop() {
    this.playing = !1;
  }

  async connect() {
    this.shaderFiles = {
      vertex: "varying vec3 v_color;void main(){float time=u_time*u_global.noiseSpeed;vec2 noiseCoord=resolution*uvNorm*u_global.noiseFreq;vec2 st=1.-uvNorm.xy;float tilt=resolution.y/2.0*uvNorm.y;float incline=resolution.x*uvNorm.x/2.0*u_vertDeform.incline;float offset=resolution.x/2.0*u_vertDeform.incline*mix(u_vertDeform.offsetBottom,u_vertDeform.offsetTop,uv.y);float noise=snoise(vec3(noiseCoord.x*u_vertDeform.noiseFreq.x+time*u_vertDeform.noiseFlow,noiseCoord.y*u_vertDeform.noiseFreq.y,time*u_vertDeform.noiseSpeed+u_vertDeform.noiseSeed))*u_vertDeform.noiseAmp;noise*=1.0-pow(abs(uvNorm.y),2.0);noise=max(0.0,noise);vec3 pos=vec3(position.x,position.y+tilt+incline+noise-offset,position.z);if(u_active_colors[0]==1.){v_color=u_baseColor;}for(int i=0;i<u_waveLayers_length;i++){if(u_active_colors[i+1]==1.){WaveLayers layer=u_waveLayers[i];float noise=smoothstep(layer.noiseFloor,layer.noiseCeil,snoise(vec3(noiseCoord.x*layer.noiseFreq.x+time*layer.noiseFlow,noiseCoord.y*layer.noiseFreq.y,time*layer.noiseSpeed+layer.noiseSeed))/2.0+0.5);v_color=blendNormal(v_color,layer.color,pow(noise,4.));}}gl_Position=projectionMatrix*modelViewMatrix*vec4(pos,1.0);}",
      noise: `
// MIT License: Copyright (C) 2011 Ashima Arts. All rights reserved. https://github.com/ashima/webgl-noise, https://github.com/stegu/webgl-noise
vec3 mod289(vec3 x){return x-floor(x*(1.0/289.0))*289.0;}vec4 mod289(vec4 x){return x-floor(x*(1.0/289.0))*289.0;}vec4 permute(vec4 x){return mod289(((x*34.0)+1.0)*x);}vec4 taylorInvSqrt(vec4 r){return 1.79284291400159-0.85373472095314*r;}float snoise(vec3 v){const vec2 C=vec2(1.0/6.0,1.0/3.0);const vec4 D=vec4(0.0,0.5,1.0,2.0);vec3 i=floor(v+dot(v,C.yyy));vec3 x0=v-i+dot(i,C.xxx);vec3 g=step(x0.yzx,x0.xyz);vec3 l=1.0-g;vec3 i1=min(g.xyz,l.zxy);vec3 i2=max(g.xyz,l.zxy);vec3 x1=x0-i1+C.xxx;vec3 x2=x0-i2+C.yyy;vec3 x3=x0-D.yyy;i=mod289(i);vec4 p=permute(permute(permute(i.z+vec4(0.0,i1.z,i2.z,1.0))+i.y+vec4(0.0,i1.y,i2.y,1.0))+i.x+vec4(0.0,i1.x,i2.x,1.0));float n_=0.142857142857;vec3 ns=n_*D.wyz-D.xzx;vec4 j=p-49.0*floor(p*ns.z*ns.z);vec4 x_=floor(j*ns.z);vec4 y_=floor(j-7.0*x_);vec4 x=x_*ns.x+ns.yyyy;vec4 y=y_*ns.x+ns.yyyy;vec4 h=1.0-abs(x)-abs(y);vec4 b0=vec4(x.xy,y.xy);vec4 b1=vec4(x.zw,y.zw);vec4 s0=floor(b0)*2.0+1.0;vec4 s1=floor(b1)*2.0+1.0;vec4 sh=-step(h,vec4(0.0));vec4 a0=b0.xzyw+s0.xzyw*sh.xxyy;vec4 a1=b1.xzyw+s1.xzyw*sh.zzww;vec3 p0=vec3(a0.xy,h.x);vec3 p1=vec3(a0.zw,h.y);vec3 p2=vec3(a1.xy,h.z);vec3 p3=vec3(a1.zw,h.w);vec4 norm=taylorInvSqrt(vec4(dot(p0,p0),dot(p1,p1),dot(p2,p2),dot(p3,p3)));p0*=norm.x;p1*=norm.y;p2*=norm.z;p3*=norm.w;vec4 m=max(0.6-vec4(dot(x0,x0),dot(x1,x1),dot(x2,x2),dot(x3,x3)),0.0);m=m*m;return 42.0*dot(m*m,vec4(dot(p0,x0),dot(p1,x1),dot(p2,x2),dot(p3,x3)));}`,
      blend: `
// MIT Licence: Copyright (C) 2015 Jamie Owen. All rights reserved. https://github.com/jamieowen/glsl-blend
vec3 blendNormal(vec3 base, vec3 blend){return blend;}vec3 blendNormal(vec3 base,vec3 blend,float opacity){return (blendNormal(base,blend)*opacity+base*(1.0-opacity));}float blendScreen(float base,float blend){return 1.0-((1.0-base)*(1.0-blend));}vec3 blendScreen(vec3 base,vec3 blend){return vec3(blendScreen(base.r,blend.r),blendScreen(base.g,blend.g),blendScreen(base.b,blend.b));}vec3 blendScreen(vec3 base,vec3 blend,float opacity){return (blendScreen(base, blend)*opacity+base*(1.0-opacity));}vec3 blendMultiply(vec3 base,vec3 blend){return base*blend;}vec3 blendMultiply(vec3 base,vec3 blend,float opacity){return (blendMultiply(base,blend)*opacity+base*(1.0-opacity));}float blendOverlay(float base,float blend){return base<0.5?(2.0*base*blend):(1.0-2.0*(1.0-base)*(1.0-blend));}vec3 blendOverlay(vec3 base,vec3 blend){return vec3(blendOverlay(base.r,blend.r),blendOverlay(base.g,blend.g),blendOverlay(base.b,blend.b));}vec3 blendOverlay(vec3 base,vec3 blend,float opacity){return (blendOverlay(base,blend)*opacity+base*(1.0-opacity));}vec3 blendHardLight(vec3 base,vec3 blend){return blendOverlay(blend,base);}vec3 blendHardLight(vec3 base,vec3 blend,float opacity){return (blendHardLight(base,blend)*opacity+base*(1.0-opacity));}float blendSoftLight(float base,float blend){return (blend<0.5)?(2.0*base*blend+base*base*(1.0-2.0*blend)):(sqrt(base)*(2.0*blend-1.0)+2.0*base*(1.0-blend));}vec3 blendSoftLight(vec3 base,vec3 blend){return vec3(blendSoftLight(base.r,blend.r),blendSoftLight(base.g,blend.g),blendSoftLight(base.b,blend.b));}vec3 blendSoftLight(vec3 base,vec3 blend,float opacity){return (blendSoftLight(base,blend)*opacity+base*(1.0-opacity));}float blendColorDodge(float base,float blend){return (blend==1.0)?blend:min(base/(1.0-blend),1.0);}vec3 blendColorDodge(vec3 base,vec3 blend){return vec3(blendColorDodge(base.r,blend.r),blendColorDodge(base.g,blend.g),blendColorDodge(base.b,blend.b));}vec3 blendColorDodge(vec3 base,vec3 blend,float opacity){return (blendColorDodge(base, blend)*opacity+base*(1.0-opacity));}float blendColorBurn(float base,float blend){return (blend==0.0)?blend:max((1.0-((1.0-base)/blend)),0.0);}vec3 blendColorBurn(vec3 base,vec3 blend){return vec3(blendColorBurn(base.r,blend.r),blendColorBurn(base.g,blend.g),blendColorBurn(base.b,blend.b));}vec3 blendColorBurn(vec3 base,vec3 blend,float opacity){return (blendColorBurn(base, blend)*opacity+base*(1.0-opacity));}float blendVividLight(float base,float blend){return (blend<0.5)?blendColorBurn(base,(2.0*blend)):blendColorDodge(base,(2.0*(blend-0.5)));}vec3 blendVividLight(vec3 base,vec3 blend){return vec3(blendVividLight(base.r,blend.r),blendVividLight(base.g,blend.g),blendVividLight(base.b,blend.b));}vec3 blendVividLight(vec3 base,vec3 blend,float opacity){return (blendVividLight(base,blend)*opacity+base*(1.0-opacity));}float blendLighten(float base,float blend){return max(blend,base);}vec3 blendLighten(vec3 base,vec3 blend){return vec3(blendLighten(base.r,blend.r),blendLighten(base.g,blend.g),blendLighten(base.b,blend.b));}vec3 blendLighten(vec3 base,vec3 blend,float opacity){return (blendLighten(base,blend)*opacity+base*(1.0-opacity));}float blendLinearBurn(float base,float blend){return max(base+blend-1.0,0.0);}vec3 blendLinearBurn(vec3 base,vec3 blend){return max(base+blend-vec3(1.0),vec3(0.0));}vec3 blendLinearBurn(vec3 base,vec3 blend,float opacity){return (blendLinearBurn(base, blend)*opacity+base*(1.0-opacity));}float blendLinearDodge(float base,float blend){return min(base+blend,1.0);}vec3 blendLinearDodge(vec3 base,vec3 blend){return min(base+blend,vec3(1.0));}vec3 blendLinearDodge(vec3 base,vec3 blend,float opacity){return (blendLinearDodge(base,blend)*opacity+base*(1.0-opacity));}float blendLinearLight(float base,float blend){return blend<0.5?blendLinearBurn(base,(2.0*blend)):blendLinearDodge(base,(2.0*(blend-0.5)));}vec3 blendLinearLight(vec3 base,vec3 blend){return vec3(blendLinearLight(base.r,blend.r),blendLinearLight(base.g,blend.g),blendLinearLight(base.b,blend.b));}vec3 blendLinearLight(vec3 base,vec3 blend,float opacity){return (blendLinearLight(base,blend)*opacity+base*(1.0-opacity));}`,
      fragment: "varying vec3 v_color;void main(){vec3 color=v_color;if(u_darken_top==1.0){vec2 st=gl_FragCoord.xy/resolution.xy;color.g-=pow(st.y+sin(-12.0)*st.x,u_shadow_power)*0.4;}gl_FragColor=vec4(color,1.0);}"
    }, this.conf = {
      density: [.06, .16]
    }, this.minigl = new Ht(this.el, null, null, !0), requestAnimationFrame(() => {
      this.el && (this.computedCanvasStyle = getComputedStyle(this.el), this.waitForCssVars());
    });
  }

  initMaterial() {
    this.uniforms = {
      u_time: new this.minigl.Uniform({
        value: 0
      }),
      u_shadow_power: new this.minigl.Uniform({
        value: 5
      }),
      u_darken_top: new this.minigl.Uniform({
        value: this.el.dataset.jsDarkenTop === "" ? 1 : 0
      }),
      u_active_colors: new this.minigl.Uniform({
        value: this.activeColors,
        type: "vec4"
      }),
      u_global: new this.minigl.Uniform({
        value: {
          noiseFreq: new this.minigl.Uniform({
            value: [this.freqX, this.freqY],
            type: "vec2"
          }),
          noiseSpeed: new this.minigl.Uniform({
            value: 5e-6
          })
        },
        type: "struct"
      }),
      u_vertDeform: new this.minigl.Uniform({
        value: {
          incline: new this.minigl.Uniform({
            value: Math.sin(this.angle) / Math.cos(this.angle)
          }),
          offsetTop: new this.minigl.Uniform({
            value: -.5
          }),
          offsetBottom: new this.minigl.Uniform({
            value: -.5
          }),
          noiseFreq: new this.minigl.Uniform({
            value: [3, 4],
            type: "vec2"
          }),
          noiseAmp: new this.minigl.Uniform({
            value: this.amp
          }),
          noiseSpeed: new this.minigl.Uniform({
            value: 10
          }),
          noiseFlow: new this.minigl.Uniform({
            value: 3
          }),
          noiseSeed: new this.minigl.Uniform({
            value: this.seed
          })
        },
        type: "struct",
        excludeFrom: "fragment"
      }),
      u_baseColor: new this.minigl.Uniform({
        value: this.sectionColors[0],
        type: "vec3",
        excludeFrom: "fragment"
      }),
      u_waveLayers: new this.minigl.Uniform({
        value: [],
        excludeFrom: "fragment",
        type: "array"
      })
    };

    for (let t = 1; t < this.sectionColors.length; t += 1) this.uniforms.u_waveLayers.value.push(new this.minigl.Uniform({
      value: {
        color: new this.minigl.Uniform({
          value: this.sectionColors[t],
          type: "vec3"
        }),
        noiseFreq: new this.minigl.Uniform({
          value: [2 + t / this.sectionColors.length, 3 + t / this.sectionColors.length],
          type: "vec2"
        }),
        noiseSpeed: new this.minigl.Uniform({
          value: 11 + .3 * t
        }),
        noiseFlow: new this.minigl.Uniform({
          value: 6.5 + .3 * t
        }),
        noiseSeed: new this.minigl.Uniform({
          value: this.seed + 10 * t
        }),
        noiseFloor: new this.minigl.Uniform({
          value: .1
        }),
        noiseCeil: new this.minigl.Uniform({
          value: .63 + .07 * t
        })
      },
      type: "struct"
    }));

    return this.vertexShader = [this.shaderFiles.noise, this.shaderFiles.blend, this.shaderFiles.vertex].join(""), new this.minigl.Material(this.vertexShader, this.shaderFiles.fragment, this.uniforms);
  }

  initMesh() {
    this.material = this.initMaterial(), this.geometry = new this.minigl.PlaneGeometry(), this.mesh = new this.minigl.Mesh(this.geometry, this.material);
  }

  shouldSkipFrame(t) {
    return !!window.document.hidden || parseInt(t, 10) % 2 == 0 || void 0;
  }

  updateFrequency(t) {
    this.freqX += t, this.freqY += t;
  }

  toggleColor(t) {
    this.activeColors[t] = this.activeColors[t] === 0 ? 1 : 0;
  }

  init() {
    this.playing = !0, this.initGradientColors(), this.initMesh(), this.resize(), requestAnimationFrame(this.animate);
  }

  waitForCssVars() {
    this.computedCanvasStyle && this.computedCanvasStyle.getPropertyValue("--w3m-gradient-1").indexOf("#") !== -1 ? this.init() : this.init();
  }

  initGradientColors() {
    this.sectionColors = ["--w3m-gradient-1", "--w3m-gradient-2", "--w3m-gradient-3", "--w3m-gradient-4"].map(t => {
      let a = this.computedCanvasStyle.getPropertyValue(t).trim();
      return a.length === 4 && (a = `#${a.substr(1).split("").map(n => n + n).join("")}`), a && `0x${a.substr(1)}`;
    }).filter(Boolean).map(Ut);
  }

};

function Ut(e) {
  return [(e >> 16 & 255) / 255, (e >> 8 & 255) / 255, (255 & e) / 255];
}

function mt(e, t, a) {
  return t in e ? Object.defineProperty(e, t, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = a, e;
}

let Ht = class {
  constructor(t, a, n) {
    const o = this;
    o.canvas = t, o.gl = o.canvas.getContext("webgl", {
      antialias: !0
    }), o.meshes = [];
    const r = o.gl;
    a && n && this.setSize(a, n), Object.defineProperties(o, {
      Material: {
        enumerable: !1,
        value: class {
          constructor(c, m) {
            let s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            const d = this;

            function v(N, E) {
              const x = r.createShader(N);
              return r.shaderSource(x, E), r.compileShader(x), r.getShaderParameter(x, r.COMPILE_STATUS) || console.error(r.getShaderInfoLog(x)), x;
            }

            function O(N, E) {
              return Object.entries(N).map(_ref2 => {
                let [x, A] = _ref2;
                return A.getDeclaration(x, E);
              }).join("");
            }

            d.uniforms = s, d.uniformInstances = [];
            const C = "precision highp float;";
            d.vertexSource = `${C} attribute vec4 position;attribute vec2 uv;attribute vec2 uvNorm;${O(o.commonUniforms, "vertex")} ${O(s, "vertex")} ${c}`, d.Source = `${C} ${O(o.commonUniforms, "fragment")} ${O(s, "fragment")} ${m} `, d.vertexShader = v(r.VERTEX_SHADER, d.vertexSource), d.fragmentShader = v(r.FRAGMENT_SHADER, d.Source), d.program = r.createProgram(), r.attachShader(d.program, d.vertexShader), r.attachShader(d.program, d.fragmentShader), r.linkProgram(d.program), r.getProgramParameter(d.program, r.LINK_STATUS) || console.error(r.getProgramInfoLog(d.program)), r.useProgram(d.program), d.attachUniforms(void 0, o.commonUniforms), d.attachUniforms(void 0, d.uniforms);
          }

          attachUniforms(c, m) {
            const s = this;
            c === void 0 ? Object.entries(m).forEach(_ref3 => {
              let [d, v] = _ref3;
              s.attachUniforms(d, v);
            }) : m.type == "array" ? m.value.forEach((d, v) => s.attachUniforms(`${c}[${v}]`, d)) : m.type == "struct" ? Object.entries(m.value).forEach(_ref4 => {
              let [d, v] = _ref4;
              return s.attachUniforms(`${c}.${d}`, v);
            }) : s.uniformInstances.push({
              uniform: m,
              location: r.getUniformLocation(s.program, c)
            });
          }

        }
      },
      Uniform: {
        enumerable: !1,
        value: class {
          constructor(c) {
            this.type = "float", Object.assign(this, c), this.typeFn = {
              float: "1f",
              int: "1i",
              vec2: "2fv",
              vec3: "3fv",
              vec4: "4fv",
              mat4: "Matrix4fv"
            }[this.type] || "1f", this.update();
          }

          update(c) {
            this.value !== void 0 && r[`uniform${this.typeFn}`](c, this.typeFn.indexOf("Matrix") === 0 ? this.transpose : this.value, this.typeFn.indexOf("Matrix") === 0 ? this.value : null);
          }

          getDeclaration(c, m, s) {
            const d = this;

            if (d.excludeFrom !== m) {
              if (d.type === "array") return d.value[0].getDeclaration(c, m, d.value.length) + `const int ${c}_length=${d.value.length};`;

              if (d.type === "struct") {
                let v = c.replace("u_", "");
                return v = v.charAt(0).toUpperCase() + v.slice(1), `uniform struct ${v} {` + Object.entries(d.value).map(_ref5 => {
                  let [O, C] = _ref5;
                  return C.getDeclaration(O, m).replace(/^uniform/, "");
                }).join("") + `} ${c}${s > 0 ? `[${s}]` : ""};`;
              }

              return `uniform ${d.type} ${c}${s > 0 ? `[${s}]` : ""};`;
            }
          }

        }
      },
      PlaneGeometry: {
        enumerable: !1,
        value: class {
          constructor(c, m, s, d, v) {
            r.createBuffer(), this.attributes = {
              position: new o.Attribute({
                target: r.ARRAY_BUFFER,
                size: 3
              }),
              uv: new o.Attribute({
                target: r.ARRAY_BUFFER,
                size: 2
              }),
              uvNorm: new o.Attribute({
                target: r.ARRAY_BUFFER,
                size: 2
              }),
              index: new o.Attribute({
                target: r.ELEMENT_ARRAY_BUFFER,
                size: 3,
                type: r.UNSIGNED_SHORT
              })
            }, this.setTopology(s, d), this.setSize(c, m, v);
          }

          setTopology() {
            let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            let m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            const s = this;
            s.xSegCount = c, s.ySegCount = m, s.vertexCount = (s.xSegCount + 1) * (s.ySegCount + 1), s.quadCount = s.xSegCount * s.ySegCount * 2, s.attributes.uv.values = new Float32Array(2 * s.vertexCount), s.attributes.uvNorm.values = new Float32Array(2 * s.vertexCount), s.attributes.index.values = new Uint16Array(3 * s.quadCount);

            for (let d = 0; d <= s.ySegCount; d++) for (let v = 0; v <= s.xSegCount; v++) {
              const O = d * (s.xSegCount + 1) + v;

              if (s.attributes.uv.values[2 * O] = v / s.xSegCount, s.attributes.uv.values[2 * O + 1] = 1 - d / s.ySegCount, s.attributes.uvNorm.values[2 * O] = v / s.xSegCount * 2 - 1, s.attributes.uvNorm.values[2 * O + 1] = 1 - d / s.ySegCount * 2, v < s.xSegCount && d < s.ySegCount) {
                const C = d * s.xSegCount + v;
                s.attributes.index.values[6 * C] = O, s.attributes.index.values[6 * C + 1] = O + 1 + s.xSegCount, s.attributes.index.values[6 * C + 2] = O + 1, s.attributes.index.values[6 * C + 3] = O + 1, s.attributes.index.values[6 * C + 4] = O + 1 + s.xSegCount, s.attributes.index.values[6 * C + 5] = O + 2 + s.xSegCount;
              }
            }

            s.attributes.uv.update(), s.attributes.uvNorm.update(), s.attributes.index.update();
          }

          setSize() {
            let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            let m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            let s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "xz";
            const d = this;
            d.width = c, d.height = m, d.orientation = s, d.attributes.position.values && d.attributes.position.values.length === 3 * d.vertexCount || (d.attributes.position.values = new Float32Array(3 * d.vertexCount));
            const v = c / -2,
                  O = m / -2,
                  C = c / d.xSegCount,
                  N = m / d.ySegCount;

            for (let E = 0; E <= d.ySegCount; E++) {
              const x = O + E * N;

              for (let A = 0; A <= d.xSegCount; A++) {
                const M = v + A * C,
                      P = E * (d.xSegCount + 1) + A;
                d.attributes.position.values[3 * P + "xyz".indexOf(s[0])] = M, d.attributes.position.values[3 * P + "xyz".indexOf(s[1])] = -x;
              }
            }

            d.attributes.position.update();
          }

        }
      },
      Mesh: {
        enumerable: !1,
        value: class {
          constructor(c, m) {
            const s = this;
            s.geometry = c, s.material = m, s.attributeInstances = [], Object.entries(s.geometry.attributes).forEach(_ref6 => {
              let [d, v] = _ref6;
              s.attributeInstances.push({
                attribute: v,
                location: v.attach(d, s.material.program)
              });
            }), o.meshes.push(s);
          }

          draw() {
            r.useProgram(this.material.program), this.material.uniformInstances.forEach(_ref7 => {
              let {
                uniform: c,
                location: m
              } = _ref7;
              return c.update(m);
            }), this.attributeInstances.forEach(_ref8 => {
              let {
                attribute: c,
                location: m
              } = _ref8;
              return c.use(m);
            }), r.drawElements(r.TRIANGLES, this.geometry.attributes.index.values.length, r.UNSIGNED_SHORT, 0);
          }

          remove() {
            o.meshes = o.meshes.filter(c => c != this);
          }

        }
      },
      Attribute: {
        enumerable: !1,
        value: class {
          constructor(c) {
            this.type = r.FLOAT, this.normalized = !1, this.buffer = r.createBuffer(), Object.assign(this, c), this.update();
          }

          update() {
            this.values !== void 0 && (r.bindBuffer(this.target, this.buffer), r.bufferData(this.target, this.values, r.STATIC_DRAW));
          }

          attach(c, m) {
            const s = r.getAttribLocation(m, c);
            return this.target === r.ARRAY_BUFFER && (r.enableVertexAttribArray(s), r.vertexAttribPointer(s, this.size, this.type, this.normalized, 0, 0)), s;
          }

          use(c) {
            r.bindBuffer(this.target, this.buffer), this.target === r.ARRAY_BUFFER && (r.enableVertexAttribArray(c), r.vertexAttribPointer(c, this.size, this.type, this.normalized, 0, 0));
          }

        }
      }
    });
    const i = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
    o.commonUniforms = {
      projectionMatrix: new o.Uniform({
        type: "mat4",
        value: i
      }),
      modelViewMatrix: new o.Uniform({
        type: "mat4",
        value: i
      }),
      resolution: new o.Uniform({
        type: "vec2",
        value: [1, 1]
      }),
      aspectRatio: new o.Uniform({
        type: "float",
        value: 1
      })
    };
  }

  setSize() {
    let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 640;
    let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 480;
    this.width = t, this.height = a, this.canvas.width = t, this.canvas.height = a, this.gl.viewport(0, 0, t, a), this.commonUniforms.resolution.value = [t, a], this.commonUniforms.aspectRatio.value = t / a;
  }

  setOrthographicCamera() {
    let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    let o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -2e3;
    let r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2e3;
    this.commonUniforms.projectionMatrix.value = [2 / this.width, 0, 0, 0, 0, 2 / this.height, 0, 0, 0, 0, 2 / (o - r), 0, t, a, n, 1];
  }

  render() {
    this.gl.clearColor(0, 0, 0, 0), this.gl.clearDepth(1), this.meshes.forEach(t => t.draw());
  }

};
const g = {
  CROSS_ICON: k`<svg width="12" height="12" viewBox="0 0 12 12"><path d="M9.94 11A.75.75 0 1 0 11 9.94L7.414 6.353a.5.5 0 0 1 0-.708L11 2.061A.75.75 0 1 0 9.94 1L6.353 4.586a.5.5 0 0 1-.708 0L2.061 1A.75.75 0 0 0 1 2.06l3.586 3.586a.5.5 0 0 1 0 .708L1 9.939A.75.75 0 1 0 2.06 11l3.586-3.586a.5.5 0 0 1 .708 0L9.939 11Z" fill="#fff"/></svg>`,
  NOISE_TEXTURE: k`<svg id="w3m-transparent-noise"><filter id="w3m-noise"><feTurbulence type="fractalNoise" baseFrequency="0.8"/></filter><rect width="100%" height="100%" filter="url(#w3m-noise)"/></svg>`,
  WALLET_CONNECT_LOGO: k`<svg width="178" height="29" viewBox="0 0 178 29" id="w3m-wc-logo"><path d="M10.683 7.926c5.284-5.17 13.85-5.17 19.134 0l.636.623a.652.652 0 0 1 0 .936l-2.176 2.129a.343.343 0 0 1-.478 0l-.875-.857c-3.686-3.607-9.662-3.607-13.348 0l-.937.918a.343.343 0 0 1-.479 0l-2.175-2.13a.652.652 0 0 1 0-.936l.698-.683Zm23.633 4.403 1.935 1.895a.652.652 0 0 1 0 .936l-8.73 8.543a.687.687 0 0 1-.956 0L20.37 17.64a.172.172 0 0 0-.239 0l-6.195 6.063a.687.687 0 0 1-.957 0l-8.73-8.543a.652.652 0 0 1 0-.936l1.936-1.895a.687.687 0 0 1 .957 0l6.196 6.064a.172.172 0 0 0 .239 0l6.195-6.064a.687.687 0 0 1 .957 0l6.196 6.064a.172.172 0 0 0 .24 0l6.195-6.064a.687.687 0 0 1 .956 0ZM48.093 20.948l2.338-9.355c.139-.515.258-1.07.416-1.942.12.872.258 1.427.357 1.942l2.022 9.355h4.181l3.528-13.874h-3.21l-1.943 8.523a24.825 24.825 0 0 0-.456 2.457c-.158-.931-.317-1.625-.495-2.438l-1.883-8.542h-4.201l-2.042 8.542a41.204 41.204 0 0 0-.475 2.438 41.208 41.208 0 0 0-.476-2.438l-1.903-8.542h-3.349l3.508 13.874h4.083ZM63.33 21.304c1.585 0 2.596-.654 3.11-1.605-.059.297-.078.595-.078.892v.357h2.655V15.22c0-2.735-1.248-4.32-4.3-4.32-2.636 0-4.36 1.466-4.52 3.487h2.914c.1-.891.734-1.426 1.705-1.426.911 0 1.407.515 1.407 1.11 0 .435-.258.693-1.03.792l-1.388.159c-2.061.257-3.825 1.01-3.825 3.19 0 1.982 1.645 3.092 3.35 3.092Zm.891-2.041c-.773 0-1.348-.436-1.348-1.19 0-.733.655-1.09 1.645-1.268l.674-.119c.575-.118.892-.218 1.09-.396v.912c0 1.228-.892 2.06-2.06 2.06ZM70.398 7.074v13.874h2.874V7.074h-2.874ZM74.934 7.074v13.874h2.874V7.074h-2.874ZM84.08 21.304c2.735 0 4.5-1.546 4.697-3.567h-2.893c-.139.892-.892 1.387-1.804 1.387-1.228 0-2.12-.99-2.14-2.358h6.897v-.555c0-3.21-1.764-5.312-4.816-5.312-2.933 0-4.994 2.062-4.994 5.173 0 3.37 2.12 5.232 5.053 5.232Zm-2.16-6.421c.119-1.11.932-1.922 2.081-1.922 1.11 0 1.883.772 1.903 1.922H81.92ZM94.92 21.146c.633 0 1.248-.1 1.525-.179v-2.18c-.218.04-.475.06-.693.06-1.05 0-1.427-.595-1.427-1.566v-3.805h2.338v-2.24h-2.338V7.788H91.47v3.448H89.37v2.24h2.1v4.201c0 2.3 1.15 3.469 3.45 3.469ZM104.62 21.304c3.924 0 6.302-2.299 6.599-5.608h-3.111c-.238 1.803-1.506 3.032-3.369 3.032-2.2 0-3.746-1.784-3.746-4.796 0-2.953 1.605-4.638 3.805-4.638 1.883 0 2.953 1.15 3.171 2.834h3.191c-.317-3.448-2.854-5.41-6.342-5.41-3.984 0-7.036 2.695-7.036 7.214 0 4.677 2.676 7.372 6.838 7.372ZM117.449 21.304c2.993 0 5.114-1.882 5.114-5.172 0-3.23-2.121-5.233-5.114-5.233-2.972 0-5.093 2.002-5.093 5.233 0 3.29 2.101 5.172 5.093 5.172Zm0-2.22c-1.327 0-2.18-1.09-2.18-2.952 0-1.903.892-2.973 2.18-2.973 1.308 0 2.2 1.07 2.2 2.973 0 1.862-.872 2.953-2.2 2.953ZM126.569 20.948v-5.689c0-1.208.753-2.1 1.823-2.1 1.011 0 1.606.773 1.606 2.06v5.729h2.873v-6.144c0-2.339-1.229-3.905-3.428-3.905-1.526 0-2.458.734-2.953 1.606a5.31 5.31 0 0 0 .079-.892v-.377h-2.874v9.712h2.874ZM137.464 20.948v-5.689c0-1.208.753-2.1 1.823-2.1 1.011 0 1.606.773 1.606 2.06v5.729h2.873v-6.144c0-2.339-1.228-3.905-3.428-3.905-1.526 0-2.458.734-2.953 1.606a5.31 5.31 0 0 0 .079-.892v-.377h-2.874v9.712h2.874ZM149.949 21.304c2.735 0 4.499-1.546 4.697-3.567h-2.893c-.139.892-.892 1.387-1.804 1.387-1.228 0-2.12-.99-2.14-2.358h6.897v-.555c0-3.21-1.764-5.312-4.816-5.312-2.933 0-4.994 2.062-4.994 5.173 0 3.37 2.12 5.232 5.053 5.232Zm-2.16-6.421c.119-1.11.932-1.922 2.081-1.922 1.11 0 1.883.772 1.903 1.922h-3.984ZM160.876 21.304c3.013 0 4.658-1.645 4.975-4.201h-2.874c-.099 1.07-.713 1.982-2.001 1.982-1.309 0-2.2-1.21-2.2-2.993 0-1.942 1.03-2.933 2.259-2.933 1.209 0 1.803.872 1.883 1.882h2.873c-.218-2.358-1.823-4.142-4.776-4.142-2.874 0-5.153 1.903-5.153 5.193 0 3.25 1.923 5.212 5.014 5.212ZM172.067 21.146c.634 0 1.248-.1 1.526-.179v-2.18c-.218.04-.476.06-.694.06-1.05 0-1.427-.595-1.427-1.566v-3.805h2.339v-2.24h-2.339V7.788h-2.854v3.448h-2.1v2.24h2.1v4.201c0 2.3 1.15 3.469 3.449 3.469Z" fill="#fff"/></svg>`,
  WALLET_CONNECT_ICON: k`<svg width="28" height="20" viewBox="0 0 28 20"><g clip-path="url(#a)"><path d="M7.386 6.482c3.653-3.576 9.575-3.576 13.228 0l.44.43a.451.451 0 0 1 0 .648L19.55 9.033a.237.237 0 0 1-.33 0l-.606-.592c-2.548-2.496-6.68-2.496-9.228 0l-.648.634a.237.237 0 0 1-.33 0L6.902 7.602a.451.451 0 0 1 0-.647l.483-.473Zm16.338 3.046 1.339 1.31a.451.451 0 0 1 0 .648l-6.035 5.909a.475.475 0 0 1-.662 0L14.083 13.2a.119.119 0 0 0-.166 0l-4.283 4.194a.475.475 0 0 1-.662 0l-6.035-5.91a.451.451 0 0 1 0-.647l1.338-1.31a.475.475 0 0 1 .662 0l4.283 4.194c.046.044.12.044.166 0l4.283-4.194a.475.475 0 0 1 .662 0l4.283 4.194c.046.044.12.044.166 0l4.283-4.194a.475.475 0 0 1 .662 0Z" fill="#000000"/></g><defs><clipPath id="a"><path fill="#ffffff" d="M0 0h28v20H0z"/></clipPath></defs></svg>`,
  WALLET_CONNECT_ICON_COLORED: k`<svg width="96" height="96" fill="none"><path fill="#fff" d="M25.322 33.597c12.525-12.263 32.83-12.263 45.355 0l1.507 1.476a1.547 1.547 0 0 1 0 2.22l-5.156 5.048a.814.814 0 0 1-1.134 0l-2.074-2.03c-8.737-8.555-22.903-8.555-31.64 0l-2.222 2.175a.814.814 0 0 1-1.134 0l-5.156-5.049a1.547 1.547 0 0 1 0-2.22l1.654-1.62Zm56.019 10.44 4.589 4.494a1.547 1.547 0 0 1 0 2.22l-20.693 20.26a1.628 1.628 0 0 1-2.267 0L48.283 56.632a.407.407 0 0 0-.567 0L33.03 71.012a1.628 1.628 0 0 1-2.268 0L10.07 50.75a1.547 1.547 0 0 1 0-2.22l4.59-4.494a1.628 1.628 0 0 1 2.267 0l14.687 14.38c.156.153.41.153.567 0l14.685-14.38a1.628 1.628 0 0 1 2.268 0l14.687 14.38c.156.153.41.153.567 0l14.686-14.38a1.628 1.628 0 0 1 2.268 0Z"/><path stroke="#000" d="M25.672 33.954c12.33-12.072 32.325-12.072 44.655 0l1.508 1.476a1.047 1.047 0 0 1 0 1.506l-5.157 5.048a.314.314 0 0 1-.434 0l-2.074-2.03c-8.932-8.746-23.409-8.746-32.34 0l-2.222 2.174a.314.314 0 0 1-.434 0l-5.157-5.048a1.047 1.047 0 0 1 0-1.506l1.655-1.62Zm55.319 10.44 4.59 4.494a1.047 1.047 0 0 1 0 1.506l-20.694 20.26a1.128 1.128 0 0 1-1.568 0l-14.686-14.38a.907.907 0 0 0-1.267 0L32.68 70.655a1.128 1.128 0 0 1-1.568 0L10.42 50.394a1.047 1.047 0 0 1 0-1.506l4.59-4.493a1.128 1.128 0 0 1 1.567 0l14.687 14.379a.907.907 0 0 0 1.266 0l-.35-.357.35.357 14.686-14.38a1.128 1.128 0 0 1 1.568 0l14.687 14.38a.907.907 0 0 0 1.267 0l14.686-14.38a1.128 1.128 0 0 1 1.568 0Z"/></svg>`,
  BACK_ICON: k`<svg width="10" height="18" viewBox="0 0 10 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.735.179a.75.75 0 0 1 .087 1.057L2.92 8.192a1.25 1.25 0 0 0 0 1.617l5.902 6.956a.75.75 0 1 1-1.144.97L1.776 10.78a2.75 2.75 0 0 1 0-3.559L7.678.265A.75.75 0 0 1 8.735.18Z" fill="#fff"/></svg>`,
  COPY_ICON: k`<svg width="24" height="24" fill="none"><path fill="#fff" fill-rule="evenodd" d="M7.01 7.01c.03-1.545.138-2.5.535-3.28A5 5 0 0 1 9.73 1.545C10.8 1 12.2 1 15 1c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C23 4.8 23 6.2 23 9c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185c-.78.397-1.735.505-3.28.534l-.001.01c-.03 1.54-.138 2.493-.534 3.27a5 5 0 0 1-2.185 2.186C13.2 23 11.8 23 9 23c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C1 19.2 1 17.8 1 15c0-2.8 0-4.2.545-5.27A5 5 0 0 1 3.73 7.545C4.508 7.149 5.46 7.04 7 7.01h.01ZM15 15.5c-1.425 0-2.403-.001-3.162-.063-.74-.06-1.139-.172-1.427-.319a3.5 3.5 0 0 1-1.53-1.529c-.146-.288-.257-.686-.318-1.427C8.501 11.403 8.5 10.425 8.5 9c0-1.425.001-2.403.063-3.162.06-.74.172-1.139.318-1.427a3.5 3.5 0 0 1 1.53-1.53c.288-.146.686-.257 1.427-.318.759-.062 1.737-.063 3.162-.063 1.425 0 2.403.001 3.162.063.74.06 1.139.172 1.427.318a3.5 3.5 0 0 1 1.53 1.53c.146.288.257.686.318 1.427.062.759.063 1.737.063 3.162 0 1.425-.001 2.403-.063 3.162-.06.74-.172 1.139-.319 1.427a3.5 3.5 0 0 1-1.529 1.53c-.288.146-.686.257-1.427.318-.759.062-1.737.063-3.162.063ZM7 8.511c-.444.009-.825.025-1.162.052-.74.06-1.139.172-1.427.318a3.5 3.5 0 0 0-1.53 1.53c-.146.288-.257.686-.318 1.427-.062.759-.063 1.737-.063 3.162 0 1.425.001 2.403.063 3.162.06.74.172 1.139.318 1.427a3.5 3.5 0 0 0 1.53 1.53c.288.146.686.257 1.427.318.759.062 1.737.063 3.162.063 1.425 0 2.403-.001 3.162-.063.74-.06 1.139-.172 1.427-.319a3.5 3.5 0 0 0 1.53-1.53c.146-.287.257-.685.318-1.426.027-.337.043-.718.052-1.162H15c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C7 13.2 7 11.8 7 9v-.489Z" clip-rule="evenodd"/></svg>`,
  RETRY_ICON: k`<svg width="15" height="16" viewBox="0 0 15 16"><path d="M6.464 2.03A.75.75 0 0 0 5.403.97L2.08 4.293a1 1 0 0 0 0 1.414L5.403 9.03a.75.75 0 0 0 1.06-1.06L4.672 6.177a.25.25 0 0 1 .177-.427h2.085a4 4 0 1 1-3.93 4.746c-.077-.407-.405-.746-.82-.746-.414 0-.755.338-.7.748a5.501 5.501 0 1 0 5.45-6.248H4.848a.25.25 0 0 1-.177-.427L6.464 2.03Z" fill="#fff"/></svg>`,
  DESKTOP_ICON: k`<svg width="16" height="16" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 5.98c0-1.85 0-2.775.394-3.466a3 3 0 0 1 1.12-1.12C2.204 1 3.13 1 4.98 1h6.04c1.85 0 2.775 0 3.466.394a3 3 0 0 1 1.12 1.12C16 3.204 16 4.13 16 5.98v1.04c0 1.85 0 2.775-.394 3.466a3 3 0 0 1-1.12 1.12C13.796 12 12.87 12 11.02 12H4.98c-1.85 0-2.775 0-3.466-.394a3 3 0 0 1-1.12-1.12C0 9.796 0 8.87 0 7.02V5.98ZM4.98 2.5h6.04c.953 0 1.568.001 2.034.043.446.04.608.108.69.154a1.5 1.5 0 0 1 .559.56c.046.08.114.243.154.69.042.465.043 1.08.043 2.033v1.04c0 .952-.001 1.568-.043 2.034-.04.446-.108.608-.154.69a1.499 1.499 0 0 1-.56.559c-.08.046-.243.114-.69.154-.466.042-1.08.043-2.033.043H4.98c-.952 0-1.568-.001-2.034-.043-.446-.04-.608-.108-.69-.154a1.5 1.5 0 0 1-.559-.56c-.046-.08-.114-.243-.154-.69-.042-.465-.043-1.08-.043-2.033V5.98c0-.952.001-1.568.043-2.034.04-.446.108-.608.154-.69a1.5 1.5 0 0 1 .56-.559c.08-.046.243-.114.69-.154.465-.042 1.08-.043 2.033-.043Z" fill="#fff"/><path d="M4 14.25a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z" fill="#fff"/></svg>`,
  MOBILE_ICON: k`<svg width="16" height="16" viewBox="0 0 16 16"><path d="M6.75 5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3 4.98c0-1.85 0-2.775.394-3.466a3 3 0 0 1 1.12-1.12C5.204 0 6.136 0 8 0s2.795 0 3.486.394a3 3 0 0 1 1.12 1.12C13 2.204 13 3.13 13 4.98v6.04c0 1.85 0 2.775-.394 3.466a3 3 0 0 1-1.12 1.12C10.796 16 9.864 16 8 16s-2.795 0-3.486-.394a3 3 0 0 1-1.12-1.12C3 13.796 3 12.87 3 11.02V4.98Zm8.5 0v6.04c0 .953-.001 1.568-.043 2.034-.04.446-.108.608-.154.69a1.499 1.499 0 0 1-.56.559c-.08.045-.242.113-.693.154-.47.042-1.091.043-2.05.043-.959 0-1.58-.001-2.05-.043-.45-.04-.613-.109-.693-.154a1.5 1.5 0 0 1-.56-.56c-.046-.08-.114-.243-.154-.69-.042-.466-.043-1.08-.043-2.033V4.98c0-.952.001-1.568.043-2.034.04-.446.108-.608.154-.69a1.5 1.5 0 0 1 .56-.559c.08-.045.243-.113.693-.154C6.42 1.501 7.041 1.5 8 1.5c.959 0 1.58.001 2.05.043.45.04.613.109.693.154a1.5 1.5 0 0 1 .56.56c.046.08.114.243.154.69.042.465.043 1.08.043 2.033Z" fill="#fff"/></svg>`,
  ARROW_DOWN_ICON: k`<svg width="14" height="14" viewBox="0 0 14 14"><path d="M2.28 7.47a.75.75 0 0 0-1.06 1.06l5.25 5.25a.75.75 0 0 0 1.06 0l5.25-5.25a.75.75 0 0 0-1.06-1.06l-3.544 3.543a.25.25 0 0 1-.426-.177V.75a.75.75 0 0 0-1.5 0v10.086a.25.25 0 0 1-.427.176L2.28 7.47Z" fill="#fff"/></svg>`,
  ARROW_UP_RIGHT_ICON: k`<svg width="15" height="14" fill="none"><path d="M4.5 1.75A.75.75 0 0 1 5.25 1H12a1.5 1.5 0 0 1 1.5 1.5v6.75a.75.75 0 0 1-1.5 0V4.164a.25.25 0 0 0-.427-.176L4.061 11.5A.75.75 0 0 1 3 10.44l7.513-7.513a.25.25 0 0 0-.177-.427H5.25a.75.75 0 0 1-.75-.75Z" fill="#fff"/></svg>`,
  ARROW_RIGHT_ICON: k`<svg width="6" height="14" viewBox="0 0 6 14"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.181 1.099a.75.75 0 0 1 1.024.279l2.433 4.258a2.75 2.75 0 0 1 0 2.729l-2.433 4.257a.75.75 0 1 1-1.303-.744L4.335 7.62a1.25 1.25 0 0 0 0-1.24L1.902 2.122a.75.75 0 0 1 .28-1.023Z" fill="#fff"/></svg>`,
  QRCODE_ICON: k`<svg width="25" height="24" viewBox="0 0 25 24"><path d="M23.748 9a.748.748 0 0 0 .748-.752c-.018-2.596-.128-4.07-.784-5.22a6 6 0 0 0-2.24-2.24c-1.15-.656-2.624-.766-5.22-.784a.748.748 0 0 0-.752.748c0 .414.335.749.748.752 1.015.007 1.82.028 2.494.088.995.09 1.561.256 1.988.5.7.398 1.28.978 1.679 1.678.243.427.41.993.498 1.988.061.675.082 1.479.09 2.493a.753.753 0 0 0 .75.749ZM3.527.788C4.677.132 6.152.022 8.747.004A.748.748 0 0 1 9.5.752a.753.753 0 0 1-.749.752c-1.014.007-1.818.028-2.493.088-.995.09-1.561.256-1.988.5-.7.398-1.28.978-1.679 1.678-.243.427-.41.993-.499 1.988-.06.675-.081 1.479-.088 2.493A.753.753 0 0 1 1.252 9a.748.748 0 0 1-.748-.752c.018-2.596.128-4.07.784-5.22a6 6 0 0 1 2.24-2.24ZM1.252 15a.748.748 0 0 0-.748.752c.018 2.596.128 4.07.784 5.22a6 6 0 0 0 2.24 2.24c1.15.656 2.624.766 5.22.784a.748.748 0 0 0 .752-.748.753.753 0 0 0-.749-.752c-1.014-.007-1.818-.028-2.493-.089-.995-.089-1.561-.255-1.988-.498a4.5 4.5 0 0 1-1.679-1.68c-.243-.426-.41-.992-.499-1.987-.06-.675-.081-1.479-.088-2.493A.753.753 0 0 0 1.252 15ZM22.996 15.749a.753.753 0 0 1 .752-.749c.415 0 .751.338.748.752-.018 2.596-.128 4.07-.784 5.22a6 6 0 0 1-2.24 2.24c-1.15.656-2.624.766-5.22.784a.748.748 0 0 1-.752-.748c0-.414.335-.749.748-.752 1.015-.007 1.82-.028 2.494-.089.995-.089 1.561-.255 1.988-.498a4.5 4.5 0 0 0 1.679-1.68c.243-.426.41-.992.498-1.987.061-.675.082-1.479.09-2.493Z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7 4a2.5 2.5 0 0 0-2.5 2.5v2A2.5 2.5 0 0 0 7 11h2a2.5 2.5 0 0 0 2.5-2.5v-2A2.5 2.5 0 0 0 9 4H7Zm2 1.5H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1ZM13.5 6.5A2.5 2.5 0 0 1 16 4h2a2.5 2.5 0 0 1 2.5 2.5v2A2.5 2.5 0 0 1 18 11h-2a2.5 2.5 0 0 1-2.5-2.5v-2Zm2.5-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1ZM7 13a2.5 2.5 0 0 0-2.5 2.5v2A2.5 2.5 0 0 0 7 20h2a2.5 2.5 0 0 0 2.5-2.5v-2A2.5 2.5 0 0 0 9 13H7Zm2 1.5H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z" fill="#fff"/><path d="M13.5 15.5c0-.465 0-.697.038-.89a2 2 0 0 1 1.572-1.572C15.303 13 15.535 13 16 13v2.5h-2.5ZM18 13c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89H18V13ZM18 17.5h2.5c0 .465 0 .697-.038.89a2 2 0 0 1-1.572 1.572C18.697 20 18.465 20 18 20v-2.5ZM13.5 17.5H16V20c-.465 0-.697 0-.89-.038a2 2 0 0 1-1.572-1.572c-.038-.193-.038-.425-.038-.89Z" fill="#fff"/></svg>`,
  SCAN_ICON: k`<svg width="16" height="16" fill="none"><path fill="#fff" d="M10 15.216c0 .422.347.763.768.74 1.202-.064 2.025-.222 2.71-.613a5.001 5.001 0 0 0 1.865-1.866c.39-.684.549-1.507.613-2.709a.735.735 0 0 0-.74-.768.768.768 0 0 0-.76.732c-.009.157-.02.306-.032.447-.073.812-.206 1.244-.384 1.555-.31.545-.761.996-1.306 1.306-.311.178-.743.311-1.555.384-.141.013-.29.023-.447.032a.768.768 0 0 0-.732.76ZM10 .784c0 .407.325.737.732.76.157.009.306.02.447.032.812.073 1.244.206 1.555.384a3.5 3.5 0 0 1 1.306 1.306c.178.311.311.743.384 1.555.013.142.023.29.032.447a.768.768 0 0 0 .76.732.734.734 0 0 0 .74-.768c-.064-1.202-.222-2.025-.613-2.71A5 5 0 0 0 13.477.658c-.684-.39-1.507-.549-2.709-.613a.735.735 0 0 0-.768.74ZM5.232.044A.735.735 0 0 1 6 .784a.768.768 0 0 1-.732.76c-.157.009-.305.02-.447.032-.812.073-1.244.206-1.555.384A3.5 3.5 0 0 0 1.96 3.266c-.178.311-.311.743-.384 1.555-.013.142-.023.29-.032.447A.768.768 0 0 1 .784 6a.735.735 0 0 1-.74-.768c.064-1.202.222-2.025.613-2.71A5 5 0 0 1 2.523.658C3.207.267 4.03.108 5.233.044ZM5.268 14.456a.768.768 0 0 1 .732.76.734.734 0 0 1-.768.74c-1.202-.064-2.025-.222-2.71-.613a5 5 0 0 1-1.865-1.866c-.39-.684-.549-1.507-.613-2.709A.735.735 0 0 1 .784 10c.407 0 .737.325.76.732.009.157.02.306.032.447.073.812.206 1.244.384 1.555a3.5 3.5 0 0 0 1.306 1.306c.311.178.743.311 1.555.384.142.013.29.023.447.032Z"/></svg>`,
  CHECKMARK_ICON: k`<svg width="13" height="12" viewBox="0 0 13 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.155.132a.75.75 0 0 1 .232 1.035L5.821 11.535a1 1 0 0 1-1.626.09L.665 7.21a.75.75 0 1 1 1.17-.937L4.71 9.867a.25.25 0 0 0 .406-.023L11.12.364a.75.75 0 0 1 1.035-.232Z" fill="#fff"/></svg>`,
  HELP_ETH_IMG: k`<svg width="60" height="60" fill="none" viewBox="0 0 60 60"><g clip-path="url(#j)"><rect width="60" height="60" rx="30" fill="#987DE8"/><path fill-rule="evenodd" clip-rule="evenodd" d="m15.48 28.367 11.966-19.3c1.174-1.892 3.927-1.892 5.1 0l11.97 19.306a6 6 0 0 1 .9 3.142v.028a6 6 0 0 1-1.154 3.56L33.227 50.208c-1.599 2.188-4.864 2.188-6.461 0L15.733 35.095a6 6 0 0 1-1.154-3.538v-.029a6 6 0 0 1 .9-3.161Z" fill="#fff"/><path d="M30.84 10.112a.992.992 0 0 0-.844-.464V24.5l12.598 5.53c.081-.466-.001-.963-.27-1.398L30.84 10.112Z" fill="#643CDD"/><path d="M29.996 9.648a.991.991 0 0 0-.845.465l-11.489 18.53a1.991 1.991 0 0 0-.264 1.387l12.598-5.53V9.648Z" fill="#BDADEB"/><path d="M29.996 50.544a.994.994 0 0 0 .808-.41l11.235-15.38c.307-.434-.193-.988-.658-.72L31.49 39.71a2.998 2.998 0 0 1-1.494.398v10.437Z" fill="#643CDD"/><path d="M17.966 34.762 29.19 50.134c.2.274.503.41.807.41V40.108a2.998 2.998 0 0 1-1.493-.398l-9.884-5.676c-.468-.27-.971.292-.653.728Z" fill="#BDADEB"/><path d="M42.594 30.03 29.996 24.5v13.138a3 3 0 0 0 1.495-.399l10.149-5.83c.525-.31.856-.823.954-1.38Z" fill="#401AB3"/><path d="M29.996 37.638V24.462l-12.598 5.566c.098.564.437 1.083.974 1.392l10.13 5.82c.462.265.978.398 1.494.398Z" fill="#7C5AE2"/></g><rect class="help-img-highlight" x=".5" y=".5" width="59" height="59" rx="29.5"/><defs><clipPath id="j"><rect width="60" height="60" rx="30" fill="#fff"/></clipPath></defs></svg>`,
  HELP_PAINTING_IMG: k`<svg width="60" height="60" fill="none" viewBox="0 0 60 60"><g clip-path="url(#k)"><rect width="60" height="60" rx="3" fill="#C653C6"/><path d="M52.094 47.344c0-4.246-1.436-9.557-5.885-12.4a2.876 2.876 0 0 0-1.615-3.891v-.819a4.037 4.037 0 0 0-1.34-3.007 4.75 4.75 0 0 0-2.41-6.252v-5.506c0-6.248-5.065-11.313-11.313-11.313-6.247 0-11.312 5.065-11.312 11.313v2.152a3.343 3.343 0 0 0-1.18 5.045 4.738 4.738 0 0 0-1.633 3.584 4.73 4.73 0 0 0 .956 2.858 5.218 5.218 0 0 0-2.358 6.815c-3.06 4.129-6.098 8.298-6.098 15.64 0 2.668.364 4.856.731 6.385.184.765.368 1.366.509 1.78a12.721 12.721 0 0 0 .225.611l.015.037.005.011.001.004v.002h.001l.92-.393-.92.394.26.606h38.26l.291-.49-.86-.51.86.51v-.001l.002-.002.002-.005.01-.017.035-.06.127-.225c.108-.195.26-.477.441-.835.363-.714.845-1.732 1.328-2.953.959-2.427 1.945-5.725 1.945-9.068Z" fill="#E87DE8" stroke="#fff" stroke-width="2"/><path fill-rule="evenodd" clip-rule="evenodd" d="M26.5 29.5c-3-.5-5.5-3-5.503-7l.002-7c0-.466 0-.698.026-.893a3 3 0 0 1 2.582-2.582c.195-.026.428-.026.893-.026 2 0 2.5-2.5 2.5-2.5s0 2.5 2.5 2.5c1.398 0 2.097 0 2.648.229a3 3 0 0 1 1.624 1.623c.228.552.228 1.25.228 2.649v6c0 4-3 7-6.5 7 1.35.23 4 0 6.5-2v9.53C34 38.5 31.495 40 28 40s-6-1.5-6-2.97L24 34l2.5 1.5v-6ZM26 47h4.5c2.5 0 3 4 3 5.5h-3l-1-1.5H26v-4Zm-6.25 5.5H24V57h-8c0-1 1-4.5 3.75-4.5Z" fill="#fff"/></g><rect class="help-img-highlight" x=".5" y=".5" width="59" height="59" rx="2.5"/><defs><clipPath id="k"><rect width="60" height="60" rx="3" fill="#fff"/></clipPath></defs></svg>`,
  HELP_CHART_IMG: k`<svg width="60" height="60" fill="none" viewBox="0 0 60 60"><g clip-path="url(#l)"><path d="M0 25.01C0 15.76 0 11.133 1.97 7.678a15 15 0 0 1 5.598-5.597C11.023.11 15.648.11 24.9.11h10.2c9.251 0 13.877 0 17.332 1.97a15 15 0 0 1 5.597 5.597C60 11.133 60 15.758 60 25.01v10.2c0 9.252 0 13.877-1.97 17.332a15 15 0 0 1-5.598 5.598c-3.455 1.97-8.08 1.97-17.332 1.97H24.9c-9.251 0-13.877 0-17.332-1.97a14.999 14.999 0 0 1-5.597-5.598C0 49.087 0 44.462 0 35.21v-10.2Z" fill="#1DC956"/><path d="M.5 25.01c0-4.635 0-8.078.244-10.795.244-2.71.726-4.65 1.66-6.289a14.5 14.5 0 0 1 5.412-5.41c1.639-.936 3.579-1.418 6.289-1.661C16.822.61 20.265.61 24.9.61h10.2c4.635 0 8.078 0 10.795.245 2.71.243 4.65.725 6.29 1.66a14.5 14.5 0 0 1 5.41 5.411c.935 1.64 1.417 3.579 1.66 6.29.244 2.717.245 6.16.245 10.794v10.2c0 4.635 0 8.078-.244 10.795-.244 2.71-.726 4.65-1.66 6.29a14.5 14.5 0 0 1-5.412 5.41c-1.639.936-3.579 1.418-6.289 1.661-2.717.244-6.16.244-10.795.244H24.9c-4.635 0-8.078 0-10.795-.244-2.71-.243-4.65-.725-6.29-1.66a14.5 14.5 0 0 1-5.41-5.412C1.47 50.655.988 48.716.745 46.005.5 43.288.5 39.845.5 35.21v-10.2Z" stroke="#fff" stroke-opacity=".1"/><path d="M16.109 60c-3.833-.179-6.41-.645-8.541-1.86a15 15 0 0 1-5.598-5.598C.553 50.057.155 46.967.043 41.985l4.146-1.382a4 4 0 0 0 2.48-2.39l4.654-12.409a2 2 0 0 1 2.505-1.195l2.526.842a2 2 0 0 0 2.422-1.003l2.968-5.938c.81-1.62 3.185-1.415 3.705.32l3.774 12.581a2 2 0 0 0 3.025 1.09l3.342-2.228c.27-.18.49-.422.646-.706l5.297-9.712a2 2 0 0 1 1.428-1.016l4.134-.689a2 2 0 0 1 1.61.437l3.892 3.243a2 2 0 0 0 2.694-.122l4.633-4.632C60 19.28 60 21.88 60 25.01v10.2c0 9.252 0 13.877-1.97 17.332a14.998 14.998 0 0 1-5.598 5.598c-2.131 1.215-4.708 1.681-8.54 1.86H16.108Z" fill="#2BEE6C"/><path d="M.072 43.03a112.37 112.37 0 0 1-.048-2.093l3.85-1.283a3 3 0 0 0 1.86-1.793l4.653-12.408a3 3 0 0 1 3.758-1.793l2.526.842a1 1 0 0 0 1.21-.501l2.97-5.938c1.214-2.43 4.775-2.123 5.556.48l3.774 12.58a1 1 0 0 0 1.513.545l3.341-2.227a1 1 0 0 0 .323-.353l5.298-9.712a3 3 0 0 1 2.14-1.523l4.135-.69a3 3 0 0 1 2.414.655l3.892 3.244a1 1 0 0 0 1.347-.061l5.28-5.28c.046.845.077 1.752.097 2.732l-3.962 3.962a3 3 0 0 1-4.042.183l-3.893-3.243a1 1 0 0 0-.804-.218l-4.135.689a1 1 0 0 0-.714.507l-5.297 9.712c-.233.427-.565.79-.97 1.06l-3.34 2.228a3 3 0 0 1-4.538-1.635l-3.775-12.58c-.26-.868-1.447-.97-1.852-.16l-2.969 5.937a3 3 0 0 1-3.632 1.505l-2.526-.842a1 1 0 0 0-1.252.597L7.606 38.564a5 5 0 0 1-3.1 2.988L.072 43.029Z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M49.5 19a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z" fill="#2BEE6C"/><path d="M47.5 19a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" fill="#fff"/><path d="M45 .283v59.654c-.63.042-1.294.074-2 .098V.185c.706.025 1.37.056 2 .098Z" fill="#fff"/><path class="help-img-highlight" d="M.5 25.01c0-4.635 0-8.078.244-10.795.244-2.71.726-4.65 1.66-6.289a14.5 14.5 0 0 1 5.412-5.41c1.639-.936 3.579-1.418 6.289-1.661C16.822.61 20.265.61 24.9.61h10.2c4.635 0 8.078 0 10.795.245 2.71.243 4.65.725 6.29 1.66a14.5 14.5 0 0 1 5.41 5.411c.935 1.64 1.417 3.579 1.66 6.29.244 2.717.245 6.16.245 10.794v10.2c0 4.635 0 8.078-.244 10.795-.244 2.71-.726 4.65-1.66 6.29a14.5 14.5 0 0 1-5.412 5.41c-1.639.936-3.579 1.418-6.289 1.661-2.717.244-6.16.244-10.795.244H24.9c-4.635 0-8.078 0-10.795-.244-2.71-.243-4.65-.725-6.29-1.66a14.5 14.5 0 0 1-5.41-5.412C1.47 50.655.988 48.716.745 46.005.5 43.288.5 39.845.5 35.21v-10.2Z"/></g><defs><clipPath id="l"><path fill="#fff" d="M0 0h60v60H0z"/></clipPath></defs></svg>`,
  HELP_KEY_IMG: k`<svg width="60" height="60" fill="none" viewBox="0 0 60 60"><g clip-path="url(#m)"><path fill="#EB8B47" d="M0 24.9c0-9.252 0-13.878 1.97-17.332A15 15 0 0 1 7.569 1.97C11.023 0 15.648 0 24.9 0h10.2c9.251 0 13.877 0 17.332 1.97a15 15 0 0 1 5.597 5.598C60 11.022 60 15.648 60 24.899v10.2c0 9.252 0 13.878-1.97 17.332a15.001 15.001 0 0 1-5.598 5.598c-3.455 1.97-8.08 1.97-17.332 1.97H24.9c-9.251 0-13.877 0-17.332-1.97a15 15 0 0 1-5.597-5.598C0 48.977 0 44.351 0 35.1V24.9Z"/><path class="help-img-highlight" d="M.5 24.9c0-4.635 0-8.078.244-10.795.244-2.71.726-4.65 1.66-6.29a14.5 14.5 0 0 1 5.412-5.41C9.455 1.468 11.395.986 14.105.743 16.822.5 20.265.5 24.9.5h10.2c4.635 0 8.078 0 10.795.244 2.71.243 4.65.725 6.29 1.66a14.5 14.5 0 0 1 5.41 5.411c.935 1.64 1.417 3.58 1.66 6.29.244 2.717.245 6.16.245 10.794v10.2c0 4.635 0 8.078-.244 10.796-.244 2.71-.726 4.65-1.66 6.289a14.5 14.5 0 0 1-5.412 5.41c-1.639.936-3.579 1.418-6.289 1.661-2.717.244-6.16.244-10.795.244H24.9c-4.635 0-8.078 0-10.795-.244-2.71-.243-4.65-.725-6.29-1.66a14.5 14.5 0 0 1-5.41-5.411c-.935-1.64-1.417-3.58-1.66-6.29C.5 43.178.5 39.734.5 35.1V24.9Z"/><path fill="#FF974C" stroke="#fff" stroke-width="2" d="M39.192 29.192c5.077-5.077 5.077-13.308 0-18.385-5.076-5.077-13.308-5.077-18.384 0-5.077 5.077-5.077 13.308 0 18.385l1.287 1.291c1.137 1.142 1.706 1.712 2.097 2.387.267.462.472.957.608 1.473.2.755.2 1.56.2 3.171V48.75c0 1.077 0 1.615.134 2.119a4 4 0 0 0 .407.984c.262.45.643.831 1.404 1.592l.294.295c.654.654.982.981 1.365 1.086.26.07.533.07.792 0 .383-.105.71-.432 1.365-1.086l3.478-3.479c.655-.654.982-.981 1.087-1.365a1.5 1.5 0 0 0 0-.791c-.105-.384-.432-.711-1.087-1.365l-.478-.479c-.655-.654-.982-.981-1.087-1.365a1.5 1.5 0 0 1 0-.791c.105-.384.432-.711 1.087-1.365l.478-.479c.655-.654.982-.981 1.087-1.365a1.5 1.5 0 0 0 0-.791c-.105-.384-.432-.711-1.087-1.365l-.492-.493c-.65-.65-.974-.974-1.08-1.355a1.5 1.5 0 0 1-.003-.788c.102-.382.425-.71 1.069-1.364l5.46-5.547Z"/><circle cx="30" cy="17" r="4" fill="#EB8B47" stroke="#fff" stroke-width="2"/></g><defs><clipPath id="m"><path fill="#fff" d="M0 0h60v60H0z"/></clipPath></defs></svg>`,
  HELP_USER_IMG: k`<svg width="60" height="60" fill="none" viewBox="0 0 60 60"><g clip-path="url(#n)"><rect width="60" height="60" fill="#00ACE6" rx="30"/><path fill="#1AC6FF" stroke="#fff" stroke-width="2" d="M59 73c0 16.016-12.984 29-29 29S1 89.016 1 73c0-16.017 11-29 29-29s29 12.983 29 29ZM18.69 19.902a11 11 0 0 1 9.281-8.692 14.842 14.842 0 0 1 4.058 0 11 11 0 0 1 9.28 8.692c.178.866.322 1.75.44 2.625.132.977.132 1.968 0 2.945a39.467 39.467 0 0 1-.44 2.625 11 11 0 0 1-9.28 8.692 14.862 14.862 0 0 1-4.058 0 11 11 0 0 1-9.28-8.692 39.467 39.467 0 0 1-.44-2.625 11.004 11.004 0 0 1 0-2.945c.118-.876.262-1.759.44-2.625Z"/><circle cx="24.5" cy="23.5" r="1.5" fill="#fff"/><circle cx="35.5" cy="23.5" r="1.5" fill="#fff"/><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m31 20-3 8h4"/></g><rect class="help-img-highlight" width="59" height="59" x=".5" y=".5" rx="29.5"/><defs><clipPath id="n"><rect width="60" height="60" fill="#fff" rx="30"/></clipPath></defs></svg>`,
  HELP_LOCK_IMG: k`<svg width="60" height="60" fill="none" viewBox="0 0 60 60"><rect width="60" height="60" fill="#C653C6" rx="3"/><path fill="#fff" d="M20.034 15.216C20 15.607 20 16.07 20 17v2.808c0 1.13 0 1.696-.2 2.11a1.78 1.78 0 0 1-.584.714c-.366.28-1.051.42-2.423.7a7.076 7.076 0 0 0-1.597.511 9.001 9.001 0 0 0-4.353 4.353C10 30.005 10 32.336 10 37c0 4.663 0 6.995.843 8.804a9.001 9.001 0 0 0 4.353 4.353C17.005 51 19.336 51 24 51h12c4.663 0 6.995 0 8.804-.843a9.001 9.001 0 0 0 4.353-4.353C50 43.995 50 41.664 50 37c0-4.663 0-6.995-.843-8.804a9.001 9.001 0 0 0-4.353-4.353 7.076 7.076 0 0 0-1.597-.511c-1.372-.28-2.057-.42-2.423-.7a1.78 1.78 0 0 1-.583-.715C40 21.505 40 20.94 40 19.809V17c0-.929 0-1.393-.034-1.784a9 9 0 0 0-8.182-8.182C31.393 7 30.93 7 30 7s-1.393 0-1.784.034a9 9 0 0 0-8.182 8.182Z"/><path fill="#E87DE8" d="M22 17c0-.929 0-1.393.044-1.784a7 7 0 0 1 6.172-6.172C28.606 9 29.071 9 30 9s1.393 0 1.784.044a7 7 0 0 1 6.172 6.172c.044.39.044.855.044 1.784v4.5a1.5 1.5 0 0 1-3 0V17c0-.93 0-1.394-.077-1.78a4 4 0 0 0-3.143-3.143C31.394 12 30.93 12 30 12s-1.394 0-1.78.077a4 4 0 0 0-3.143 3.143C25 15.606 25 16.07 25 17v4.5a1.5 1.5 0 0 1-3 0V17Z"/><path fill="#E87DE8" fill-rule="evenodd" d="M12 36.62c0-4.317 0-6.476.92-8.088a7 7 0 0 1 2.612-2.612c1.612-.92 3.77-.92 8.088-.92h6.855c.469 0 .703 0 .906.017 2.73.222 4.364 2.438 4.619 4.983.27-2.698 2.111-5 5.015-5A6.985 6.985 0 0 1 48 31.985v5.395c0 4.317 0 6.476-.92 8.088a7 7 0 0 1-2.612 2.612c-1.612.92-3.77.92-8.088.92h-5.855c-.469 0-.703 0-.906-.017-2.73-.222-4.364-2.438-4.619-4.983-.258 2.583-1.943 4.818-4.714 4.99-.155.01-.335.01-.694.01-.55 0-.825 0-1.057-.015a7 7 0 0 1-6.52-6.52C12 42.233 12 41.958 12 41.408V36.62Zm21.24-.273a4 4 0 1 0-6.478 0c.985 1.36 1.479 2.039 1.564 2.229.178.398.176.818.174 1.247V42.5a1.5 1.5 0 0 0 3 0v-2.677c-.002-.429-.004-.85.174-1.247.085-.19.579-.87 1.565-2.229Z" clip-rule="evenodd"/><rect class="help-img-highlight" width="59" height="59" x=".5" y=".5" rx="2.5"/></svg>`,
  HELP_COMPAS_IMG: k`<svg width="60" height="60" fill="none" viewBox="0 0 60 60"><rect width="60" height="60" fill="#1DC956" rx="30"/><circle cx="30" cy="29.999" r="3" fill="#fff"/><path fill="#2BEE6C" stroke="#fff" stroke-width="2" d="m45.316 17.9-.88-.425.88.424a7.9 7.9 0 0 1 .026-.053c.093-.192.21-.432.26-.687l-.819-.162.819.162a2 2 0 0 0-.239-1.405c-.132-.224-.32-.412-.472-.562a8.415 8.415 0 0 1-.042-.042l-.042-.042c-.15-.151-.338-.34-.562-.472l-.508.862.508-.862a2 2 0 0 0-1.405-.239c-.255.05-.495.167-.687.26l-.053.026-15.05 7.246-.108.052c-1.131.545-1.843.887-2.456 1.374a6.994 6.994 0 0 0-1.13 1.13c-.487.613-.83 1.325-1.375 2.457l-.051.108-7.247 15.05-.025.053c-.094.192-.21.431-.26.686a2 2 0 0 0 .239 1.406l.855-.505-.856.505c.133.224.321.411.473.562l.042.042.041.042c.15.151.338.34.563.472a2 2 0 0 0 1.405.239l-.195-.981.195.98c.255-.05.494-.166.686-.26l.054-.025-.419-.87.419.87 15.05-7.247.107-.051c1.132-.545 1.844-.888 2.457-1.374a7.002 7.002 0 0 0 1.13-1.13c.487-.614.83-1.325 1.374-2.457l.052-.108 7.246-15.05Z"/><path fill="#1DC956" d="m33.376 32.723-2.669-3.43-14.85 14.849.206.205a1 1 0 0 0 1.141.194l15.105-7.273a3 3 0 0 0 1.067-4.545Z"/><path fill="#86F999" d="m26.624 27.276 2.669 3.43 14.85-14.849-.206-.205a1 1 0 0 0-1.141-.194L27.69 22.731a3 3 0 0 0-1.067 4.545Z"/><circle cx="30" cy="30" r="3" fill="#fff" transform="rotate(45 30 30)"/><rect class="help-img-highlight" width="59" height="59" x=".5" y=".5" rx="29.5"/></svg>`,
  HELP_NOUN_IMG: k`<svg width="60" height="60" fill="none" viewBox="0 0 60 60"><rect width="60" height="60" fill="#794CFF" rx="3"/><path fill="#987DE8" stroke="#fff" stroke-width="2" d="M33 22.5v-1H16v5H8.5V36H13v-5h3v7.5h17V31h1v7.5h17v-17H34v5h-1v-4Z"/><path fill="#fff" d="M37.5 25h10v10h-10z"/><path fill="#4019B2" d="M42.5 25h5v10h-5z"/><path fill="#fff" d="M19.5 25h10v10h-10z"/><path fill="#4019B2" d="M24.5 25h5v10h-5z"/><path fill="#fff" d="M12 30.5h4V37h-4v-6.5Z"/><rect class="help-img-highlight" width="59" height="59" x=".5" y=".5" rx="2.5"/></svg>`,
  HELP_DAO_IMG: k`<svg width="60" height="60" fill="none" viewBox="0 0 60 60"><g clip-path="url(#o)"><path fill="#EB8B47" d="M0 24.9c0-9.252 0-13.878 1.97-17.332A15 15 0 0 1 7.569 1.97C11.023 0 15.648 0 24.9 0h10.2c9.251 0 13.877 0 17.332 1.97a15 15 0 0 1 5.597 5.598C60 11.022 60 15.648 60 24.899v10.2c0 9.252 0 13.878-1.97 17.332a15.001 15.001 0 0 1-5.598 5.598c-3.455 1.97-8.08 1.97-17.332 1.97H24.9c-9.251 0-13.877 0-17.332-1.97a15 15 0 0 1-5.597-5.598C0 48.977 0 44.351 0 35.1V24.9Z"/><path class="help-img-highlight" d="M.5 24.9c0-4.635 0-8.078.244-10.795.244-2.71.726-4.65 1.66-6.29a14.5 14.5 0 0 1 5.412-5.41C9.455 1.468 11.395.986 14.105.743 16.822.5 20.265.5 24.9.5h10.2c4.635 0 8.078 0 10.795.244 2.71.243 4.65.725 6.29 1.66a14.5 14.5 0 0 1 5.41 5.411c.935 1.64 1.417 3.58 1.66 6.29.244 2.717.245 6.16.245 10.794v10.2c0 4.635 0 8.078-.244 10.796-.244 2.71-.726 4.65-1.66 6.289a14.5 14.5 0 0 1-5.412 5.41c-1.639.936-3.579 1.418-6.289 1.661-2.717.244-6.16.244-10.795.244H24.9c-4.635 0-8.078 0-10.795-.244-2.71-.243-4.65-.725-6.29-1.66a14.5 14.5 0 0 1-5.41-5.411c-.935-1.64-1.417-3.58-1.66-6.29C.5 43.178.5 39.734.5 35.1V24.9Z"/><path fill="#FF974C" stroke="#fff" stroke-width="2" d="M19 52c5.523 0 10-4.477 10-10s-4.477-10-10-10S9 36.477 9 42s4.477 10 10 10Z"/><path fill="#fff" fill-rule="evenodd" d="M42.844 8.326a1 1 0 0 0-1.687 0L28.978 27.463A1 1 0 0 0 29.822 29h24.357a1 1 0 0 0 .843-1.537L42.844 8.326Z" clip-rule="evenodd"/><path fill="#FF974C" fill-rule="evenodd" d="M42.335 11.646c.324.115.571.504 1.066 1.28l7.332 11.523c.562.883.843 1.325.792 1.69a1 1 0 0 1-.342.623c-.28.238-.803.238-1.85.238H34.667c-1.047 0-1.57 0-1.85-.238a1 1 0 0 1-.342-.623c-.051-.365.23-.806.792-1.69l7.332-11.523c.495-.776.742-1.165 1.066-1.28a1 1 0 0 1 .67 0ZM35 27a7 7 0 0 0 7-7 7 7 0 0 0 7 7H35Z" clip-rule="evenodd"/><path fill="#FF974C" stroke="#fff" stroke-width="2" d="M10.106 9.357c-.109.32-.107.682-.106.975V25.668c-.001.293-.003.654.106.975a2 2 0 0 0 1.251 1.25c.32.11.682.108.975.107H19c5.523 0 10-4.477 10-10S24.523 8 19 8h-6.668c-.293-.001-.654-.003-.975.106a2 2 0 0 0-1.25 1.251Z"/><circle cx="19" cy="18" r="4" fill="#EB8B47" stroke="#fff" stroke-width="2"/><circle cx="19" cy="41.999" r="4" fill="#EB8B47" stroke="#fff" stroke-width="2"/></g><defs><clipPath id="o"><path fill="#fff" d="M0 0h60v60H0z"/></clipPath></defs></svg>`,
  SEARCH_ICON: k`<svg width="20" height="21"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.432 13.992c-.354-.353-.91-.382-1.35-.146a5.5 5.5 0 1 1 2.265-2.265c-.237.441-.208.997.145 1.35l3.296 3.296a.75.75 0 1 1-1.06 1.061l-3.296-3.296Zm.06-5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" fill="#949E9E"/></svg>`,
  HELP_ICON: k`<svg width="11" height="17" viewBox="0 0 11 17"><path fill="#fff" d="M5.22 2.97c-1.07 0-2.25.843-2.25 2.25a.75.75 0 0 1-1.5 0c0-2.393 2.019-3.75 3.75-3.75 1.73 0 3.75 1.357 3.75 3.75 0 1.64-1.038 2.466-1.785 3.057-.802.635-1.215.984-1.215 1.693a.75.75 0 1 1-1.5 0c0-1.466.985-2.24 1.681-2.788l.103-.081C7.007 6.504 7.47 6.08 7.47 5.22c0-1.407-1.181-2.25-2.25-2.25ZM5.22 14.97a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"/></svg>`,
  WALLET_ICON: k`<svg width="15" height="14" fill="none" viewBox="0 0 15 14"><path fill="#fff" fill-rule="evenodd" d="M.64 9.2v-3h.001c.009-1.857.07-2.886.525-3.682a4 4 0 0 1 1.492-1.493C3.58.5 4.813.5 7.28.5h3.735c.58 0 .871 0 1.114.04A3 3 0 0 1 14.6 3.011c.04.243.04.533.04 1.114 0 .58 0 .871-.04 1.114a3 3 0 0 1-2.471 2.47c-.243.041-.533.041-1.114.041h-.777c.178.307.302.648.362 1.011.04.243.04.533.04 1.114 0 .58 0 .871-.04 1.114a3 3 0 0 1-2.471 2.47c-.243.041-.533.041-1.114.041H4.507A3.867 3.867 0 0 1 .64 9.633V9.2ZM7.28 2h3.735c.64 0 .779.005.87.02a1.5 1.5 0 0 1 1.235 1.236c.015.09.02.229.02.869s-.005.779-.02.87a1.5 1.5 0 0 1-1.236 1.235c-.09.015-.229.02-.869.02H4.023c-.697 0-1.345.21-1.883.572V6.25h.001c.004-.791.015-1.383.059-1.867.056-.629.157-.926.269-1.122a2.5 2.5 0 0 1 .932-.933c.197-.111.494-.212 1.123-.268C5.173 2 6.019 2 7.28 2Zm-.265 5.75H4.023c-1.04 0-1.883.843-1.883 1.883A2.367 2.367 0 0 0 4.507 12h2.508c.64 0 .779-.005.87-.02a1.5 1.5 0 0 0 1.235-1.236c.015-.09.02-.229.02-.869s-.005-.779-.02-.87A1.5 1.5 0 0 0 7.884 7.77c-.09-.015-.228-.02-.869-.02Z" clip-rule="evenodd"/></svg>`,
  NETWORK_PLACEHOLDER: k`<svg width="28" height="28" fill="none" viewBox="0 0 28 28"><mask id="p" width="26" height="28" x="1" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M12 1.172a4 4 0 0 1 4 0l8.124 4.69a4 4 0 0 1 2 3.465v9.381a4 4 0 0 1-2 3.464L16 26.862a4 4 0 0 1-4 0l-8.124-4.69a4 4 0 0 1-2-3.464V9.327a4 4 0 0 1 2-3.464L12 1.173Z"/></mask><g mask="url(#p)"><path id="network-placeholder-fill" fill="#fff" d="M0 0h28v28H0z"/><path id="network-placeholder-dash" stroke="#000" stroke-dasharray="2 2" d="m8.953 2.931 2.032-1.173.25.433 1.015-.586c.269-.155.553-.271.844-.35l-.13-.483a4.003 4.003 0 0 1 2.071 0l-.13.483c.293.079.576.195.845.35l1.016.586.25-.433 2.03 1.173-.25.433 2.032 1.173.25-.433 2.03 1.172-.25.433 1.016.587c.269.155.512.342.725.556l.354-.354a4.003 4.003 0 0 1 1.035 1.794l-.483.129c.078.292.12.596.12.906v1.172h.5v2.346h-.5v2.345h.5v2.345h-.5v1.173c0 .31-.042.614-.12.906l.483.13a4.003 4.003 0 0 1-1.035 1.793l-.354-.354a3.498 3.498 0 0 1-.725.556l-1.015.586.25.434-2.031 1.172-.25-.433-2.031 1.173.25.433-2.031 1.172-.25-.433-1.016.587a3.494 3.494 0 0 1-.844.35l.13.482a4.003 4.003 0 0 1-2.071 0l.13-.483a3.496 3.496 0 0 1-.845-.35l-1.015-.586-.25.433-2.032-1.172.25-.433-2.03-1.173-.25.433L4.89 22.76l.25-.434-1.015-.586a3.498 3.498 0 0 1-.725-.556l-.354.354a4.003 4.003 0 0 1-1.035-1.794l.483-.13a3.497 3.497 0 0 1-.12-.905v-1.173h-.5V15.19h.5v-2.345h-.5v-2.346h.5V9.327c0-.31.042-.614.12-.906l-.483-.13a4.003 4.003 0 0 1 1.035-1.793l.354.354c.213-.214.456-.401.725-.556l1.015-.587-.25-.433 2.031-1.172.25.433 2.031-1.173-.25-.433Z"/><path fill="#798686" stroke="#fff" d="M14.243 13.563 14 13.428l-.243.135-6.388 3.549-.024.013c-.432.24-.79.44-1.053.622-.266.184-.516.405-.636.722a1.5 1.5 0 0 0 0 1.062c.12.317.37.538.636.722.263.183.62.382 1.053.622l.024.013 3.164 1.758.088.049c1.164.646 1.857 1.032 2.607 1.162.51.09 1.033.09 1.544 0 .75-.13 1.443-.516 2.606-1.162l.09-.05 3.163-1.757.024-.013c.432-.24.79-.44 1.053-.622.266-.184.516-.405.636-.722l-.468-.177.468.177a1.5 1.5 0 0 0 0-1.062l-.468.177.468-.177c-.12-.317-.37-.538-.636-.722-.263-.183-.62-.382-1.053-.622l-.024-.013-6.388-3.55Z"/><path fill="#9EA9A9" stroke="#fff" d="M14.243 8.563 14 8.428l-.243.135-6.388 3.549-.024.013c-.432.24-.79.44-1.053.622-.266.184-.516.405-.636.722a1.5 1.5 0 0 0 0 1.062c.12.316.37.537.636.722.263.183.62.382 1.053.622l.024.013 3.164 1.758.088.049c1.164.646 1.857 1.032 2.607 1.162.51.09 1.033.09 1.544 0 .75-.13 1.443-.516 2.606-1.162l.09-.05 3.163-1.757.024-.013c.432-.24.79-.44 1.053-.622.266-.184.516-.405.636-.722l-.468-.177.468.177a1.5 1.5 0 0 0 0-1.062l-.468.177.468-.177c-.12-.316-.37-.537-.636-.722-.263-.183-.62-.382-1.053-.622l-.024-.013-6.388-3.55Z"/><path fill="#C9CFCF" stroke="#fff" d="m22.344 9.53-.468-.176.468.177a1.5 1.5 0 0 0 0-1.062l-.468.177.468-.177c-.12-.317-.37-.537-.636-.722-.263-.183-.62-.382-1.053-.622l-.024-.013-3.163-1.758-.09-.05c-1.163-.645-1.856-1.03-2.606-1.161a4.5 4.5 0 0 0-1.544 0c-.75.13-1.443.516-2.607 1.162l-.088.05-3.164 1.757-.024.013c-.432.24-.79.44-1.053.622-.266.185-.516.405-.636.722a1.5 1.5 0 0 0 0 1.062c.12.317.37.537.636.722.263.183.62.382 1.053.622l.024.013 3.164 1.758.088.049c1.164.646 1.857 1.032 2.607 1.162.51.09 1.033.09 1.544 0 .75-.13 1.443-.516 2.606-1.162l.09-.05 3.163-1.757.024-.013c.432-.24.79-.44 1.053-.622.266-.184.516-.405.636-.722Z"/></g></svg>`,
  WALLET_PLACEHOLDER: k`<svg width="60" height="60" fill="none" viewBox="0 0 60 60"><g clip-path="url(#q)"><path id="wallet-placeholder-fill" fill="#fff" d="M0 24.9c0-9.251 0-13.877 1.97-17.332a15 15 0 0 1 5.598-5.597C11.023 0 15.648 0 24.9 0h10.2c9.252 0 13.877 0 17.332 1.97a15 15 0 0 1 5.597 5.598C60 11.023 60 15.648 60 24.9v10.2c0 9.252 0 13.877-1.97 17.332a15.001 15.001 0 0 1-5.598 5.597C48.977 60 44.352 60 35.1 60H24.9c-9.251 0-13.877 0-17.332-1.97a15 15 0 0 1-5.597-5.598C0 48.977 0 44.352 0 35.1V24.9Z"/><path id="wallet-placeholder-dash" stroke="#000" stroke-dasharray="4 4" stroke-width="1.5" d="M.04 41.708a231.598 231.598 0 0 1-.039-4.403l.75-.001L.75 35.1v-2.55H0v-5.1h.75V24.9l.001-2.204h-.75c.003-1.617.011-3.077.039-4.404l.75.016c.034-1.65.099-3.08.218-4.343l-.746-.07c.158-1.678.412-3.083.82-4.316l.713.236c.224-.679.497-1.296.827-1.875a14.25 14.25 0 0 1 1.05-1.585L3.076 5.9A15 15 0 0 1 5.9 3.076l.455.596a14.25 14.25 0 0 1 1.585-1.05c.579-.33 1.196-.603 1.875-.827l-.236-.712C10.812.674 12.217.42 13.895.262l.07.746C15.23.89 16.66.824 18.308.79l-.016-.75C19.62.012 21.08.004 22.695.001l.001.75L24.9.75h2.55V0h5.1v.75h2.55l2.204.001v-.75c1.617.003 3.077.011 4.404.039l-.016.75c1.65.034 3.08.099 4.343.218l.07-.746c1.678.158 3.083.412 4.316.82l-.236.713c.679.224 1.296.497 1.875.827a14.24 14.24 0 0 1 1.585 1.05l.455-.596A14.999 14.999 0 0 1 56.924 5.9l-.596.455c.384.502.735 1.032 1.05 1.585.33.579.602 1.196.827 1.875l.712-.236c.409 1.233.663 2.638.822 4.316l-.747.07c.119 1.264.184 2.694.218 4.343l.75-.016c.028 1.327.036 2.787.039 4.403l-.75.001.001 2.204v2.55H60v5.1h-.75v2.55l-.001 2.204h.75a231.431 231.431 0 0 1-.039 4.404l-.75-.016c-.034 1.65-.099 3.08-.218 4.343l.747.07c-.159 1.678-.413 3.083-.822 4.316l-.712-.236a10.255 10.255 0 0 1-.827 1.875 14.242 14.242 0 0 1-1.05 1.585l.596.455a14.997 14.997 0 0 1-2.824 2.824l-.455-.596c-.502.384-1.032.735-1.585 1.05-.579.33-1.196.602-1.875.827l.236.712c-1.233.409-2.638.663-4.316.822l-.07-.747c-1.264.119-2.694.184-4.343.218l.016.75c-1.327.028-2.787.036-4.403.039l-.001-.75-2.204.001h-2.55V60h-5.1v-.75H24.9l-2.204-.001v.75a231.431 231.431 0 0 1-4.404-.039l.016-.75c-1.65-.034-3.08-.099-4.343-.218l-.07.747c-1.678-.159-3.083-.413-4.316-.822l.236-.712a10.258 10.258 0 0 1-1.875-.827 14.252 14.252 0 0 1-1.585-1.05l-.455.596A14.999 14.999 0 0 1 3.076 54.1l.596-.455a14.24 14.24 0 0 1-1.05-1.585 10.259 10.259 0 0 1-.827-1.875l-.712.236C.674 49.188.42 47.783.262 46.105l.746-.07C.89 44.77.824 43.34.79 41.692l-.75.016Z"/><path fill="#fff" fill-rule="evenodd" d="M35.643 32.145c-.297-.743-.445-1.114-.401-1.275a.42.42 0 0 1 .182-.27c.134-.1.463-.1 1.123-.1.742 0 1.499.046 2.236-.05a6 6 0 0 0 5.166-5.166c.051-.39.051-.855.051-1.784 0-.928 0-1.393-.051-1.783a6 6 0 0 0-5.166-5.165c-.39-.052-.854-.052-1.783-.052h-7.72c-4.934 0-7.401 0-9.244 1.051a8 8 0 0 0-2.985 2.986C16.057 22.28 16.003 24.58 16 29 15.998 31.075 16 33.15 16 35.224A7.778 7.778 0 0 0 23.778 43H28.5c1.394 0 2.09 0 2.67-.116a6 6 0 0 0 4.715-4.714c.115-.58.115-1.301.115-2.744 0-1.31 0-1.964-.114-2.49a4.998 4.998 0 0 0-.243-.792Z" clip-rule="evenodd"/><path fill="#9EA9A9" fill-rule="evenodd" d="M37 18h-7.72c-2.494 0-4.266.002-5.647.126-1.361.122-2.197.354-2.854.728a6.5 6.5 0 0 0-2.425 2.426c-.375.657-.607 1.492-.729 2.853-.11 1.233-.123 2.777-.125 4.867 0 .7 0 1.05.097 1.181.096.13.182.181.343.2.163.02.518-.18 1.229-.581a6.195 6.195 0 0 1 3.053-.8H37c.977 0 1.32-.003 1.587-.038a4.5 4.5 0 0 0 3.874-3.874c.036-.268.039-.611.039-1.588 0-.976-.003-1.319-.038-1.587a4.5 4.5 0 0 0-3.875-3.874C38.32 18.004 37.977 18 37 18Zm-7.364 12.5h-7.414a4.722 4.722 0 0 0-4.722 4.723 6.278 6.278 0 0 0 6.278 6.278H28.5c1.466 0 1.98-.008 2.378-.087a4.5 4.5 0 0 0 3.535-3.536c.08-.397.087-.933.087-2.451 0-1.391-.009-1.843-.08-2.17a3.5 3.5 0 0 0-2.676-2.676c-.328-.072-.762-.08-2.108-.08Z" clip-rule="evenodd"/></g><defs><clipPath id="q"><path fill="#fff" d="M0 0h60v60H0z"/></clipPath></defs></svg>`,
  TOKEN_PLACEHOLDER: k`<svg width="60" height="60" viewBox="0 0 60 60" fill="none"><rect id="token-placeholder-fill" width="58" height="58" x="1" y="1" fill="#fff" rx="29"/><path fill="#3B4040" stroke="#fff" stroke-width="2" d="M32 10a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v5.566c0 .357.192.685.495.875a16.001 16.001 0 0 1 4.256 3.894c.667.88.33 2.113-.627 2.665l-2.494 1.44c-.956.552-2.166.204-2.913-.609a9.12 9.12 0 1 0 .064 12.267c.739-.82 1.945-1.181 2.907-.64l2.509 1.415c.962.542 1.312 1.77.654 2.658a16 16 0 0 1-4.356 4.028c-.303.19-.495.518-.495.875V50a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2.992c0-.602-.528-1.065-1.13-1.032-.579.032-1.16.032-1.74 0-.602-.032-1.13.43-1.13 1.032V50a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-5.566c0-.357-.192-.685-.495-.875a16 16 0 0 1 0-27.118c.303-.19.495-.517.495-.875V10a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2.992c0 .601.528 1.064 1.13 1.032.58-.032 1.161-.032 1.74 0 .602.033 1.13-.43 1.13-1.032V10Z"/><rect id="token-placeholder-dash" width="58" height="58" x="1" y="1" stroke="#000" stroke-dasharray="6 6" stroke-width="2" rx="29"/></svg>`,
  ACCOUNT_COPY: k`<svg width="14" height="14" fill="none" viewBox="0 0 14 14"><path fill="#fff" fill-rule="evenodd" d="M4.003 4.005c.012-1.225.074-1.936.391-2.491a3 3 0 0 1 1.12-1.12C6.204 0 7.136 0 9 0s2.795 0 3.486.394a3 3 0 0 1 1.12 1.12C14 2.204 14 3.136 14 5s0 2.795-.394 3.486a3 3 0 0 1-1.12 1.12c-.555.317-1.266.379-2.491.391l.002.003c-.012 1.222-.075 1.932-.391 2.486a3 3 0 0 1-1.12 1.12C7.796 14 6.864 14 5 14s-2.795 0-3.486-.394a3 3 0 0 1-1.12-1.12C0 11.796 0 10.864 0 9s0-2.795.394-3.486a3 3 0 0 1 1.12-1.12c.554-.316 1.264-.379 2.486-.391l.003.002ZM9 8.5c-.959 0-1.58-.001-2.05-.043-.45-.04-.613-.109-.693-.154a1.5 1.5 0 0 1-.56-.56c-.045-.08-.113-.243-.154-.693C5.501 6.58 5.5 5.959 5.5 5c0-.959.001-1.58.043-2.05.04-.45.109-.613.154-.693a1.5 1.5 0 0 1 .56-.56c.08-.045.243-.113.693-.154C7.42 1.501 8.041 1.5 9 1.5c.959 0 1.58.001 2.05.043.45.04.613.109.693.154a1.5 1.5 0 0 1 .56.56c.045.08.113.243.154.693.042.47.043 1.091.043 2.05 0 .959-.001 1.58-.043 2.05-.04.45-.109.613-.154.693a1.5 1.5 0 0 1-.56.56c-.08.045-.242.113-.693.154-.47.042-1.091.043-2.05.043ZM4 5.503a13.77 13.77 0 0 0-1.05.04c-.45.04-.613.109-.693.154a1.5 1.5 0 0 0-.56.56c-.045.08-.113.243-.154.693C1.501 7.42 1.5 8.041 1.5 9c0 .959.001 1.58.043 2.05.04.45.109.613.154.693a1.5 1.5 0 0 0 .56.56c.08.045.243.113.693.154.47.042 1.091.043 2.05.043.959 0 1.58-.001 2.05-.043.45-.04.613-.109.693-.154a1.5 1.5 0 0 0 .56-.56c.045-.08.113-.242.154-.693.025-.283.035-.619.04-1.05-1.534-.003-2.358-.037-2.983-.394a3 3 0 0 1-1.12-1.12c-.357-.625-.39-1.449-.394-2.983Z" clip-rule="evenodd"/></svg>`,
  ACCOUNT_DISCONNECT: k`<svg width="16" height="14" fill="none" viewBox="0 0 16 14"><path fill="#fff" d="M9.677 1.5h-2.61c-1.261 0-2.107.001-2.757.06-.629.056-.926.157-1.122.268a2.5 2.5 0 0 0-.933.933c-.112.196-.212.493-.269 1.122-.058.65-.06 1.496-.06 2.757v.72c0 1.26.002 2.107.06 2.756.057.63.157.927.27 1.123a2.5 2.5 0 0 0 .932.933c.196.111.493.212 1.122.268.65.059 1.496.06 2.757.06h2.61a.75.75 0 1 1 0 1.5h-2.61c-2.467 0-3.7 0-4.622-.525a4 4 0 0 1-1.493-1.493C.427 11.06.427 9.827.427 7.36v-.72c0-2.467 0-3.7.525-4.622A4 4 0 0 1 2.445.525C3.366 0 4.6 0 7.067 0h2.61a.75.75 0 1 1 0 1.5Z"/><path fill="#fff" d="M10.896 11.03a.75.75 0 0 1 0-1.06l1.793-1.793a.25.25 0 0 0-.176-.427H8.177a.75.75 0 0 1 0-1.5h4.336a.25.25 0 0 0 .176-.427L10.896 4.03a.75.75 0 0 1 1.061-1.06l3.323 3.323a1 1 0 0 1 0 1.414l-3.323 3.323a.75.75 0 0 1-1.06 0Z"/></svg>`
},
      Zt = {
  1: "692ed6ba-e569-459a-556a-776476829e00",
  42161: "600a9a04-c1b9-42ca-6785-9b4b6ff85200",
  43114: "30c46e53-e989-45fb-4549-be3bd4eb3b00",
  56: "93564157-2e8e-4ce7-81df-b264dbee9b00",
  250: "06b26297-fe0c-4733-5d6b-ffa5498aac00",
  10: "ab9c186a-c52f-464b-2906-ca59d760a400",
  137: "41d04d42-da3b-4453-8506-668cc0727900",
  100: "02b53f6a-e3d4-479e-1cb4-21178987d100",
  9001: "f926ff41-260d-4028-635e-91913fc28e00",
  324: "b310f07f-4ef7-49f3-7073-2a0a39685800",
  314: "5a73b3dd-af74-424e-cae0-0de859ee9400",
  4689: "34e68754-e536-40da-c153-6ef2e7188a00",
  1088: "3897a66d-40b9-4833-162f-a2c90531c900",
  1284: "161038da-44ae-4ec7-1208-0ea569454b00",
  1285: "f1d73bb6-5450-4e18-38f7-fb6484264a00"
};

var Z = (e => (e.metaMask = "metaMask", e.trust = "trust", e.phantom = "phantom", e.brave = "brave", e.spotEthWallet = "spotEthWallet", e.exodus = "exodus", e.tokenPocket = "tokenPocket", e.frame = "frame", e.tally = "tally", e.coinbaseWallet = "coinbaseWallet", e.core = "core", e.bitkeep = "bitkeep", e.mathWallet = "mathWallet", e.opera = "opera", e.tokenary = "tokenary", e["1inch"] = "1inch", e.kuCoinWallet = "kuCoinWallet", e.ledger = "ledger", e))(Z || {});

const J = {
  injectedPreset: {
    metaMask: {
      name: "MetaMask",
      icon: "619537c0-2ff3-4c78-9ed8-a05e7567f300",
      url: "https://metamask.io",
      isMobile: !0,
      isInjected: !0
    },
    trust: {
      name: "Trust",
      icon: "0528ee7e-16d1-4089-21e3-bbfb41933100",
      url: "https://trustwallet.com",
      isMobile: !0,
      isInjected: !0
    },
    spotEthWallet: {
      name: "Spot",
      icon: "1bf33a89-b049-4a1c-d1f6-4dd7419ee400",
      url: "https://www.spot-wallet.com",
      isMobile: !0,
      isInjected: !0
    },
    phantom: {
      name: "Phantom",
      icon: "62471a22-33cb-4e65-5b54-c3d9ea24b900",
      url: "https://phantom.app",
      isInjected: !0
    },
    core: {
      name: "Core",
      icon: "35f9c46e-cc57-4aa7-315d-e6ccb2a1d600",
      url: "https://core.app",
      isMobile: !0,
      isInjected: !0
    },
    bitkeep: {
      name: "BitKeep",
      icon: "3f7075d0-4ab7-4db5-404d-3e4c05e6fe00",
      url: "https://bitkeep.com",
      isMobile: !0,
      isInjected: !0
    },
    tokenPocket: {
      name: "TokenPocket",
      icon: "f3119826-4ef5-4d31-4789-d4ae5c18e400",
      url: "https://www.tokenpocket.pro",
      isMobile: !0,
      isInjected: !0
    },
    mathWallet: {
      name: "MathWallet",
      icon: "26a8f588-3231-4411-60ce-5bb6b805a700",
      url: "https://mathwallet.org",
      isMobile: !0,
      isInjected: !0
    },
    exodus: {
      name: "Exodus",
      icon: "4c16cad4-cac9-4643-6726-c696efaf5200",
      url: "https://www.exodus.com",
      isMobile: !0,
      isDesktop: !0,
      isInjected: !0
    },
    kuCoinWallet: {
      name: "KuCoin Wallet",
      icon: "1e47340b-8fd7-4ad6-17e7-b2bd651fae00",
      url: "https://kuwallet.com",
      isMobile: !0,
      isInjected: !0
    },
    ledger: {
      name: "Ledger",
      icon: "a7f416de-aa03-4c5e-3280-ab49269aef00",
      url: "https://www.ledger.com",
      isDesktop: !0
    },
    brave: {
      name: "Brave",
      icon: "125e828e-9936-4451-a8f2-949c119b7400",
      url: "https://brave.com/wallet",
      isInjected: !0
    },
    frame: {
      name: "Frame",
      icon: "cd492418-ea85-4ef1-aeed-1c9e20b58900",
      url: "https://frame.sh",
      isInjected: !0
    },
    tally: {
      name: "Tally",
      icon: "98d2620c-9fc8-4a1c-31bc-78d59d00a300",
      url: "https://tallyho.org",
      isInjected: !0
    },
    coinbaseWallet: {
      name: "Coinbase",
      icon: "f8068a7f-83d7-4190-1f94-78154a12c600",
      url: "https://www.coinbase.com/wallet",
      isInjected: !0
    },
    opera: {
      name: "Opera",
      icon: "877fa1a4-304d-4d45-ca8e-f76d1a556f00",
      url: "https://www.opera.com/crypto",
      isInjected: !0
    },
    tokenary: {
      name: "Tokenary",
      icon: "5e481041-dc3c-4a81-373a-76bbde91b800",
      url: "https://tokenary.io",
      isDesktop: !0,
      isInjected: !0
    },
    ["1inch"]: {
      name: "1inch Wallet",
      icon: "dce1ee99-403f-44a9-9f94-20de30616500",
      url: "https://1inch.io/wallet",
      isMobile: !0
    }
  },

  getInjectedId(e) {
    if (e.toUpperCase() !== "INJECTED" && e.length) return e;
    const {
      ethereum: t,
      spotEthWallet: a,
      coinbaseWalletExtension: n
    } = window;
    return t ? t.isTrust || t.isTrustWallet ? "trust" : t.isPhantom ? "phantom" : t.isBraveWallet ? "brave" : a ? "spotEthWallet" : t.isExodus ? "exodus" : t.isTokenPocket ? "tokenPocket" : t.isFrame ? "frame" : t.isTally ? "tally" : n ? "coinbaseWallet" : t.isAvalanche ? "core" : t.isBitKeep ? "bitkeep" : t.isMathWallet ? "mathWallet" : t.isOpera ? "opera" : t.isTokenary ? "tokenary" : t.isOneInchIOSWallet || t.isOneInchAndroidWallet ? "1inch" : t.isKuCoinWallet ? "kuCoinWallet" : t.isMetaMask ? "metaMask" : "injected" : "metaMask";
  },

  getInjectedName(e) {
    var t, a;
    if (e.length && e.toUpperCase() !== "INJECTED") return e;
    const n = J.getInjectedId("");
    return (a = (t = J.injectedPreset[n]) == null ? void 0 : t.name) != null ? a : "Injected";
  }

},
      Ft = {
  ETH: {
    icon: "692ed6ba-e569-459a-556a-776476829e00"
  },
  WETH: {
    icon: "692ed6ba-e569-459a-556a-776476829e00"
  },
  AVAX: {
    icon: "30c46e53-e989-45fb-4549-be3bd4eb3b00"
  },
  FTM: {
    icon: "06b26297-fe0c-4733-5d6b-ffa5498aac00"
  },
  BNB: {
    icon: "93564157-2e8e-4ce7-81df-b264dbee9b00"
  },
  MATIC: {
    icon: "41d04d42-da3b-4453-8506-668cc0727900"
  },
  OP: {
    icon: "ab9c186a-c52f-464b-2906-ca59d760a400"
  },
  xDAI: {
    icon: "02b53f6a-e3d4-479e-1cb4-21178987d100"
  },
  EVMOS: {
    icon: "f926ff41-260d-4028-635e-91913fc28e00"
  },
  METIS: {
    icon: "3897a66d-40b9-4833-162f-a2c90531c900"
  },
  IOTX: {
    icon: "34e68754-e536-40da-c153-6ef2e7188a00"
  }
};

var zt = Object.defineProperty,
    pt = Object.getOwnPropertySymbols,
    Vt = Object.prototype.hasOwnProperty,
    Gt = Object.prototype.propertyIsEnumerable,
    ut = (e, t, a) => t in e ? zt(e, t, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: a
}) : e[t] = a,
    qt = (e, t) => {
  for (var a in t || (t = {})) Vt.call(t, a) && ut(e, a, t[a]);

  if (pt) for (var a of pt(t)) Gt.call(t, a) && ut(e, a, t[a]);
  return e;
};

const h = {
  MOBILE_BREAKPOINT: 600,
  W3M_RECENT_WALLET: "W3M_RECENT_WALLET",

  rejectStandaloneButtonComponent() {
    const {
      isStandalone: e
    } = p.state;
    if (e) throw new Error("Web3Modal button components are not available in standalone mode.");
  },

  getShadowRootElement(e, t) {
    const a = e.renderRoot.querySelector(t);
    if (!a) throw new Error(`${t} not found`);
    return a;
  },

  getWalletId(e) {
    return J.getInjectedId(e);
  },

  getWalletIcon(e) {
    var t, a;
    const n = (t = J.injectedPreset[e]) == null ? void 0 : t.icon,
          {
      projectId: o,
      walletImages: r
    } = j.state;
    return (a = r === null || r === void 0 ? void 0 : r[e]) != null ? a : o && n ? S.getImageUrl(n) : "";
  },

  getWalletName(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    const a = J.getInjectedName(e);
    return t ? a.split(" ")[0] : a;
  },

  getChainIcon(e) {
    var t;
    const a = Zt[e],
          {
      projectId: n,
      chainImages: o
    } = j.state;
    return (t = o === null || o === void 0 ? void 0 : o[e]) != null ? t : n && a ? S.getImageUrl(a) : "";
  },

  getTokenIcon(e) {
    var t, a;
    const n = (t = Ft[e]) == null ? void 0 : t.icon,
          {
      projectId: o,
      tokenImages: r
    } = j.state;
    return (a = r === null || r === void 0 ? void 0 : r[e]) != null ? a : o && n ? S.getImageUrl(n) : "";
  },

  isMobileAnimation() {
    return window.innerWidth <= h.MOBILE_BREAKPOINT;
  },

  async preloadImage(e) {
    return new Promise((t, a) => {
      const n = new Image();
      n.onload = t, n.onerror = a, n.src = e;
    });
  },

  getErrorMessage(e) {
    return e instanceof Error ? e.message : "Unknown Error";
  },

  debounce(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    let a;
    return function () {
      for (var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++) {
        n[_key] = arguments[_key];
      }

      function o() {
        e(...n);
      }

      a && clearTimeout(a), a = setTimeout(o, t);
    };
  },

  async handleMobileLinking(e) {
    const {
      standaloneUri: t,
      selectedChain: a
    } = p.state,
          {
      links: n,
      name: o
    } = e;

    function r(i) {
      let c = "";
      n != null && n.universal ? c = W.formatUniversalUrl(n.universal, i, o) : n != null && n.native && (c = W.formatNativeUrl(n.native, i, o)), W.openHref(c);
    }

    t ? (h.setRecentWallet(e), r(t)) : (await L.client().connectWalletConnect(i => {
      r(i);
    }, a === null || a === void 0 ? void 0 : a.id), h.setRecentWallet(e), _.close());
  },

  async handleAndroidLinking() {
    const {
      standaloneUri: e,
      selectedChain: t
    } = p.state;
    e ? W.openHref(e) : (await L.client().connectWalletConnect(a => {
      W.setWalletConnectAndroidDeepLink(a), W.openHref(a);
    }, t === null || t === void 0 ? void 0 : t.id), _.close());
  },

  async handleUriCopy() {
    const {
      standaloneUri: e
    } = p.state;
    if (e) await navigator.clipboard.writeText(e);else {
      const t = L.client().walletConnectUri;
      await navigator.clipboard.writeText(t);
    }
    D.openToast("Link copied", "success");
  },

  async handleConnectorConnection(e, t) {
    try {
      const {
        selectedChain: a
      } = p.state;
      await L.client().connectConnector(e, a === null || a === void 0 ? void 0 : a.id), _.close();
    } catch (a) {
      console.error(a), t ? t() : D.openToast(h.getErrorMessage(a), "error");
    }
  },

  getCustomWallets() {
    var e;
    const {
      desktopWallets: t,
      mobileWallets: a
    } = j.state;
    return (e = W.isMobile() ? a : t) != null ? e : [];
  },

  getCustomImageUrls() {
    const {
      chainImages: e,
      walletImages: t
    } = j.state,
          a = Object.values(e !== null && e !== void 0 ? e : {}),
          n = Object.values(t !== null && t !== void 0 ? t : {});
    return Object.values([...a, ...n]);
  },

  getConnectorImageUrls() {
    return L.client().getConnectors().map(_ref9 => {
      let {
        id: e
      } = _ref9;
      return J.getInjectedId(e);
    }).map(e => h.getWalletIcon(e));
  },

  truncate(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
    return e.length <= t ? e : `${e.substring(0, 4)}...${e.substring(e.length - 4)}`;
  },

  generateAvatarColors(e) {
    var t;
    const a = (t = e.match(/.{1,7}/g)) == null ? void 0 : t.splice(0, 5),
          n = [];
    a === null || a === void 0 ? void 0 : a.forEach(r => {
      let i = 0;

      for (let m = 0; m < r.length; m += 1) i = r.charCodeAt(m) + ((i << 5) - i), i = i & i;

      const c = [0, 0, 0];

      for (let m = 0; m < 3; m += 1) {
        const s = i >> m * 8 & 255;
        c[m] = s;
      }

      n.push(`rgb(${c[0]}, ${c[1]}, ${c[2]})`);
    });
    const o = document.querySelector(":root");

    if (o) {
      const r = {
        "--w3m-color-av-1": n[0],
        "--w3m-color-av-2": n[1],
        "--w3m-color-av-3": n[2],
        "--w3m-color-av-4": n[3],
        "--w3m-color-av-5": n[4]
      };
      Object.entries(r).forEach(_ref10 => {
        let [i, c] = _ref10;
        return o.style.setProperty(i, c);
      });
    }
  },

  setRecentWallet(e) {
    const {
      walletConnectVersion: t
    } = p.state;
    localStorage.setItem(h.W3M_RECENT_WALLET, JSON.stringify({
      [t]: e
    }));
  },

  getRecentWallet() {
    const e = localStorage.getItem(h.W3M_RECENT_WALLET);

    if (e) {
      const {
        walletConnectVersion: t
      } = p.state,
            a = JSON.parse(e);
      if (a[t]) return a[t];
    }
  },

  getExtensionWallets() {
    const e = [];

    for (const [t, a] of Object.entries(J.injectedPreset)) t !== Z.coinbaseWallet && a && a.isInjected && !a.isDesktop && e.push(qt({
      id: t
    }, a));

    return e;
  },

  caseSafeIncludes(e, t) {
    return e.toUpperCase().includes(t.toUpperCase());
  }

},
      Kt = y`#w3m-transparent-noise,.w3m-canvas,.w3m-color-placeholder,.w3m-gradient-placeholder,.w3m-highlight{inset:0;position:absolute;display:block;pointer-events:none;width:100%;height:100px;border-radius:8px 8px 0 0;transform:translateY(-5px)}.w3m-gradient-placeholder{background:linear-gradient(var(--w3m-gradient-1),var(--w3m-gradient-2),var(--w3m-gradient-3),var(--w3m-gradient-4))}.w3m-color-placeholder{background-color:var(--w3m-color-fg-accent)}.w3m-highlight{border:1px solid var(--w3m-color-overlay)}.w3m-canvas{opacity:0;transition:opacity 2s ease;box-shadow:0 8px 28px -6px rgba(10,16,31,.12),0 18px 88px -4px rgba(10,16,31,.14)}.w3m-canvas-visible{opacity:1}#w3m-transparent-noise{mix-blend-mode:multiply;opacity:.35}.w3m-toolbar{height:28px;display:flex;position:relative;margin:5px 15px 5px 5px;justify-content:space-between;align-items:center}.w3m-toolbar img,.w3m-toolbar svg{height:28px;object-position:left center;object-fit:contain}#w3m-wc-logo path{fill:var(--w3m-color-fg-inverse)}.w3m-action-btn{width:28px;height:28px;border-radius:50%;border:0;display:flex;justify-content:center;align-items:center;cursor:pointer;transition:background-color,.2s ease;background-color:var(--w3m-color-bg-1);box-shadow:0 0 0 1px var(--w3m-color-overlay),0 2px 4px -2px rgba(0,0,0,.12),0 4px 4px -2px rgba(0,0,0,.08)}.w3m-action-btn:hover{background-color:var(--w3m-color-bg-2)}.w3m-action-btn svg{display:block;object-position:center}.w3m-action-btn path{fill:var(--w3m-color-fg-1)}.w3m-actions{display:flex}.w3m-actions button:first-child{margin-right:16px}.w3m-help-active button:first-child{background-color:var(--w3m-color-fg-1)}.w3m-help-active button:first-child path{fill:var(--w3m-color-bg-1)}`;

var Yt = Object.defineProperty,
    Xt = Object.getOwnPropertyDescriptor,
    Ne = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Xt(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Yt(t, a, o), o;
};

const vt = new Bt();
let ce = class extends w {
  constructor() {
    super(), this.open = !1, this.isHelp = !1, this.unsubscribeRouter = void 0, this.playTimeout = void 0, this.unsubscribeRouter = I.subscribe(e => {
      this.isHelp = e.view === "Help";
    });
  }

  firstUpdated() {
    const {
      themeBackground: e
    } = j.state;
    e === "gradient" && (this.playTimeout = setTimeout(() => {
      vt.play(this.canvasEl), this.open = !0;
    }, 800));
  }

  disconnectedCallback() {
    var e;
    (e = this.unsubscribeRouter) == null || e.call(this), clearTimeout(this.playTimeout), vt.stop();
  }

  get canvasEl() {
    return h.getShadowRootElement(this, ".w3m-canvas");
  }

  onHelp() {
    I.push("Help");
  }

  render() {
    const {
      themeBackground: e
    } = j.state,
          t = {
      "w3m-canvas": !0,
      "w3m-canvas-visible": this.open
    },
          a = {
      "w3m-actions": !0,
      "w3m-help-active": this.isHelp
    };
    return l`${e === "themeColor" ? l`<div class="w3m-color-placeholder"></div>` : null} ${e === "gradient" ? l`<div class="w3m-gradient-placeholder"></div><canvas class="${T(t)}"></canvas>${g.NOISE_TEXTURE}` : null}<div class="w3m-highlight"></div><div class="w3m-toolbar">${g.WALLET_CONNECT_LOGO}<div class="${T(a)}"><button class="w3m-action-btn" @click="${this.onHelp}">${g.HELP_ICON}</button> <button class="w3m-action-btn" @click="${_.close}">${g.CROSS_ICON}</button></div></div>`;
  }

};
ce.styles = [u.globalCss, Kt], Ne([$()], ce.prototype, "open", 2), Ne([$()], ce.prototype, "isHelp", 2), ce = Ne([b("w3m-modal-backcard")], ce);
const Qt = y`main{padding:20px;padding-top:0;width:100%}`;

var Jt = Object.defineProperty,
    eo = Object.getOwnPropertyDescriptor,
    to = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? eo(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Jt(t, a, o), o;
};

let Re = class extends w {
  render() {
    return l`<main><slot></slot></main>`;
  }

};
Re.styles = [u.globalCss, Qt], Re = to([b("w3m-modal-content")], Re);
const oo = y`footer{padding:10px;display:flex;flex-direction:column;align-items:inherit;justify-content:inherit;border-top:1px solid var(--w3m-color-bg-2)}`;

var ao = Object.defineProperty,
    no = Object.getOwnPropertyDescriptor,
    ro = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? no(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && ao(t, a, o), o;
};

let Be = class extends w {
  render() {
    return l`<footer><slot></slot></footer>`;
  }

};
Be.styles = [u.globalCss, oo], Be = ro([b("w3m-modal-footer")], Be);
const io = y`header{display:flex;justify-content:center;align-items:center;padding:20px;position:relative}.w3m-border{border-bottom:1px solid var(--w3m-color-bg-2);margin-bottom:20px}header button{padding:15px 20px;transition:opacity .2s ease}@media(hover:hover){header button:hover{opacity:.5}}.w3m-back-btn{position:absolute;left:0}.w3m-action-btn{position:absolute;right:0}path{fill:var(--w3m-color-fg-accent)}`;

var lo = Object.defineProperty,
    so = Object.getOwnPropertyDescriptor,
    de = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? so(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && lo(t, a, o), o;
};

let q = class extends w {
  constructor() {
    super(...arguments), this.title = "", this.onAction = void 0, this.actionIcon = void 0, this.border = !1;
  }

  backBtnTemplate() {
    return l`<button class="w3m-back-btn" @click="${I.goBack}">${g.BACK_ICON}</button>`;
  }

  actionBtnTemplate() {
    return l`<button class="w3m-action-btn" @click="${this.onAction}">${this.actionIcon}</button>`;
  }

  render() {
    const e = {
      "w3m-border": this.border
    },
          t = I.state.history.length > 1,
          a = this.title ? l`<w3m-text variant="large-bold">${this.title}</w3m-text>` : l`<slot></slot>`;
    return l`<header class="${T(e)}">${t ? this.backBtnTemplate() : null} ${a} ${this.onAction ? this.actionBtnTemplate() : null}</header>`;
  }

};
q.styles = [u.globalCss, io], de([f()], q.prototype, "title", 2), de([f()], q.prototype, "onAction", 2), de([f()], q.prototype, "actionIcon", 2), de([f()], q.prototype, "border", 2), q = de([b("w3m-modal-header")], q);
const co = y`.w3m-router{overflow:hidden;will-change:transform}.w3m-content{display:flex;flex-direction:column}`;

var ho = Object.defineProperty,
    mo = Object.getOwnPropertyDescriptor,
    Ue = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? mo(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && ho(t, a, o), o;
};

let he = class extends w {
  constructor() {
    super(), this.view = I.state.view, this.prevView = I.state.view, this.unsubscribe = void 0, this.oldHeight = "0px", this.resizeObserver = void 0, this.unsubscribe = I.subscribe(e => {
      this.view !== e.view && this.onChangeRoute();
    });
  }

  firstUpdated() {
    this.resizeObserver = new ResizeObserver(_ref11 => {
      let [e] = _ref11;
      const t = `${e.contentRect.height}px`;
      this.oldHeight !== "0px" && (V(this.routerEl, {
        height: [this.oldHeight, t]
      }, {
        duration: .2
      }), V(this.routerEl, {
        opacity: [0, 1],
        scale: [.99, 1]
      }, {
        duration: .37,
        delay: .03
      })), this.oldHeight = t;
    }), this.resizeObserver.observe(this.contentEl);
  }

  disconnectedCallback() {
    var e, t;
    (e = this.unsubscribe) == null || e.call(this), (t = this.resizeObserver) == null || t.disconnect();
  }

  get routerEl() {
    return h.getShadowRootElement(this, ".w3m-router");
  }

  get contentEl() {
    return h.getShadowRootElement(this, ".w3m-content");
  }

  viewTemplate() {
    switch (this.view) {
      case "ConnectWallet":
        return l`<w3m-connect-wallet-view></w3m-connect-wallet-view>`;

      case "SelectNetwork":
        return l`<w3m-select-network-view></w3m-select-network-view>`;

      case "InjectedConnector":
        return l`<w3m-injected-connector-view></w3m-injected-connector-view>`;

      case "InstallConnector":
        return l`<w3m-install-connector-view></w3m-install-connector-view>`;

      case "GetWallet":
        return l`<w3m-get-wallet-view></w3m-get-wallet-view>`;

      case "DesktopConnector":
        return l`<w3m-desktop-connector-view></w3m-desktop-connector-view>`;

      case "WalletExplorer":
        return l`<w3m-wallet-explorer-view></w3m-wallet-explorer-view>`;

      case "Qrcode":
        return l`<w3m-qrcode-view></w3m-qrcode-view>`;

      case "Help":
        return l`<w3m-help-view></w3m-help-view>`;

      case "Account":
        return l`<w3m-account-view></w3m-account-view>`;

      case "SwitchNetwork":
        return l`<w3m-switch-network-view></w3m-switch-network-view>`;

      default:
        return l`<div>Not Found</div>`;
    }
  }

  async onChangeRoute() {
    await V(this.routerEl, {
      opacity: [1, 0],
      scale: [1, 1.02]
    }, {
      duration: .15
    }).finished, this.view = I.state.view;
  }

  render() {
    return l`<div class="w3m-router"><div class="w3m-content">${this.viewTemplate()}</div></div>`;
  }

};
he.styles = [u.globalCss, co], Ue([$()], he.prototype, "view", 2), Ue([$()], he.prototype, "prevView", 2), he = Ue([b("w3m-modal-router")], he);
const po = y`div{height:36px;width:max-content;display:flex;justify-content:center;align-items:center;padding:10px 15px;position:absolute;top:12px;box-shadow:0 6px 14px -6px rgba(10,16,31,.3),0 10px 32px -4px rgba(10,16,31,.15);z-index:2;left:50%;transform:translateX(-50%);pointer-events:none;backdrop-filter:blur(20px) saturate(1.8);-webkit-backdrop-filter:blur(20px) saturate(1.8);border-radius:36px;border:1px solid var(--w3m-color-overlay);background-color:var(--w3m-color-overlay)}svg{margin-right:5px}@-moz-document url-prefix(){div{background-color:var(--w3m-color-bg-3)}}.w3m-success path{fill:var(--w3m-color-fg-accent)}.w3m-error path{fill:var(--w3m-color-err)}`;

var uo = Object.defineProperty,
    vo = Object.getOwnPropertyDescriptor,
    gt = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? vo(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && uo(t, a, o), o;
};

let $e = class extends w {
  constructor() {
    super(), this.open = !1, this.unsubscribe = void 0, this.timeout = void 0, this.unsubscribe = D.subscribe(e => {
      e.open ? (this.open = !0, this.timeout = setTimeout(() => D.closeToast(), 2200)) : (this.open = !1, clearTimeout(this.timeout));
    });
  }

  disconnectedCallback() {
    var e;
    (e = this.unsubscribe) == null || e.call(this), clearTimeout(this.timeout), D.closeToast();
  }

  render() {
    const {
      message: e,
      variant: t
    } = D.state,
          a = {
      "w3m-success": t === "success",
      "w3m-error": t === "error"
    };
    return this.open ? l`<div class="${T(a)}">${t === "success" ? g.CHECKMARK_ICON : null} ${t === "error" ? g.CROSS_ICON : null}<w3m-text variant="small-normal">${e}</w3m-text></div>` : null;
  }

};
$e.styles = [u.globalCss, po], gt([$()], $e.prototype, "open", 2), $e = gt([b("w3m-modal-toast")], $e);
const go = y`button{padding:5px;border-radius:10px;transition:all .2s ease;display:flex;flex-direction:column;align-items:center;justify-content:center;width:80px;height:90px}w3m-network-image{width:54px;height:59px}w3m-text{width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center;margin-top:5px}button:hover{background-color:var(--w3m-color-overlay)}`;

var wo = Object.defineProperty,
    bo = Object.getOwnPropertyDescriptor,
    Oe = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? bo(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && wo(t, a, o), o;
};

let oe = class extends w {
  constructor() {
    super(...arguments), this.onClick = () => null, this.name = "", this.chainId = "";
  }

  render() {
    return l`<button @click="${this.onClick}"><w3m-network-image chainId="${this.chainId}"></w3m-network-image><w3m-text variant="xsmall-normal">${this.name}</w3m-text></button>`;
  }

};
oe.styles = [u.globalCss, go], Oe([f()], oe.prototype, "onClick", 2), Oe([f()], oe.prototype, "name", 2), Oe([f()], oe.prototype, "chainId", 2), oe = Oe([b("w3m-network-button")], oe);
const fo = y`div{width:inherit;height:inherit}.polygon-stroke{stroke:var(--w3m-color-overlay)}svg{width:100%;height:100%;margin:0}#network-placeholder-fill{fill:var(--w3m-color-bg-3)}#network-placeholder-dash{stroke:var(--w3m-color-overlay)}`;

var yo = Object.defineProperty,
    xo = Object.getOwnPropertyDescriptor,
    wt = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? xo(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && yo(t, a, o), o;
};

let Ie = class extends w {
  constructor() {
    super(...arguments), this.chainId = "";
  }

  render() {
    const e = h.getChainIcon(this.chainId);
    return e ? l`<div><svg width="54" height="59" viewBox="0 0 54 59" fill="none"><defs><clipPath id="polygon"><path d="M17.033 4.964c3.852-2.262 5.778-3.393 7.84-3.77a11.807 11.807 0 0 1 4.254 0c2.062.377 3.988 1.508 7.84 3.77l6.066 3.562c3.852 2.263 5.777 3.394 7.13 5.022a12.268 12.268 0 0 1 2.127 3.747c.71 2.006.71 4.268.71 8.793v7.124c0 4.525 0 6.787-.71 8.793a12.268 12.268 0 0 1-2.126 3.747c-1.354 1.628-3.28 2.76-7.131 5.022l-6.066 3.562c-3.852 2.262-5.778 3.393-7.84 3.771a11.814 11.814 0 0 1-4.254 0c-2.062-.378-3.988-1.509-7.84-3.77l-6.066-3.563c-3.852-2.263-5.778-3.394-7.13-5.022a12.268 12.268 0 0 1-2.127-3.747C1 40 1 37.737 1 33.212v-7.124c0-4.525 0-6.787.71-8.793a12.268 12.268 0 0 1 2.127-3.747c1.352-1.628 3.278-2.76 7.13-5.022l6.066-3.562Z"/></clipPath></defs><image clip-path="url(#polygon)" href="${e}" width="58" height="59" x="-2" y="0"/><path class="polygon-stroke" d="M17.22 5.295c3.877-2.277 5.737-3.363 7.72-3.726a11.44 11.44 0 0 1 4.12 0c1.983.363 3.844 1.45 7.72 3.726l6.065 3.562c3.876 2.276 5.731 3.372 7.032 4.938a11.896 11.896 0 0 1 2.06 3.63c.683 1.928.688 4.11.688 8.663v7.124c0 4.553-.005 6.735-.688 8.664a11.896 11.896 0 0 1-2.06 3.63c-1.3 1.565-3.156 2.66-7.032 4.937l-6.065 3.563c-3.877 2.276-5.737 3.362-7.72 3.725a11.46 11.46 0 0 1-4.12 0c-1.983-.363-3.844-1.449-7.72-3.726l-6.065-3.562c-3.876-2.276-5.731-3.372-7.032-4.938a11.885 11.885 0 0 1-2.06-3.63c-.682-1.928-.688-4.11-.688-8.663v-7.124c0-4.553.006-6.735.688-8.664a11.885 11.885 0 0 1 2.06-3.63c1.3-1.565 3.156-2.66 7.032-4.937l6.065-3.562Z" stroke="#fff"/></svg></div>` : l`${g.NETWORK_PLACEHOLDER}`;
  }

};
Ie.styles = [u.globalCss, fo], wt([f()], Ie.prototype, "chainId", 2), Ie = wt([b("w3m-network-image")], Ie);
const Co = .1,
      bt = 2.5,
      F = 7;

function He(e, t, a) {
  return e === t ? !1 : (e - t < 0 ? t - e : e - t) <= a + Co;
}

function ko(e, t) {
  const a = Array.prototype.slice.call(Ot.create(e, {
    errorCorrectionLevel: t
  }).modules.data, 0),
        n = Math.sqrt(a.length);
  return a.reduce((o, r, i) => (i % n === 0 ? o.push([r]) : o[o.length - 1].push(r)) && o, []);
}

const $o = {
  generate(e, t, a, n) {
    const o = n === "light" ? "#141414" : "#fff",
          r = n === "light" ? "#fff" : "#141414",
          i = [],
          c = ko(e, "Q"),
          m = t / c.length,
          s = [{
      x: 0,
      y: 0
    }, {
      x: 1,
      y: 0
    }, {
      x: 0,
      y: 1
    }];
    s.forEach(_ref12 => {
      let {
        x: E,
        y: x
      } = _ref12;
      const A = (c.length - F) * m * E,
            M = (c.length - F) * m * x,
            P = .32;

      for (let U = 0; U < s.length; U += 1) {
        const ee = m * (F - U * 2);
        i.push(De`<rect fill="${U % 2 === 0 ? o : r}" height="${ee}" rx="${ee * P}" ry="${ee * P}" width="${ee}" x="${A + m * U}" y="${M + m * U}">`);
      }
    });
    const d = Math.floor((a + 25) / m),
          v = c.length / 2 - d / 2,
          O = c.length / 2 + d / 2 - 1,
          C = [];
    c.forEach((E, x) => {
      E.forEach((A, M) => {
        if (c[x][M] && !(x < F && M < F || x > c.length - (F + 1) && M < F || x < F && M > c.length - (F + 1)) && !(x > v && x < O && M > v && M < O)) {
          const P = x * m + m / 2,
                U = M * m + m / 2;
          C.push([P, U]);
        }
      });
    });
    const N = {};
    return C.forEach(_ref13 => {
      let [E, x] = _ref13;
      N[E] ? N[E].push(x) : N[E] = [x];
    }), Object.entries(N).map(_ref14 => {
      let [E, x] = _ref14;
      const A = x.filter(M => x.every(P => !He(M, P, m)));
      return [Number(E), A];
    }).forEach(_ref15 => {
      let [E, x] = _ref15;
      x.forEach(A => {
        i.push(De`<circle cx="${E}" cy="${A}" fill="${o}" r="${m / bt}">`);
      });
    }), Object.entries(N).filter(_ref16 => {
      let [E, x] = _ref16;
      return x.length > 1;
    }).map(_ref17 => {
      let [E, x] = _ref17;
      const A = x.filter(M => x.some(P => He(M, P, m)));
      return [Number(E), A];
    }).map(_ref18 => {
      let [E, x] = _ref18;
      x.sort((M, P) => M < P ? -1 : 1);
      const A = [];

      for (const M of x) {
        const P = A.find(U => U.some(ee => He(M, ee, m)));
        P ? P.push(M) : A.push([M]);
      }

      return [E, A.map(M => [M[0], M[M.length - 1]])];
    }).forEach(_ref19 => {
      let [E, x] = _ref19;
      x.forEach(_ref20 => {
        let [A, M] = _ref20;
        i.push(De`<line x1="${E}" x2="${E}" y1="${A}" y2="${M}" stroke="${o}" stroke-width="${m / (bt / 2)}" stroke-linecap="round">`);
      });
    }), i;
  }

},
      Oo = y`@keyframes fadeIn{0%{opacity:0}100%{opacity:1}}div{position:relative;user-select:none;display:block;overflow:hidden;width:100%;aspect-ratio:1/1;animation:fadeIn ease .2s}svg:first-child,w3m-wallet-image{position:absolute;top:50%;left:50%;transform:translateY(-50%) translateX(-50%)}w3m-wallet-image{transform:translateY(-50%) translateX(-50%)}w3m-wallet-image{width:25%;height:25%;border-radius:15px}svg:first-child{transform:translateY(-50%) translateX(-50%) scale(.9)}svg:first-child path:first-child{fill:var(--w3m-color-fg-accent)}svg:first-child path:last-child{stroke:var(--w3m-color-overlay)}`;

var Io = Object.defineProperty,
    Eo = Object.getOwnPropertyDescriptor,
    me = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Eo(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Io(t, a, o), o;
};

let K = class extends w {
  constructor() {
    super(...arguments), this.uri = "", this.size = 0, this.logoSrc = "", this.walletId = "";
  }

  svgTemplate() {
    var e;
    const t = (e = j.state.themeMode) != null ? e : "light";
    return De`<svg height="${this.size}" width="${this.size}">${$o.generate(this.uri, this.size, this.size / 4, t)}</svg>`;
  }

  render() {
    return l`<div>${this.walletId || this.logoSrc ? l`<w3m-wallet-image walletId="${B(this.walletId)}" src="${B(this.logoSrc)}"></w3m-wallet-image>` : g.WALLET_CONNECT_ICON_COLORED} ${this.svgTemplate()}</div>`;
  }

};
K.styles = [u.globalCss, Oo], me([f()], K.prototype, "uri", 2), me([f({
  type: Number
})], K.prototype, "size", 2), me([f()], K.prototype, "logoSrc", 2), me([f()], K.prototype, "walletId", 2), K = me([b("w3m-qrcode")], K);
const Mo = y`:host{position:relative;height:28px;width:75%}input{width:100%;height:100%;line-height:28px!important;border-radius:28px;font-style:normal;font-family:-apple-system,system-ui,BlinkMacSystemFont,'Segoe UI',Roboto,Ubuntu,'Helvetica Neue',sans-serif;font-feature-settings:'case' on;font-weight:500;font-size:16px;letter-spacing:-.03em;padding:0 10px 0 34px;transition:.2s all ease;color:transparent;position:absolute;background-color:var(--w3m-color-bg-3);box-shadow:inset 0 0 0 1px var(--w3m-color-overlay)}input::placeholder{color:transparent}svg{margin-right:4px}.w3m-placeholder{top:0;left:50%;transform:translateX(-50%);transition:.2s all ease;pointer-events:none;display:flex;align-items:center;justify-content:center;height:100%;width:fit-content;position:relative}input:focus-within+.w3m-placeholder,input:not(:placeholder-shown)+.w3m-placeholder{transform:translateX(10px);left:0}w3m-text{opacity:1;transition:.2s opacity ease}input:focus-within+.w3m-placeholder w3m-text,input:not(:placeholder-shown)+.w3m-placeholder w3m-text{opacity:0}input:focus-within,input:not(:placeholder-shown){color:var(--w3m-color-fg-1)}input:focus-within{box-shadow:inset 0 0 0 1px var(--w3m-color-fg-accent)}path{fill:var(--w3m-color-fg-2)}`;

var Wo = Object.defineProperty,
    Ao = Object.getOwnPropertyDescriptor,
    ft = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Ao(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Wo(t, a, o), o;
};

let Ee = class extends w {
  constructor() {
    super(...arguments), this.onChange = () => null;
  }

  render() {
    const e = W.isMobile() ? "Search mobile wallets" : "Search desktop wallets";
    return l`<input type="text" @input="${this.onChange}" placeholder="${e}"><div class="w3m-placeholder">${g.SEARCH_ICON}<w3m-text color="secondary" variant="medium-thin">${e}</w3m-text></div>`;
  }

};
Ee.styles = [u.globalCss, Mo], ft([f()], Ee.prototype, "onChange", 2), Ee = ft([b("w3m-search-input")], Ee);
const Lo = y`@keyframes rotate{100%{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}100%{stroke-dasharray:90,150;stroke-dashoffset:-124}}svg{animation:rotate 2s linear infinite;display:flex;justify-content:center;align-items:center}svg circle{stroke-linecap:round;animation:dash 1.5s ease infinite;stroke:var(--w3m-color-fg-accent)}`;

var jo = Object.defineProperty,
    So = Object.getOwnPropertyDescriptor,
    Po = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? So(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && jo(t, a, o), o;
};

let Ze = class extends w {
  render() {
    return l`<svg viewBox="0 0 50 50" width="24" height="24"><circle cx="25" cy="25" r="20" fill="none" stroke-width="4" stroke="#fff"/></svg>`;
  }

};
Ze.styles = [u.globalCss, Lo], Ze = Po([b("w3m-spinner")], Ze);

const _o = y`span{font-style:normal;font-family:-apple-system,system-ui,BlinkMacSystemFont,'Segoe UI',Roboto,Ubuntu,'Helvetica Neue',sans-serif;font-feature-settings:'tnum' on,'lnum' on,'case' on}.w3m-xxsmall-bold{font-weight:700;font-size:10px;line-height:12px;letter-spacing:.02em;text-transform:uppercase}.w3m-xsmall-normal{font-weight:600;font-size:12px;line-height:14px;letter-spacing:-.03em}.w3m-small-thin{font-weight:500;font-size:14px;line-height:16px;letter-spacing:-.03em}.w3m-small-normal{font-weight:600;font-size:14px;line-height:16px;letter-spacing:-.03em}.w3m-medium-thin{font-weight:500;font-size:16px;line-height:20px;letter-spacing:-.03em}.w3m-medium-normal{font-weight:600;font-size:16px;line-height:20px;letter-spacing:-.03em}.w3m-medium-bold{font-weight:700;font-size:16px;line-height:20px;letter-spacing:-.03em}.w3m-large-bold{font-weight:600;font-size:20px;line-height:24px;letter-spacing:-.03em}:host(*){color:var(--w3m-color-fg-1)}.w3m-color-primary{color:var(--w3m-color-fg-1)}.w3m-color-secondary{color:var(--w3m-color-fg-2)}.w3m-color-tertiary{color:var(--w3m-color-fg-3)}.w3m-color-inverse{color:var(--w3m-color-fg-inverse)}.w3m-color-accnt{color:var(--w3m-color-fg-accent)}.w3m-color-error{color:var(--w3m-color-err)}`;

var Do = Object.defineProperty,
    To = Object.getOwnPropertyDescriptor,
    Fe = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? To(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Do(t, a, o), o;
};

let pe = class extends w {
  constructor() {
    super(...arguments), this.variant = "medium-normal", this.color = "primary";
  }

  render() {
    const e = {
      "w3m-large-bold": this.variant === "large-bold",
      "w3m-medium-bold": this.variant === "medium-bold",
      "w3m-medium-normal": this.variant === "medium-normal",
      "w3m-medium-thin": this.variant === "medium-thin",
      "w3m-small-normal": this.variant === "small-normal",
      "w3m-small-thin": this.variant === "small-thin",
      "w3m-xsmall-normal": this.variant === "xsmall-normal",
      "w3m-xxsmall-bold": this.variant === "xxsmall-bold",
      "w3m-color-primary": this.color === "primary",
      "w3m-color-secondary": this.color === "secondary",
      "w3m-color-tertiary": this.color === "tertiary",
      "w3m-color-inverse": this.color === "inverse",
      "w3m-color-accnt": this.color === "accent",
      "w3m-color-error": this.color === "error"
    };
    return l`<span class="${T(e)}"><slot></slot></span>`;
  }

};
pe.styles = [u.globalCss, _o], Fe([f()], pe.prototype, "variant", 2), Fe([f()], pe.prototype, "color", 2), pe = Fe([b("w3m-text")], pe);
const No = y`div{overflow:hidden;position:relative;border-radius:50%}div::after{content:'';position:absolute;inset:0;border-radius:50%;border:1px solid var(--w3m-color-overlay)}div img{width:100%;height:100%;object-fit:cover;object-position:center}svg{width:100%;height:100%}#token-placeholder-fill{fill:var(--w3m-color-bg-3)}#token-placeholder-dash{stroke:var(--w3m-color-overlay)}`;

var Ro = Object.defineProperty,
    Bo = Object.getOwnPropertyDescriptor,
    yt = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Bo(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Ro(t, a, o), o;
};

let Me = class extends w {
  constructor() {
    super(...arguments), this.symbol = void 0;
  }

  render() {
    var e;
    const t = h.getTokenIcon((e = this.symbol) != null ? e : "");
    return t ? l`<div><img src="${t}" alt="${this.id}"></div>` : g.TOKEN_PLACEHOLDER;
  }

};
Me.styles = [u.globalCss, No], yt([f()], Me.prototype, "symbol", 2), Me = yt([b("w3m-token-image")], Me);
const Uo = y`button{transition:all .2s ease;width:100%;height:100%;border-radius:10px;display:flex;align-items:flex-start}button:hover{background-color:var(--w3m-color-overlay)}button>div{width:80px;padding:5px 0;display:flex;flex-direction:column;align-items:center}w3m-text{width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center}w3m-wallet-image{height:60px;width:60px;transition:all .2s ease;border-radius:15px;margin-bottom:5px}.w3m-sublabel{margin-top:2px}`;

var Ho = Object.defineProperty,
    Zo = Object.getOwnPropertyDescriptor,
    z = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Zo(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Ho(t, a, o), o;
};

let H = class extends w {
  constructor() {
    super(...arguments), this.onClick = () => null, this.name = "", this.walletId = "", this.label = void 0, this.src = void 0, this.installed = !1, this.recent = !1;
  }

  sublabelTemplate() {
    return this.recent ? l`<w3m-text class="w3m-sublabel" variant="xxsmall-bold" color="tertiary">RECENT</w3m-text>` : this.installed ? l`<w3m-text class="w3m-sublabel" variant="xxsmall-bold" color="tertiary">INSTALLED</w3m-text>` : null;
  }

  render() {
    var e;
    return l`<button @click="${this.onClick}"><div><w3m-wallet-image walletId="${this.walletId}" .src="${this.src}"></w3m-wallet-image><w3m-text variant="xsmall-normal">${(e = this.label) != null ? e : h.getWalletName(this.name, !0)}</w3m-text>${this.sublabelTemplate()}</div></button>`;
  }

};
H.styles = [u.globalCss, Uo], z([f()], H.prototype, "onClick", 2), z([f()], H.prototype, "name", 2), z([f()], H.prototype, "walletId", 2), z([f()], H.prototype, "label", 2), z([f()], H.prototype, "src", 2), z([f()], H.prototype, "installed", 2), z([f()], H.prototype, "recent", 2), H = z([b("w3m-wallet-button")], H);
const Fo = y`div{overflow:hidden;position:relative;border-radius:inherit;width:100%;height:100%}svg{position:relative;width:100%;height:100%}div::after{content:'';position:absolute;inset:0;border-radius:inherit;border:1px solid var(--w3m-color-overlay)}div img{width:100%;height:100%;object-fit:cover;object-position:center}#wallet-placeholder-fill{fill:var(--w3m-color-bg-3)}#wallet-placeholder-dash{stroke:var(--w3m-color-overlay)}`;

var zo = Object.defineProperty,
    Vo = Object.getOwnPropertyDescriptor,
    ze = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Vo(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && zo(t, a, o), o;
};

let ue = class extends w {
  constructor() {
    super(...arguments), this.walletId = void 0, this.src = void 0;
  }

  render() {
    var e;
    const t = h.getWalletId((e = this.walletId) != null ? e : ""),
          a = h.getWalletId(t),
          n = this.src ? this.src : h.getWalletIcon(a);
    return l`${n.length ? l`<div><img src="${n}" alt="${this.id}"></div>` : g.WALLET_PLACEHOLDER}`;
  }

};
ue.styles = [u.globalCss, Fo], ze([f()], ue.prototype, "walletId", 2), ze([f()], ue.prototype, "src", 2), ue = ze([b("w3m-wallet-image")], ue);
const Go = y`:host{all:initial}div{display:flex;align-items:center;background-color:var(--w3m-color-overlay);box-shadow:inset 0 0 0 1px var(--w3m-color-overlay);border-radius:10px;padding:4px 4px 4px 8px}div button{border-radius:16px;padding:4px 8px 4px 4px;height:auto;margin-left:10px;color:var(--w3m-color-fg-inverse);background-color:var(--w3m-color-fg-accent)}button::after{content:'';inset:0;position:absolute;background-color:transparent;border-radius:inherit;transition:background-color .2s ease;border:1px solid var(--w3m-color-overlay)}button:hover::after{background-color:var(--w3m-color-overlay)}w3m-avatar{margin-right:6px}w3m-button-big w3m-avatar{margin-left:-5px}`;

var qo = Object.defineProperty,
    Ko = Object.getOwnPropertyDescriptor,
    xt = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Ko(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && qo(t, a, o), o;
};

let We = class extends w {
  constructor() {
    super(), this.balance = "hide", h.rejectStandaloneButtonComponent();
  }

  onOpen() {
    const {
      isStandalone: e
    } = p.state;
    e || _.open({
      route: "Account"
    });
  }

  accountTemplate() {
    return l`<w3m-avatar></w3m-avatar><w3m-address-text></w3m-address-text>`;
  }

  render() {
    return this.balance === "show" ? l`<div><w3m-balance></w3m-balance><button @click="${this.onOpen}">${this.accountTemplate()}</button></div>` : l`<w3m-button-big @click="${this.onOpen}">${this.accountTemplate()}</w3m-button-big>`;
  }

};
We.styles = [u.globalCss, Go], xt([f()], We.prototype, "balance", 2), We = xt([b("w3m-account-button")], We);
const Yo = y`button{display:flex;border-radius:10px;flex-direction:column;transition:background-color .2s ease;justify-content:center;padding:5px;width:100px}button:hover{background-color:var(--w3m-color-overlay)}button:disabled{pointer-events:none}w3m-network-image{width:32px;height:32px}w3m-text{margin-top:4px}`;

var Xo = Object.defineProperty,
    Qo = Object.getOwnPropertyDescriptor,
    Ve = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Qo(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Xo(t, a, o), o;
};

let ve = class extends w {
  constructor() {
    super(), this.chainId = "", this.label = "", this.unsubscribeNetwork = void 0;
    const {
      selectedChain: e
    } = p.state;
    this.chainId = e === null || e === void 0 ? void 0 : e.id.toString(), this.label = e === null || e === void 0 ? void 0 : e.name, this.unsubscribeNetwork = p.subscribe(_ref21 => {
      let {
        selectedChain: t
      } = _ref21;
      this.chainId = t === null || t === void 0 ? void 0 : t.id.toString(), this.label = t === null || t === void 0 ? void 0 : t.name;
    });
  }

  disconnectedCallback() {
    var e;
    (e = this.unsubscribeNetwork) == null || e.call(this);
  }

  onClick() {
    I.push("SelectNetwork");
  }

  render() {
    const {
      chains: e
    } = p.state,
          t = e && e.length > 1;
    return l`<button @click="${this.onClick}" ?disabled="${!t}"><w3m-network-image chainId="${B(this.chainId)}"></w3m-network-image><w3m-text variant="xsmall-normal" color="accent">${this.label}</w3m-text></button>`;
  }

};
ve.styles = [u.globalCss, Yo], Ve([$()], ve.prototype, "chainId", 2), Ve([$()], ve.prototype, "label", 2), ve = Ve([b("w3m-account-network-button")], ve);
const Jo = y`@keyframes slide{0%{background-position:0 0}100%{background-position:200px 0}}w3m-text{padding:1px 0}.w3m-loading{background:linear-gradient(270deg,var(--w3m-color-fg-1) 36.33%,var(--w3m-color-fg-3) 42.07%,var(--w3m-color-fg-1) 83.3%);background-size:200px 100%;background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent;animation-name:slide;animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:linear}`;

var ea = Object.defineProperty,
    ta = Object.getOwnPropertyDescriptor,
    ge = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? ta(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && ea(t, a, o), o;
};

let Y = class extends w {
  constructor() {
    super(), this.address = void 0, this.name = void 0, this.loading = !0, this.variant = "button", this.unsubscribeAccount = void 0, this.address = p.state.address, this.name = p.state.profileName, this.loading = Boolean(p.state.profileLoading), this.unsubscribeAccount = p.subscribe(_ref22 => {
      let {
        address: e,
        profileName: t,
        profileLoading: a
      } = _ref22;
      this.address = e, this.name = t, this.loading = Boolean(a);
    });
  }

  disconnectedCallback() {
    var e;
    (e = this.unsubscribeAccount) == null || e.call(this);
  }

  render() {
    var e;
    const t = this.variant === "button",
          a = {
      "w3m-loading": this.loading
    };
    return l`<w3m-text class="${T(a)}" variant="${t ? "medium-normal" : "large-bold"}" color="${t ? "inverse" : "primary"}">${this.name ? this.name : h.truncate((e = this.address) != null ? e : "")}</w3m-text>`;
  }

};
Y.styles = [u.globalCss, Jo], ge([$()], Y.prototype, "address", 2), ge([$()], Y.prototype, "name", 2), ge([$()], Y.prototype, "loading", 2), ge([f()], Y.prototype, "variant", 2), Y = ge([b("w3m-address-text")], Y);
const oa = y`@keyframes scroll{0%{transform:translate3d(0,0,0)}100%{transform:translate3d(calc(-70px * 10),0,0)}}.w3m-slider{position:relative;overflow-x:hidden;padding:10px 0;margin:0 -20px}.w3m-slider::after,.w3m-slider::before{content:'';height:100%;width:50px;z-index:2;position:absolute;background:linear-gradient(to right,var(--w3m-color-bg-1) 0,transparent 100%);top:0}.w3m-slider::before{left:0}.w3m-slider::after{right:0;transform:rotateZ(180deg)}.w3m-track{display:flex;width:calc(70px * 20);animation:scroll 20s linear infinite}.w3m-action{padding:30px 0 10px 0;display:flex;justify-content:center;align-items:center;flex-direction:column}.w3m-action w3m-button-big:last-child{margin-top:10px}w3m-wallet-image{width:60px;height:60px;margin:0 5px;box-shadow:0 2px 4px -2px rgba(0,0,0,.12),0 4px 4px -2px rgba(0,0,0,.08);border-radius:15px}`;

var aa = Object.defineProperty,
    na = Object.getOwnPropertyDescriptor,
    ra = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? na(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && aa(t, a, o), o;
};

let Ge = class extends w {
  onGoToQrcode() {
    I.push("Qrcode");
  }

  onGoToGetWallet() {
    I.push("GetWallet");
  }

  render() {
    const {
      previewWallets: e
    } = S.state,
          t = e.length,
          a = [...e, ...e];
    return l`<w3m-modal-header title="Connect your wallet" .onAction="${this.onGoToQrcode}" .actionIcon="${g.QRCODE_ICON}"></w3m-modal-header><w3m-modal-content>${t ? l`<div class="w3m-slider"><div class="w3m-track">${a.map(_ref23 => {
      let {
        image_url: n
      } = _ref23;
      return l`<w3m-wallet-image src="${n.lg}"></w3m-wallet-image>`;
    })}</div></div>` : null}<div class="w3m-action"><w3m-button-big @click="${h.handleAndroidLinking}"><w3m-text variant="medium-normal" color="inverse">Select Wallet</w3m-text></w3m-button-big><w3m-button-big variant="secondary" @click="${this.onGoToGetWallet}"><w3m-text variant="medium-normal" color="accent">I don’t have a wallet</w3m-text></w3m-button-big></div></w3m-modal-content>`;
  }

};
Ge.styles = [u.globalCss, oa], Ge = ra([b("w3m-android-wallet-selection")], Ge);
const ia = y`@keyframes slide{0%{transform:translateX(-50px)}100%{transform:translateX(200px)}}.w3m-placeholder,img{border-radius:50%;box-shadow:inset 0 0 0 1px var(--w3m-color-overlay);display:block;position:relative;overflow:hidden!important;background-color:var(--w3m-color-av-1);background-image:radial-gradient(at 66% 77%,var(--w3m-color-av-2) 0,transparent 50%),radial-gradient(at 29% 97%,var(--w3m-color-av-3) 0,transparent 50%),radial-gradient(at 99% 86%,var(--w3m-color-av-4) 0,transparent 50%),radial-gradient(at 29% 88%,var(--w3m-color-av-5) 0,transparent 50%);transform:translateZ(0)}.w3m-loader{width:50px;height:100%;background:linear-gradient(270deg,transparent 0,rgba(255,255,255,.4) 30%,transparent 100%);animation-name:slide;animation-duration:1.5s;transform:translateX(-50px);animation-iteration-count:infinite;animation-timing-function:linear;animation-delay:.55s}.w3m-small{width:24px;height:24px}.w3m-medium{width:60px;height:60px}`;

var la = Object.defineProperty,
    sa = Object.getOwnPropertyDescriptor,
    we = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? sa(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && la(t, a, o), o;
};

let X = class extends w {
  constructor() {
    super(), this.address = void 0, this.avatar = void 0, this.loading = !0, this.size = "small", this.unsubscribeAccount = void 0, this.address = p.state.address, this.avatar = p.state.profileAvatar, this.loading = Boolean(p.state.profileLoading), this.unsubscribeAccount = p.subscribe(_ref24 => {
      let {
        address: e,
        profileAvatar: t,
        profileLoading: a
      } = _ref24;
      this.address = e, this.avatar = t, this.loading = Boolean(a);
    });
  }

  disconnectedCallback() {
    var e;
    (e = this.unsubscribeAccount) == null || e.call(this);
  }

  render() {
    const e = {
      "w3m-placeholder": !0,
      "w3m-small": this.size === "small",
      "w3m-medium": this.size === "medium"
    };
    return this.avatar ? l`<img class="${T(e)}" src="${this.avatar}">` : this.address ? (h.generateAvatarColors(this.address), l`<div class="${T(e)}">${this.loading ? l`<div class="w3m-loader"></div>` : null}</div>`) : null;
  }

};
X.styles = [u.globalCss, ia], we([$()], X.prototype, "address", 2), we([$()], X.prototype, "avatar", 2), we([$()], X.prototype, "loading", 2), we([f()], X.prototype, "size", 2), X = we([b("w3m-avatar")], X);
const ca = y`div{display:flex;align-items:center}w3m-token-image{width:28px;height:28px;margin-right:6px}`;

var da = Object.defineProperty,
    ha = Object.getOwnPropertyDescriptor,
    qe = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? ha(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && da(t, a, o), o;
};

let be = class extends w {
  constructor() {
    var e, t;
    super(), this.symbol = void 0, this.amount = void 0, this.unsubscribeAccount = void 0, this.symbol = (e = p.state.balance) == null ? void 0 : e.symbol, this.amount = (t = p.state.balance) == null ? void 0 : t.amount, this.unsubscribeAccount = p.subscribe(_ref25 => {
      let {
        balance: a
      } = _ref25;
      this.symbol = a === null || a === void 0 ? void 0 : a.symbol, this.amount = a === null || a === void 0 ? void 0 : a.amount;
    });
  }

  disconnectedCallback() {
    var e;
    (e = this.unsubscribeAccount) == null || e.call(this);
  }

  render() {
    let e = "_._";
    return this.amount === "0.0" && (e = 0), this.amount && this.amount.length > 6 && (e = parseFloat(this.amount).toFixed(3)), l`<div><w3m-token-image symbol="${B(this.symbol)}"></w3m-token-image><w3m-text variant="medium-normal" color="primary">${e} ${this.symbol}</w3m-text></div>`;
  }

};
be.styles = [u.globalCss, ca], qe([$()], be.prototype, "symbol", 2), qe([$()], be.prototype, "amount", 2), be = qe([b("w3m-balance")], be);
const ma = y`:host{all:initial}svg{width:28px;height:20px;margin:-1px 3px 0 -5px}svg path{fill:var(--w3m-color-fg-inverse)}button:disabled svg path{fill:var(--w3m-color-fg-3)}w3m-spinner{margin:0 10px 0 0}`;

var pa = Object.defineProperty,
    ua = Object.getOwnPropertyDescriptor,
    Ae = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? ua(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && pa(t, a, o), o;
};

let ae = class extends w {
  constructor() {
    super(), this.loading = !1, this.label = "Connect Wallet", this.icon = "show", this.modalUnsub = void 0, h.rejectStandaloneButtonComponent(), this.modalUnsub = _.subscribe(e => {
      e.open && (this.loading = !0), e.open || (this.loading = !1);
    });
  }

  disconnectedCallback() {
    var e;
    (e = this.modalUnsub) == null || e.call(this);
  }

  iconTemplate() {
    return this.icon === "show" ? g.WALLET_CONNECT_ICON : null;
  }

  onClick() {
    p.state.isConnected ? this.onDisconnect() : this.onConnect();
  }

  onConnect() {
    this.loading = !0;
    const {
      enableNetworkView: e
    } = j.state,
          {
      chains: t,
      selectedChain: a
    } = p.state,
          n = (t === null || t === void 0 ? void 0 : t.length) && t.length > 1;
    e || n && !a ? _.open({
      route: "SelectNetwork"
    }) : _.open({
      route: "ConnectWallet"
    });
  }

  onDisconnect() {
    L.client().disconnect(), p.resetAccount();
  }

  render() {
    return l`<w3m-button-big .disabled="${this.loading}" @click="${this.onClick}">${this.loading ? l`<w3m-spinner></w3m-spinner><w3m-text variant="medium-normal" color="accent">Connecting...</w3m-text>` : l`${this.iconTemplate()}<w3m-text variant="medium-normal" color="inverse">${this.label}</w3m-text>`}</w3m-button-big>`;
  }

};
ae.styles = [u.globalCss, ma], Ae([$()], ae.prototype, "loading", 2), Ae([f()], ae.prototype, "label", 2), Ae([f()], ae.prototype, "icon", 2), ae = Ae([b("w3m-connect-button")], ae);

var va = Object.defineProperty,
    ga = Object.getOwnPropertyDescriptor,
    fe = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? ga(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && va(t, a, o), o;
};

let ne = class extends w {
  constructor() {
    super(), this.isConnected = !1, this.label = "Connect Wallet", this.icon = "show", this.balance = "hide", this.unsubscribeAccount = void 0, h.rejectStandaloneButtonComponent(), this.isConnected = p.state.isConnected, this.unsubscribeAccount = p.subscribe(_ref26 => {
      let {
        isConnected: e
      } = _ref26;
      this.isConnected = e;
    });
  }

  disconnectedCallback() {
    var e;
    (e = this.unsubscribeAccount) == null || e.call(this);
  }

  render() {
    const {
      enableAccountView: e
    } = j.state;
    return this.isConnected && e ? l`<w3m-account-button balance="${B(this.balance)}"></w3m-account-button>` : l`<w3m-connect-button label="${this.isConnected ? "Disconnect" : B(this.label)}" icon="${B(this.icon)}"></w3m-connect-button>`;
  }

};
fe([$()], ne.prototype, "isConnected", 2), fe([f()], ne.prototype, "label", 2), fe([f()], ne.prototype, "icon", 2), fe([f()], ne.prototype, "balance", 2), ne = fe([b("w3m-core-button")], ne);
const R = {
  allowedExplorerListings(e) {
    const {
      explorerAllowList: t,
      explorerDenyList: a
    } = j.state;
    let n = [...e];
    return t && (n = n.filter(o => t.includes(o.id))), a && (n = n.filter(o => !a.includes(o.id))), n;
  },

  walletsWithInjected(e) {
    let t = [...(e !== null && e !== void 0 ? e : [])];

    if (window.ethereum) {
      const a = h.getWalletName("");
      t = t.filter(_ref27 => {
        let {
          name: n
        } = _ref27;
        return !h.caseSafeIncludes(n, a);
      });
    }

    return t;
  },

  connectorWallets() {
    const {
      isStandalone: e
    } = p.state;
    if (e) return [];
    let t = L.client().getConnectors();
    return !window.ethereum && W.isMobile() && (t = t.filter(_ref28 => {
      let {
        id: a
      } = _ref28;
      return a !== "injected" && a !== Z.metaMask;
    })), t;
  },

  walletTemplatesWithRecent(e, t) {
    let a = [...e];

    if (t) {
      const n = h.getRecentWallet();
      a = a.filter(o => !o.values.includes(n === null || n === void 0 ? void 0 : n.name)), a.splice(1, 0, t);
    }

    return a;
  },

  deduplicateExplorerListingsFromConnectors(e) {
    const {
      isStandalone: t
    } = p.state;
    if (t) return e;
    const a = L.client().getConnectors().map(_ref29 => {
      let {
        name: n
      } = _ref29;
      return n.toUpperCase();
    });
    return e.filter(_ref30 => {
      let {
        name: n
      } = _ref30;
      return !a.includes(n.toUpperCase());
    });
  }

},
      wa = y`.w3m-grid{display:grid;grid-template-columns:repeat(4,80px);justify-content:space-between}.w3m-desktop-title,.w3m-mobile-title{display:flex;align-items:center}.w3m-mobile-title{justify-content:space-between;margin-bottom:20px;margin-top:-10px}.w3m-desktop-title{margin-bottom:10px;padding:0 10px}.w3m-subtitle{display:flex;align-items:center}.w3m-subtitle:last-child path{fill:var(--w3m-color-fg-3)}.w3m-desktop-title svg,.w3m-mobile-title svg{margin-right:6px}.w3m-desktop-title path,.w3m-mobile-title path{fill:var(--w3m-color-fg-accent)}`;

var ba = Object.defineProperty,
    fa = Object.getOwnPropertyDescriptor,
    ya = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? fa(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && ba(t, a, o), o;
};

let Ke = class extends w {
  onDesktopWallet(e) {
    I.push("DesktopConnector", {
      DesktopConnector: e
    });
  }

  onInjectedWallet() {
    I.push("InjectedConnector");
  }

  onInstallConnector() {
    I.push("InstallConnector", {
      InstallConnector: {
        id: "metaMask",
        name: "MetaMask",
        isMobile: !0,
        url: "https://metamask.io"
      }
    });
  }

  async onConnectorWallet(e) {
    window.ethereum ? e === "injected" || e === Z.metaMask ? this.onInjectedWallet() : await h.handleConnectorConnection(e) : this.onInstallConnector();
  }

  desktopWalletsTemplate() {
    const {
      desktopWallets: e
    } = j.state;
    return e === null || e === void 0 ? void 0 : e.map(_ref31 => {
      let {
        id: t,
        name: a,
        links: {
          universal: n,
          native: o
        }
      } = _ref31;
      return l`<w3m-wallet-button walletId="${t}" name="${a}" .onClick="${() => this.onDesktopWallet({
        name: a,
        walletId: t,
        universal: n,
        native: o
      })}"></w3m-wallet-button>`;
    });
  }

  previewWalletsTemplate() {
    let e = R.allowedExplorerListings(S.state.previewWallets);
    return e = R.deduplicateExplorerListingsFromConnectors(e), e.map(_ref32 => {
      let {
        name: t,
        desktop: {
          universal: a,
          native: n
        },
        homepage: o,
        image_url: r,
        id: i
      } = _ref32;
      return l`<w3m-wallet-button src="${r.lg}" name="${t}" .onClick="${() => this.onDesktopWallet({
        walletId: i,
        name: t,
        native: n,
        universal: a || o,
        icon: r.lg
      })}"></w3m-wallet-button>`;
    });
  }

  connectorWalletsTemplate() {
    return R.connectorWallets().map(_ref33 => {
      let {
        id: e,
        name: t,
        ready: a
      } = _ref33;
      return l`<w3m-wallet-button .installed="${["injected", "metaMask"].includes(e) && a}" name="${t}" walletId="${e}" .onClick="${async () => this.onConnectorWallet(e)}"></w3m-wallet-button>`;
    });
  }

  recentWalletTemplate() {
    const e = h.getRecentWallet();
    if (!e) return;
    const {
      id: t,
      name: a,
      links: n,
      image: o
    } = e;
    return l`<w3m-wallet-button .recent="${!0}" name="${a}" walletId="${B(t)}" src="${B(o)}" .onClick="${() => this.onDesktopWallet({
      name: a,
      walletId: t,
      universal: n === null || n === void 0 ? void 0 : n.universal,
      native: n === null || n === void 0 ? void 0 : n.native,
      icon: o
    })}"></w3m-wallet-button>`;
  }

  render() {
    const {
      standaloneUri: e
    } = p.state,
          t = this.desktopWalletsTemplate(),
          a = this.previewWalletsTemplate(),
          n = this.connectorWalletsTemplate(),
          o = this.recentWalletTemplate(),
          r = [...(t !== null && t !== void 0 ? t : []), ...a],
          i = [...n, ...r],
          c = R.walletTemplatesWithRecent(i, o),
          m = R.walletTemplatesWithRecent(r, o),
          s = e ? m : c,
          d = s.length > 4;
    let v = [];
    d ? v = s.filter(C => !C.values.includes(Z.coinbaseWallet)).slice(0, 3) : v = s;
    const O = Boolean(v.length);
    return l`<w3m-modal-header border="${!0}" title="Connect your wallet" .onAction="${h.handleUriCopy}" .actionIcon="${g.COPY_ICON}"></w3m-modal-header><w3m-modal-content><div class="w3m-mobile-title"><div class="w3m-subtitle">${g.MOBILE_ICON}<w3m-text variant="small-normal" color="accent">Mobile</w3m-text></div><div class="w3m-subtitle">${g.SCAN_ICON}<w3m-text variant="small-normal" color="secondary">Scan with your wallet</w3m-text></div></div><w3m-walletconnect-qr></w3m-walletconnect-qr></w3m-modal-content>${O ? l`<w3m-modal-footer><div class="w3m-desktop-title">${g.DESKTOP_ICON}<w3m-text variant="small-normal" color="accent">Desktop</w3m-text></div><div class="w3m-grid">${v} ${d ? l`<w3m-view-all-wallets-button></w3m-view-all-wallets-button>` : null}</div></w3m-modal-footer>` : null}`;
  }

};
Ke.styles = [u.globalCss, wa], Ke = ya([b("w3m-desktop-wallet-selection")], Ke);
const xa = y`div{background-color:var(--w3m-color-bg-2);padding:10px 20px 15px 20px;border-top:1px solid var(--w3m-color-bg-3);text-align:center}a{color:var(--w3m-color-fg-accent);text-decoration:none;transition:opacity .2s ease-in-out}a:hover{opacity:.8}`;

var Ca = Object.defineProperty,
    ka = Object.getOwnPropertyDescriptor,
    $a = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? ka(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Ca(t, a, o), o;
};

let Ye = class extends w {
  render() {
    const {
      termsOfServiceUrl: e,
      privacyPolicyUrl: t
    } = j.state;
    return (e !== null && e !== void 0 ? e : t) ? l`<div><w3m-text variant="small-normal" color="secondary">By connecting your wallet, you agree to our<br>${e ? l`<a href="${e}" target="_blank" rel="noopener noreferrer">Terms of Service</a>` : null} ${e && t ? "and" : null} ${t ? l`<a href="${t}" target="_blank" rel="noopener noreferrer">Privacy Policy</a>` : null}</w3m-text></div>` : null;
  }

};
Ye.styles = [u.globalCss, xa], Ye = $a([b("w3m-legal-notice")], Ye);
const Oa = y`.w3m-grid{display:grid;grid-template-columns:repeat(4,80px);margin:0 -10px;justify-content:space-between;row-gap:10px}`;

var Ia = Object.defineProperty,
    Ea = Object.getOwnPropertyDescriptor,
    Ma = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Ea(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Ia(t, a, o), o;
};

let Xe = class extends w {
  onGoToQrcode() {
    I.push("Qrcode");
  }

  async onConnectorWallet(e) {
    await h.handleConnectorConnection(e);
  }

  mobileWalletsTemplate() {
    const {
      mobileWallets: e
    } = j.state,
          t = R.walletsWithInjected(e);
    if (t.length) return t.map(_ref34 => {
      let {
        id: a,
        name: n,
        links: {
          universal: o,
          native: r
        }
      } = _ref34;
      return l`<w3m-wallet-button name="${n}" walletId="${a}" .onClick="${async () => h.handleMobileLinking({
        links: {
          native: r,
          universal: o
        },
        name: n,
        id: a
      })}"></w3m-wallet-button>`;
    });
  }

  previewWalletsTemplate() {
    const {
      previewWallets: e
    } = S.state;
    let t = R.walletsWithInjected(e);
    return t = R.allowedExplorerListings(t), t = R.deduplicateExplorerListingsFromConnectors(t), t.map(_ref35 => {
      let {
        image_url: a,
        name: n,
        mobile: {
          native: o,
          universal: r
        },
        id: i
      } = _ref35;
      return l`<w3m-wallet-button name="${n}" src="${a.lg}" .onClick="${async () => h.handleMobileLinking({
        links: {
          native: o,
          universal: r
        },
        name: n,
        id: i,
        image: a.lg
      })}"></w3m-wallet-button>`;
    });
  }

  connectorWalletsTemplate() {
    let e = R.connectorWallets();
    return window.ethereum || (e = e.filter(_ref36 => {
      let {
        id: t
      } = _ref36;
      return t !== "injected" && t !== Z.metaMask;
    })), e.map(_ref37 => {
      let {
        name: t,
        id: a,
        ready: n
      } = _ref37;
      return l`<w3m-wallet-button .installed="${["injected", "metaMask"].includes(a) && n}" name="${t}" walletId="${a}" .onClick="${async () => this.onConnectorWallet(a)}"></w3m-wallet-button>`;
    });
  }

  recentWalletTemplate() {
    const e = h.getRecentWallet();
    if (!e) return;
    const {
      id: t,
      name: a,
      links: n,
      image: o
    } = e;
    return l`<w3m-wallet-button .recent="${!0}" name="${a}" walletId="${B(t)}" src="${B(o)}" .onClick="${async () => h.handleMobileLinking({
      name: a,
      id: t,
      links: n,
      image: o
    })}"></w3m-wallet-button>`;
  }

  render() {
    const {
      standaloneUri: e
    } = p.state,
          t = this.connectorWalletsTemplate(),
          a = this.mobileWalletsTemplate(),
          n = this.previewWalletsTemplate(),
          o = this.recentWalletTemplate(),
          r = a !== null && a !== void 0 ? a : n,
          i = [...t, ...r],
          c = R.walletTemplatesWithRecent(i, o),
          m = R.walletTemplatesWithRecent(r, o),
          s = e ? m : c,
          d = s.length > 8;
    let v = [];
    d ? v = s.filter(E => !E.values.includes(Z.coinbaseWallet)).slice(0, 7) : v = s;
    const O = v.slice(0, 4),
          C = v.slice(4, 8),
          N = Boolean(v.length);
    return l`<w3m-modal-header title="Connect your wallet" .onAction="${this.onGoToQrcode}" .actionIcon="${g.QRCODE_ICON}"></w3m-modal-header>${N ? l`<w3m-modal-content><div class="w3m-grid">${O} ${C.length ? l`${C} ${d ? l`<w3m-view-all-wallets-button></w3m-view-all-wallets-button>` : null}` : null}</div></w3m-modal-content>` : null}`;
  }

};
Xe.styles = [u.globalCss, Oa], Xe = Ma([b("w3m-mobile-wallet-selection")], Xe);
const Wa = y`:host{all:initial}.w3m-overlay{inset:0;position:fixed;z-index:var(--w3m-modal-z-index);overflow:hidden;display:flex;justify-content:center;align-items:center;background-color:rgba(0,0,0,.3);opacity:0;pointer-events:none}.w3m-open{pointer-events:auto}.w3m-container{position:relative;max-width:360px;width:100%;outline:0}.w3m-card{width:100%;position:relative;transform:translateY(5px);border-radius:30px;overflow:hidden;box-shadow:0 6px 14px -6px rgba(10,16,31,.12),0 10px 32px -4px rgba(10,16,31,.1),0 0 0 1px var(--w3m-color-overlay);background-color:var(--w3m-color-bg-1);color:var(--w3m-color-fg-1)}@media(max-width:600px){.w3m-container{max-width:440px}.w3m-card{border-radius:40px 40px 0 0}.w3m-overlay{align-items:flex-end}}@media(max-width:600px){.w3m-container{max-width:440px}.w3m-card{transform:translateY(5px);border-radius:40px 40px 0 0}.w3m-overlay{align-items:flex-end}}`;

var Aa = Object.defineProperty,
    La = Object.getOwnPropertyDescriptor,
    Le = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? La(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Aa(t, a, o), o;
};

let re = class extends w {
  constructor() {
    if (super(), this.open = !1, this.preload = !0, this.activeChainId = void 0, this.unsubscribeModal = void 0, this.unsubscribeConfig = void 0, this.unwatchAccount = void 0, this.unwatchNetwork = void 0, this.abortController = void 0, u.setTheme(), this.unsubscribeConfig = j.subscribe(u.setTheme), this.unsubscribeModal = _.subscribe(e => {
      e.open ? this.onOpenModalEvent() : this.onCloseModalEvent();
    }), !p.state.isStandalone) {
      p.getAccount();
      const e = p.getSelectedChain();
      this.activeChainId = e === null || e === void 0 ? void 0 : e.id, this.fetchEnsProfile(), this.fetchBalance(), this.unwatchNetwork = L.client().watchNetwork(t => {
        const a = t.chain;
        a && this.activeChainId !== a.id && (p.setSelectedChain(a), this.activeChainId = a.id, p.resetBalance(), this.fetchBalance());
      }), this.unwatchAccount = L.client().watchAccount(t => {
        const {
          address: a
        } = p.state;
        t.address !== a && (this.fetchEnsProfile(t.address), this.fetchBalance(t.address)), p.setAddress(t.address), p.setIsConnected(t.isConnected);
      });
    }

    this.preloadModalData();
  }

  disconnectedCallback() {
    var e, t, a, n;
    (e = this.unsubscribeModal) == null || e.call(this), (t = this.unsubscribeConfig) == null || t.call(this), (a = this.unwatchAccount) == null || a.call(this), (n = this.unwatchNetwork) == null || n.call(this);
  }

  get overlayEl() {
    return h.getShadowRootElement(this, ".w3m-overlay");
  }

  get containerEl() {
    return h.getShadowRootElement(this, ".w3m-container");
  }

  async fetchEnsProfile(e) {
    try {
      if (j.state.enableAccountView) {
        p.setProfileLoading(!0);
        const t = e !== null && e !== void 0 ? e : p.state.address,
              {
          id: a
        } = L.client().getDefaultChain();

        if (t && a === 1) {
          const [n, o] = await Promise.all([L.client().fetchEnsName({
            address: t,
            chainId: 1
          }), L.client().fetchEnsAvatar({
            address: t,
            chainId: 1
          })]);
          o && (await h.preloadImage(o)), p.setProfileName(n), p.setProfileAvatar(o);
        }
      }
    } catch (t) {
      console.error(t), D.openToast(h.getErrorMessage(t), "error");
    } finally {
      p.setProfileLoading(!1);
    }
  }

  async fetchBalance(e) {
    try {
      if (j.state.enableAccountView) {
        p.setBalanceLoading(!0);
        const t = e !== null && e !== void 0 ? e : p.state.address;

        if (t) {
          const a = await L.client().fetchBalance({
            address: t
          });
          p.setBalance({
            amount: a.formatted,
            symbol: a.symbol
          });
        }
      }
    } catch (t) {
      console.error(t), D.openToast(h.getErrorMessage(t), "error");
    } finally {
      p.setBalanceLoading(!1);
    }
  }

  toggleBodyScroll(e) {
    if (document.querySelector("body")) if (e) {
      const t = document.getElementById("w3m-styles");
      t === null || t === void 0 ? void 0 : t.remove();
    } else document.head.insertAdjacentHTML("beforeend", '<style id="w3m-styles">html,body{touch-action:none;overflow:hidden;overscroll-behavior:contain;}</style>');
  }

  async preloadExplorerData() {
    var e;
    const {
      standaloneChains: t,
      chains: a,
      walletConnectVersion: n
    } = p.state,
          o = t === null || t === void 0 ? void 0 : t.join(",");
    await Promise.all([S.getPreviewWallets({
      page: 1,
      entries: 10,
      chains: o,
      device: W.isMobile() ? "mobile" : "desktop",
      version: n
    }), S.getRecomendedWallets()]), p.setIsDataLoaded(!0);
    const {
      previewWallets: r,
      recomendedWallets: i
    } = S.state,
          c = (e = a === null || a === void 0 ? void 0 : a.map(s => h.getChainIcon(s.id))) != null ? e : [],
          m = [...r, ...i].map(s => s.image_url.lg);
    await this.preloadExplorerImages([...c, ...m]);
  }

  async preloadExplorerImages(e) {
    e.length && (await Promise.all(e.map(async t => h.preloadImage(t))));
  }

  async preloadCustomImages() {
    const e = h.getCustomImageUrls();
    e.length && (await Promise.all(e.map(async t => h.preloadImage(t))));
  }

  async preloadConnectorImages() {
    if (!p.state.isStandalone) {
      const e = h.getConnectorImageUrls();
      e.length && (await Promise.all(e.map(async t => h.preloadImage(t))));
    }
  }

  async preloadModalData() {
    try {
      this.preload && (this.preload = !1, await Promise.all([this.preloadExplorerData(), this.preloadCustomImages(), this.preloadConnectorImages()]));
    } catch (e) {
      console.error(e), D.openToast("Failed preloading", "error");
    }
  }

  onCloseModal(e) {
    e.target === e.currentTarget && _.close();
  }

  async onOpenModalEvent() {
    await this.preloadModalData(), this.toggleBodyScroll(!1);
    const e = .2;
    await V(this.containerEl, {
      y: 0
    }, {
      duration: 0
    }).finished, V(this.overlayEl, {
      opacity: [0, 1]
    }, {
      duration: .2,
      delay: e
    }), V(this.containerEl, h.isMobileAnimation() ? {
      y: ["50vh", 0]
    } : {
      scale: [.98, 1]
    }, {
      scale: {
        easing: Ce({
          velocity: .4
        })
      },
      y: {
        easing: Ce({
          mass: .5
        })
      },
      delay: e
    }), this.addKeyboardEvents(), this.open = !0;
  }

  async onCloseModalEvent() {
    this.toggleBodyScroll(!0), this.removeKeyboardEvents(), await Promise.all([V(this.containerEl, h.isMobileAnimation() ? {
      y: [0, "50vh"]
    } : {
      scale: [1, .98]
    }, {
      scale: {
        easing: Ce({
          velocity: 0
        })
      },
      y: {
        easing: Ce({
          mass: .5
        })
      }
    }).finished, V(this.overlayEl, {
      opacity: [1, 0]
    }, {
      duration: .2
    }).finished]), this.open = !1;
  }

  addKeyboardEvents() {
    this.abortController = new AbortController(), window.addEventListener("keydown", e => {
      var t;
      e.key === "Escape" ? _.close() : e.key === "Tab" && ((t = e.target) != null && t.tagName.includes("W3M-") || this.containerEl.focus());
    }, this.abortController), this.containerEl.focus();
  }

  removeKeyboardEvents() {
    var e;
    (e = this.abortController) == null || e.abort(), this.abortController = void 0;
  }

  render() {
    const e = {
      "w3m-overlay": !0,
      "w3m-open": this.open
    };
    return l`<div id="w3m-modal" class="${T(e)}" @click="${this.onCloseModal}" role="alertdialog" aria-modal="true"><div class="w3m-container" tabindex="0">${this.open ? l`<w3m-modal-backcard></w3m-modal-backcard><div class="w3m-card"><w3m-modal-router></w3m-modal-router><w3m-modal-toast></w3m-modal-toast></div>` : null}</div></div>`;
  }

};
re.styles = [u.globalCss, Wa], Le([$()], re.prototype, "open", 2), Le([$()], re.prototype, "preload", 2), Le([$()], re.prototype, "activeChainId", 2), re = Le([b("w3m-modal")], re);
const ja = y`:host{all:initial}w3m-network-image{margin-left:-6px;margin-right:6px;width:28px;height:28px}`;

var Sa = Object.defineProperty,
    Pa = Object.getOwnPropertyDescriptor,
    je = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Pa(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Sa(t, a, o), o;
};

let ie = class extends w {
  constructor() {
    super(), this.chainId = "", this.label = "", this.wrongNetwork = !1, this.unsubscribeNetwork = void 0, h.rejectStandaloneButtonComponent();
    const {
      selectedChain: e
    } = p.state;
    this.onSetChainData(e), this.unsubscribeNetwork = p.subscribe(_ref38 => {
      let {
        selectedChain: t
      } = _ref38;
      this.onSetChainData(t);
    });
  }

  disconnectedCallback() {
    var e;
    (e = this.unsubscribeNetwork) == null || e.call(this);
  }

  onSetChainData(e) {
    if (e) {
      const {
        chains: t
      } = p.state,
            a = t === null || t === void 0 ? void 0 : t.map(n => n.id);
      this.chainId = e.id.toString(), this.wrongNetwork = !(a != null && a.includes(e.id)), this.label = this.wrongNetwork ? "Wrong Network" : e.name;
    }
  }

  onClick() {
    _.open({
      route: "SelectNetwork"
    });
  }

  render() {
    var e;
    const {
      chains: t
    } = p.state,
          a = t && t.length > 1;
    return l`<w3m-button-big @click="${this.onClick}" ?disabled="${!a}"><w3m-network-image chainId="${B(this.chainId)}"></w3m-network-image><w3m-text variant="medium-normal" color="inverse">${(e = this.label) != null && e.length ? this.label : "Select Network"}</w3m-text></w3m-button-big>`;
  }

};
ie.styles = [u.globalCss, ja], je([$()], ie.prototype, "chainId", 2), je([$()], ie.prototype, "label", 2), je([$()], ie.prototype, "wrongNetwork", 2), ie = je([b("w3m-network-switch")], ie);

const _a = y`button{display:flex;flex-direction:column;padding:5px 10px;border-radius:10px;transition:background-color .2s ease;height:100%;justify-content:flex-start}.w3m-icons{width:60px;height:60px;display:flex;flex-wrap:wrap;padding:7px;border-radius:15px;justify-content:space-between;align-items:center;margin-bottom:5px;background-color:var(--w3m-color-bg-2);box-shadow:inset 0 0 0 1px var(--w3m-color-overlay)}button:hover{background-color:var(--w3m-color-overlay)}.w3m-icons img{width:21px;height:21px;object-fit:cover;object-position:center;border-radius:8px;border:1px solid var(--w3m-color-overlay)}.w3m-icons svg{width:21px;height:21px}.w3m-icons img:nth-child(1),.w3m-icons img:nth-child(2),.w3m-icons svg:nth-child(1),.w3m-icons svg:nth-child(2){margin-bottom:4px}w3m-text{width:100%;text-align:center}#wallet-placeholder-fill{fill:var(--w3m-color-bg-3)}#wallet-placeholder-dash{stroke:var(--w3m-color-overlay)}`;

var Da = Object.defineProperty,
    Ta = Object.getOwnPropertyDescriptor,
    Na = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Ta(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Da(t, a, o), o;
};

let Qe = class extends w {
  onClick() {
    I.push("WalletExplorer");
  }

  render() {
    const {
      previewWallets: e
    } = S.state,
          t = h.getCustomWallets(),
          a = [...e, ...t].reverse().slice(0, 4);
    return l`<button @click="${this.onClick}"><div class="w3m-icons">${a.map(n => {
      var o;
      const r = (o = n.image_url) == null ? void 0 : o.lg;
      if (r) return l`<img src="${r}">`;
      const i = h.getWalletId(n.id),
            c = h.getWalletIcon(i);
      return c ? l`<img src="${c}">` : g.WALLET_PLACEHOLDER;
    })}</div><w3m-text variant="xsmall-normal">View All</w3m-text></button>`;
  }

};
Qe.styles = [u.globalCss, _a], Qe = Na([b("w3m-view-all-wallets-button")], Qe);
const Ra = y`.w3m-qr-container{width:100%;display:flex;justify-content:center;align-items:center;aspect-ratio:1/1}`;

var Ba = Object.defineProperty,
    Ua = Object.getOwnPropertyDescriptor,
    Ct = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Ua(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Ba(t, a, o), o;
};

let Se = class extends w {
  constructor() {
    super(), this.uri = "", this.createConnectionAndWait();
  }

  get overlayEl() {
    return h.getShadowRootElement(this, ".w3m-qr-container");
  }

  async createConnectionAndWait() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var t;

    try {
      const {
        standaloneUri: a
      } = p.state;
      a ? setTimeout(() => this.uri = a, 0) : (await L.client().connectWalletConnect(n => this.uri = n, (t = p.state.selectedChain) == null ? void 0 : t.id), _.close());
    } catch (a) {
      console.error(a), D.openToast("Connection request declined", "error"), e < 2 && this.createConnectionAndWait(e + 1);
    }
  }

  render() {
    return l`<div class="w3m-qr-container">${this.uri ? l`<w3m-qrcode size="${this.overlayEl.offsetWidth}" uri="${this.uri}"></w3m-qrcode>` : l`<w3m-spinner></w3m-spinner>`}</div>`;
  }

};
Se.styles = [u.globalCss, Ra], Ct([$()], Se.prototype, "uri", 2), Se = Ct([b("w3m-walletconnect-qr")], Se);
const Ha = y`.w3m-profile{display:flex;justify-content:space-between;align-items:flex-start;padding-top:20px}.w3m-connection-badge{background-color:var(--w3m-color-bg-2);box-shadow:inset 0 0 0 1px var(--w3m-color-overlay);padding:6px 10px 6px 26px;position:relative;border-radius:28px}.w3m-connection-badge::before{content:'';position:absolute;width:10px;height:10px;left:10px;background-color:var(--w3m-color-success);border-radius:50%;top:50%;margin-top:-5px;box-shadow:0 1px 4px 1px var(--w3m-color-success),inset 0 0 0 1px var(--w3m-color-overlay)}.w3m-footer{display:flex;justify-content:space-between}w3m-address-text{margin-top:10px;display:block}.w3m-balance{border-top:1px solid var(--w3m-color-bg-2);padding:11px 20px}`;

var Za = Object.defineProperty,
    Fa = Object.getOwnPropertyDescriptor,
    za = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Fa(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Za(t, a, o), o;
};

let Je = class extends w {
  onDisconnect() {
    _.close(), L.client().disconnect(), p.resetAccount();
  }

  async onCopyAddress() {
    var e;
    await navigator.clipboard.writeText((e = p.state.address) != null ? e : ""), D.openToast("Address copied", "success");
  }

  render() {
    return l`<w3m-modal-content><div class="w3m-profile"><div class="w3m-info"><w3m-avatar size="medium"></w3m-avatar><w3m-address-text variant="modal"></w3m-address-text></div><div class="w3m-connection-badge"><w3m-text variant="small-normal" color="secondary">Connected</w3m-text></div></div></w3m-modal-content><div class="w3m-balance"><w3m-balance></w3m-balance></div><w3m-modal-footer><div class="w3m-footer"><w3m-account-network-button></w3m-account-network-button><w3m-box-button label="Copy Address" .onClick="${this.onCopyAddress}" .icon="${g.ACCOUNT_COPY}"></w3m-box-button><w3m-box-button label="Disconnect" .onClick="${this.onDisconnect}" .icon="${g.ACCOUNT_DISCONNECT}"></w3m-box-button></div></w3m-modal-footer>`;
  }

};
Je.styles = [u.globalCss, Ha], Je = za([b("w3m-account-view")], Je);

var Va = Object.defineProperty,
    Ga = Object.getOwnPropertyDescriptor,
    qa = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Ga(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Va(t, a, o), o;
};

let et = class extends w {
  viewTemplate() {
    return W.isAndroid() ? l`<w3m-android-wallet-selection></w3m-android-wallet-selection>` : W.isMobile() ? l`<w3m-mobile-wallet-selection></w3m-mobile-wallet-selection>` : l`<w3m-desktop-wallet-selection></w3m-desktop-wallet-selection>`;
  }

  render() {
    return l`${this.viewTemplate()}<w3m-legal-notice></w3m-legal-notice>`;
  }

};
et.styles = [u.globalCss], et = qa([b("w3m-connect-wallet-view")], et);
const Ka = y`.w3m-wrapper{display:flex;align-items:center;justify-content:center;width:100%;aspect-ratio:1/1;flex-direction:column}.w3m-connecting-title{display:flex;align-items:center;justify-content:center;margin-bottom:16px}w3m-spinner{margin-right:10px}w3m-wallet-image{border-radius:15px;width:25%;aspect-ratio:1/1;margin-bottom:20px}.w3m-install-actions{display:flex}.w3m-install-actions w3m-button{margin:0 5px;opacity:1}`;

var Ya = Object.defineProperty,
    Xa = Object.getOwnPropertyDescriptor,
    kt = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? Xa(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Ya(t, a, o), o;
};

let Pe = class extends w {
  constructor() {
    super(), this.uri = "", this.createConnectionAndWait();
  }

  getRouterData() {
    var e;
    const t = (e = I.state.data) == null ? void 0 : e.DesktopConnector;
    if (!t) throw new Error("Missing router data");
    return t;
  }

  onFormatAndRedirect(e) {
    const {
      native: t,
      universal: a,
      name: n
    } = this.getRouterData();

    if (t) {
      const o = W.formatNativeUrl(t, e, n);
      W.openHref(o);
    } else if (a) {
      const o = W.formatUniversalUrl(a, e, n);
      W.openHref(o, "_blank");
    }
  }

  async createConnectionAndWait() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var t;
    const {
      standaloneUri: a
    } = p.state,
          {
      name: n,
      walletId: o,
      native: r,
      universal: i,
      icon: c
    } = this.getRouterData(),
          m = {
      name: n,
      id: o,
      links: {
        native: r,
        universal: i
      },
      image: c
    };
    if (a) h.setRecentWallet(m), this.onFormatAndRedirect(a);else try {
      await L.client().connectWalletConnect(s => {
        this.uri = s, this.onFormatAndRedirect(s);
      }, (t = p.state.selectedChain) == null ? void 0 : t.id), h.setRecentWallet(m), _.close();
    } catch (s) {
      console.error(s), D.openToast("Connection request declined", "error"), e < 2 && this.createConnectionAndWait(e + 1);
    }
  }

  onConnectWithMobile() {
    I.push("Qrcode");
  }

  onGoToWallet() {
    const {
      universal: e,
      name: t
    } = this.getRouterData();

    if (e) {
      const a = W.formatUniversalUrl(e, this.uri, t);
      W.openHref(a, "_blank");
    }
  }

  render() {
    const {
      name: e,
      icon: t,
      universal: a,
      walletId: n
    } = this.getRouterData(),
          o = h.getWalletName(e);
    return l`<w3m-modal-header title="${o}"></w3m-modal-header><w3m-modal-content><div class="w3m-wrapper">${t ? l`<w3m-wallet-image src="${t}" size="lg"></w3m-wallet-image>` : l`<w3m-wallet-image size="lg" walletid="${B(n)}"></w3m-wallet-image>`}<div class="w3m-connecting-title"><w3m-spinner></w3m-spinner><w3m-text variant="large-bold" color="secondary">${`Continue in ${o}...`}</w3m-text></div><div class="w3m-install-actions"><w3m-button .onClick="${async () => this.createConnectionAndWait()}" .iconRight="${g.RETRY_ICON}">Retry</w3m-button>${a ? l`<w3m-button .onClick="${this.onGoToWallet.bind(this)}" .iconLeft="${g.ARROW_UP_RIGHT_ICON}">Go to Wallet</w3m-button>` : l`<w3m-button .onClick="${this.onConnectWithMobile}" .iconLeft="${g.MOBILE_ICON}">Connect with Mobile</w3m-button>`}</div></div></w3m-modal-content>`;
  }

};
Pe.styles = [u.globalCss, Ka], kt([$()], Pe.prototype, "uri", 2), Pe = kt([b("w3m-desktop-connector-view")], Pe);
const Qa = y`.w3m-info-text{margin:5px 0 15px;max-width:320px;text-align:center}.w3m-wallet-item{margin:0 -20px 0 0;padding-right:20px;display:flex;align-items:center;border-bottom:1px solid var(--w3m-color-bg-2)}.w3m-wallet-item:last-child{margin-bottom:-20px;border-bottom:0}.w3m-wallet-content{margin-left:20px;height:60px;display:flex;flex:1;align-items:center;justify-content:space-between}.w3m-footer-actions{display:flex;flex-direction:column;align-items:center;padding:20px 0;border-top:1px solid var(--w3m-color-bg-2)}w3m-wallet-image{display:block;width:40px;height:40px;border-radius:10px}`;

var Ja = Object.defineProperty,
    en = Object.getOwnPropertyDescriptor,
    tn = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? en(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Ja(t, a, o), o;
};

let tt = class extends w {
  constructor() {
    super(...arguments), this.explorerUrl = "https://explorer.walletconnect.com/";
  }

  onGet(e) {
    W.openHref(e, "_blank");
  }

  onExplore() {
    W.openHref(this.explorerUrl, "_blank");
  }

  render() {
    const {
      recomendedWallets: e
    } = S.state,
          t = h.getCustomWallets().slice(0, 6),
          a = e.length,
          n = t.length;
    return l`<w3m-modal-header title="Get a wallet"></w3m-modal-header><w3m-modal-content>${a ? e.map(_ref39 => {
      let {
        name: o,
        image_url: r,
        homepage: i
      } = _ref39;
      return l`<div class="w3m-wallet-item"><w3m-wallet-image src="${r.lg}"></w3m-wallet-image><div class="w3m-wallet-content"><w3m-text variant="medium-normal">${o}</w3m-text><w3m-button .iconRight="${g.ARROW_RIGHT_ICON}" .onClick="${() => this.onGet(i)}">Get</w3m-button></div></div>`;
    }) : null} ${n ? t.map(_ref40 => {
      let {
        name: o,
        id: r,
        links: i
      } = _ref40;
      return l`<div class="w3m-wallet-item"><w3m-wallet-image walletId="${r}"></w3m-wallet-image><div class="w3m-wallet-content"><w3m-text variant="medium-normal">${o}</w3m-text><w3m-button .iconRight="${g.ARROW_RIGHT_ICON}" .onClick="${() => this.onGet(i.universal)}">Get</w3m-button></div></div>`;
    }) : null}</w3m-modal-content><div class="w3m-footer-actions"><w3m-text variant="medium-normal">Not what you're looking for?</w3m-text><w3m-text variant="small-thin" color="secondary" class="w3m-info-text">With hundreds of wallets out there, there's something for everyone</w3m-text><w3m-button .onClick="${this.onExplore.bind(this)}" .iconRight="${g.ARROW_UP_RIGHT_ICON}">Explore Wallets</w3m-button></div>`;
  }

};
tt.styles = [u.globalCss, Qa], tt = tn([b("w3m-get-wallet-view")], tt);
const on = y`.w3m-footer-actions{display:flex;justify-content:center}.w3m-footer-actions w3m-button{margin:0 5px}.w3m-info-container{display:flex;flex-direction:column;justify-content:center;align-items:center;margin-bottom:20px}.w3m-info-container:last-child{margin-bottom:0}.w3m-info-text{margin-top:5px;text-align:center}.w3m-images svg{margin:0 2px 5px;width:55px;height:55px}.help-img-highlight{stroke:var(--w3m-color-overlay)}`;

var an = Object.defineProperty,
    nn = Object.getOwnPropertyDescriptor,
    rn = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? nn(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && an(t, a, o), o;
};

let ot = class extends w {
  constructor() {
    super(...arguments), this.learnUrl = "https://ethereum.org/en/wallets/";
  }

  onGet() {
    I.push("GetWallet");
  }

  onLearnMore() {
    W.openHref(this.learnUrl, "_blank");
  }

  render() {
    return l`<w3m-modal-header title="What is a wallet?"></w3m-modal-header><w3m-modal-content><div class="w3m-info-container"><div class="w3m-images">${g.HELP_CHART_IMG} ${g.HELP_PAINTING_IMG} ${g.HELP_ETH_IMG}</div><w3m-text variant="medium-normal">A home for your digital assets</w3m-text><w3m-text variant="small-thin" color="secondary" class="w3m-info-text">A wallet lets you store, send and receive digital assets like cryptocurrencies and NFTs.</w3m-text></div><div class="w3m-info-container"><div class="w3m-images">${g.HELP_KEY_IMG} ${g.HELP_USER_IMG} ${g.HELP_LOCK_IMG}</div><w3m-text variant="medium-normal">One login for all of web3</w3m-text><w3m-text variant="small-thin" color="secondary" class="w3m-info-text">Log in to any app by connecting your wallet. Say goodbye to countless passwords!</w3m-text></div><div class="w3m-info-container"><div class="w3m-images">${g.HELP_COMPAS_IMG} ${g.HELP_NOUN_IMG} ${g.HELP_DAO_IMG}</div><w3m-text variant="medium-normal">Your gateway to a new web</w3m-text><w3m-text variant="small-thin" color="secondary" class="w3m-info-text">With your wallet, you can explore and interact with DeFi, NFTs, DAOs, and much more.</w3m-text></div><div class="w3m-footer-actions"><w3m-button .onClick="${this.onGet.bind(this)}" .iconLeft="${g.WALLET_ICON}">Get a Wallet</w3m-button><w3m-button .onClick="${this.onLearnMore.bind(this)}" .iconRight="${g.ARROW_UP_RIGHT_ICON}">Learn More</w3m-button></div></w3m-modal-content>`;
  }

};
ot.styles = [u.globalCss, on], ot = rn([b("w3m-help-view")], ot);
const ln = y`.w3m-injected-wrapper{display:flex;align-items:center;justify-content:center;width:100%;aspect-ratio:1/1;flex-direction:column}.w3m-connecting-title{display:flex;align-items:center;justify-content:center;margin-bottom:20px}w3m-spinner{margin-right:10px}w3m-wallet-image{border-radius:15px;width:25%;aspect-ratio:1/1;margin-bottom:20px}w3m-button{opacity:0}.w3m-injected-error w3m-button{opacity:1}`;

var sn = Object.defineProperty,
    cn = Object.getOwnPropertyDescriptor,
    at = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? cn(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && sn(t, a, o), o;
};

let ye = class extends w {
  constructor() {
    super(), this.connecting = !0, this.error = !1, this.connector = L.client().getConnectorById("injected"), this.onConnect();
  }

  async onConnect() {
    const {
      ready: e
    } = this.connector;
    e && (this.error = !1, this.connecting = !0, await h.handleConnectorConnection("injected", () => {
      this.error = !0, this.connecting = !1;
    }));
  }

  render() {
    const e = h.getWalletName(this.connector.name),
          t = h.getWalletId(this.connector.id),
          a = {
      "w3m-injected-wrapper": !0,
      "w3m-injected-error": this.error
    };
    return l`<w3m-modal-header title="${e}"></w3m-modal-header><w3m-modal-content><div class="${T(a)}"><w3m-wallet-image walletId="${t}" size="lg"></w3m-wallet-image><div class="w3m-connecting-title">${this.connecting ? l`<w3m-spinner></w3m-spinner>` : null}<w3m-text variant="large-bold" color="${this.error ? "error" : "secondary"}">${this.error ? "Connection declined" : `Continue in ${e}...`}</w3m-text></div><w3m-button .onClick="${this.onConnect.bind(this)}" .disabled="${!this.error}" .iconRight="${g.RETRY_ICON}">Try Again</w3m-button></div></w3m-modal-content>`;
  }

};
ye.styles = [u.globalCss, ln], at([$()], ye.prototype, "connecting", 2), at([$()], ye.prototype, "error", 2), ye = at([b("w3m-injected-connector-view")], ye);
const dn = y`.w3m-injected-wrapper{display:flex;align-items:center;justify-content:center;width:100%;aspect-ratio:1/1;flex-direction:column}.w3m-connecting-title{display:flex;align-items:center;justify-content:center;margin-bottom:16px}.w3m-install-title{display:flex;align-items:center;justify-content:center;flex-direction:column}.w3m-install-title w3m-text:last-child{margin-top:10px;max-width:240px}.w3m-install-actions{display:flex;margin-top:15px;align-items:center;flex-direction:column}@media(max-width:355px){.w3m-install-actions{flex-direction:column;align-items:center}}w3m-wallet-image{border-radius:15px;width:25%;aspect-ratio:1/1;margin-bottom:20px}w3m-button{opacity:0}.w3m-install-actions w3m-button{margin:5px;opacity:1}.w3m-info-text{text-align:center}`;

var hn = Object.defineProperty,
    mn = Object.getOwnPropertyDescriptor,
    pn = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? mn(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && hn(t, a, o), o;
};

let nt = class extends w {
  getRouterData() {
    var e;
    const t = (e = I.state.data) == null ? void 0 : e.InstallConnector;
    if (!t) throw new Error("Missing router data");
    return t;
  }

  onInstall() {
    const {
      url: e
    } = this.getRouterData();
    W.openHref(e, "_blank");
  }

  onMobile() {
    const {
      name: e
    } = this.getRouterData();
    I.push("ConnectWallet"), D.openToast(`Scan the code with ${e}`, "success");
  }

  render() {
    const {
      name: e,
      id: t,
      isMobile: a
    } = this.getRouterData();
    return l`<w3m-modal-header title="${e}"></w3m-modal-header><w3m-modal-content><div class="w3m-injected-wrapper"><w3m-wallet-image walletId="${t}" size="lg"></w3m-wallet-image><div class="w3m-install-title"><w3m-text variant="large-bold">Install ${e}</w3m-text><w3m-text color="secondary" variant="medium-thin" class="w3m-info-text">To connect ${e}, install the browser extension.</w3m-text></div><div class="w3m-install-actions"><w3m-button .onClick="${this.onInstall.bind(this)}" .iconLeft="${g.ARROW_DOWN_ICON}">Install Extension</w3m-button>${a ? l`<w3m-button .onClick="${this.onMobile.bind(this)}" .iconLeft="${g.MOBILE_ICON}">${e} Mobile</w3m-button>` : null}</div></div></w3m-modal-content>`;
  }

};
nt.styles = [u.globalCss, dn], nt = pn([b("w3m-install-connector-view")], nt);

var un = Object.defineProperty,
    vn = Object.getOwnPropertyDescriptor,
    gn = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? vn(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && un(t, a, o), o;
};

let rt = class extends w {
  render() {
    return l`<w3m-modal-header title="Scan the code" .onAction="${h.handleUriCopy}" .actionIcon="${g.COPY_ICON}"></w3m-modal-header><w3m-modal-content><w3m-walletconnect-qr></w3m-walletconnect-qr></w3m-modal-content>`;
  }

};
rt.styles = [u.globalCss], rt = gn([b("w3m-qrcode-view")], rt);
const wn = y`.w3m-grid{display:grid;grid-template-columns:repeat(4,80px);margin:-5px -10px;justify-content:space-between}`;

var bn = Object.defineProperty,
    fn = Object.getOwnPropertyDescriptor,
    yn = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? fn(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && bn(t, a, o), o;
};

let it = class extends w {
  async onSelectChain(e) {
    const {
      isConnected: t,
      selectedChain: a,
      walletConnectVersion: n
    } = p.state;
    t ? (a === null || a === void 0 ? void 0 : a.id) === e.id ? I.replace("Account") : n === 2 ? (await L.client().switchNetwork({
      chainId: e.id
    }), I.replace("Account")) : I.push("SwitchNetwork", {
      SwitchNetwork: e
    }) : (I.push("ConnectWallet"), p.setSelectedChain(e));
  }

  render() {
    const {
      chains: e
    } = p.state;
    return l`<w3m-modal-header title="Select network"></w3m-modal-header><w3m-modal-content><div class="w3m-grid">${e === null || e === void 0 ? void 0 : e.map(t => l`<w3m-network-button name="${t.name}" chainId="${t.id}" .onClick="${async () => this.onSelectChain(t)}">${t.name}</w3m-network-button>`)}</div></w3m-modal-content>`;
  }

};
it.styles = [u.globalCss, wn], it = yn([b("w3m-select-network-view")], it);
const xn = y`.w3m-wrapper{display:flex;align-items:center;justify-content:center;width:100%;aspect-ratio:1/1;flex-direction:column}.w3m-connecting-title{display:flex;align-items:center;justify-content:center;margin-bottom:16px}w3m-spinner{margin-right:10px}w3m-network-image{width:96px;height:96px;margin-bottom:20px}w3m-button{opacity:0}.w3m-error w3m-button{opacity:1}`;

var Cn = Object.defineProperty,
    kn = Object.getOwnPropertyDescriptor,
    $t = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? kn(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && Cn(t, a, o), o;
};

let _e = class extends w {
  constructor() {
    super(), this.error = !1, this.onSwitchNetwork();
  }

  getRouterData() {
    var e;
    const t = (e = I.state.data) == null ? void 0 : e.SwitchNetwork;
    if (!t) throw new Error("Missing router data");
    return t;
  }

  async onSwitchNetwork() {
    try {
      this.error = !1;
      const e = this.getRouterData();
      await L.client().switchNetwork({
        chainId: e.id
      }), p.setSelectedChain(e), I.replace("Account");
    } catch {
      this.error = !0;
    }
  }

  render() {
    const {
      id: e,
      name: t
    } = this.getRouterData(),
          a = {
      "w3m-wrapper": !0,
      "w3m-error": this.error
    };
    return l`<w3m-modal-header title="${`Connect to ${t}`}"></w3m-modal-header><w3m-modal-content><div class="${T(a)}"><w3m-network-image chainId="${e}"></w3m-network-image><div class="w3m-connecting-title">${this.error ? null : l`<w3m-spinner></w3m-spinner>`}<w3m-text variant="large-bold" color="${this.error ? "error" : "secondary"}">${this.error ? "Connection declined" : "Approve in your wallet"}</w3m-text></div><w3m-button .onClick="${this.onSwitchNetwork.bind(this)}" .disabled="${!this.error}" .iconRight="${g.RETRY_ICON}">Try Again</w3m-button></div></w3m-modal-content>`;
  }

};

_e.styles = [u.globalCss, xn], $t([$()], _e.prototype, "error", 2), _e = $t([b("w3m-switch-network-view")], _e);
const $n = y`w3m-modal-content{height:clamp(200px,60vh,600px);display:block;overflow:scroll;scrollbar-width:none;position:relative;margin-top:1px}.w3m-grid{display:grid;grid-template-columns:repeat(4,80px);justify-content:space-between;margin:-15px -10px;padding-top:20px}w3m-modal-content::after,w3m-modal-content::before{content:'';position:fixed;pointer-events:none;z-index:1;width:100%;height:20px;opacity:1}w3m-modal-content::before{box-shadow:0 -1px 0 0 var(--w3m-color-bg-1);background:linear-gradient(var(--w3m-color-bg-1),rgba(255,255,255,0))}w3m-modal-content::after{box-shadow:0 1px 0 0 var(--w3m-color-bg-1);background:linear-gradient(rgba(255,255,255,0),var(--w3m-color-bg-1));top:calc(100% - 20px)}w3m-modal-content::-webkit-scrollbar{display:none}.w3m-placeholder-block{display:flex;justify-content:center;align-items:center;height:100px;overflow:hidden}.w3m-empty,.w3m-loading{display:flex}.w3m-loading .w3m-placeholder-block{height:100%}.w3m-end-reached .w3m-placeholder-block{height:0;opacity:0}.w3m-empty .w3m-placeholder-block{opacity:1;height:100%}w3m-wallet-button{margin:calc((100% - 60px)/ 3) 0}`;

var On = Object.defineProperty,
    In = Object.getOwnPropertyDescriptor,
    xe = (e, t, a, n) => {
  for (var o = n > 1 ? void 0 : n ? In(t, a) : t, r = e.length - 1, i; r >= 0; r--) (i = e[r]) && (o = (n ? i(t, a, o) : i(o)) || o);

  return n && o && On(t, a, o), o;
};

const lt = 40;
let Q = class extends w {
  constructor() {
    super(...arguments), this.loading = !S.state.wallets.listings.length, this.firstFetch = !S.state.wallets.listings.length, this.search = "", this.endReached = !1, this.intersectionObserver = void 0, this.searchDebounce = h.debounce(e => {
      e.length >= 3 ? (this.firstFetch = !0, this.endReached = !1, this.search = e, S.resetSearch(), this.fetchWallets()) : this.search && (this.search = "", this.endReached = this.isLastPage(), S.resetSearch());
    });
  }

  firstUpdated() {
    this.createPaginationObserver();
  }

  disconnectedCallback() {
    var e;
    (e = this.intersectionObserver) == null || e.disconnect();
  }

  get placeholderEl() {
    return h.getShadowRootElement(this, ".w3m-placeholder-block");
  }

  createPaginationObserver() {
    this.intersectionObserver = new IntersectionObserver(_ref41 => {
      let [e] = _ref41;
      e.isIntersecting && !(this.search && this.firstFetch) && this.fetchWallets();
    }), this.intersectionObserver.observe(this.placeholderEl);
  }

  isLastPage() {
    const {
      wallets: e,
      search: t
    } = S.state,
          {
      listings: a,
      total: n
    } = this.search ? t : e;
    return n <= lt || a.length >= n;
  }

  async fetchWallets() {
    var e;
    const {
      wallets: t,
      search: a
    } = S.state,
          n = h.getExtensionWallets(),
          {
      listings: o,
      total: r,
      page: i
    } = this.search ? a : t;
    if (!this.endReached && (this.firstFetch || r > lt && o.length < r)) try {
      this.loading = !0;
      const c = (e = p.state.standaloneChains) == null ? void 0 : e.join(","),
            {
        listings: m
      } = await S.getPaginatedWallets({
        page: this.firstFetch ? 1 : i + 1,
        entries: lt,
        device: W.isMobile() ? "mobile" : "desktop",
        search: this.search,
        version: p.state.walletConnectVersion,
        chains: c
      }),
            s = m.map(_ref42 => {
        let {
          image_url: v
        } = _ref42;
        return v.lg;
      }),
            d = n.map(_ref43 => {
        let {
          id: v
        } = _ref43;
        return h.getWalletIcon(v);
      });
      await Promise.all([...s.map(async v => h.preloadImage(v)), ...d.map(async v => h.preloadImage(v)), W.wait(300)]), this.endReached = this.isLastPage();
    } catch (c) {
      console.error(c), D.openToast(h.getErrorMessage(c), "error");
    } finally {
      this.loading = !1, this.firstFetch = !1;
    }
  }

  onConnectCustom(_ref44) {
    let {
      name: e,
      id: t,
      links: a
    } = _ref44;
    W.isMobile() ? h.handleMobileLinking({
      links: a,
      name: e,
      id: t
    }) : I.push("DesktopConnector", {
      DesktopConnector: {
        name: e,
        walletId: t,
        universal: a.universal,
        native: a.native
      }
    });
  }

  onConnectListing(e) {
    if (W.isMobile()) {
      const {
        id: t,
        image_url: a
      } = e,
            {
        native: n,
        universal: o
      } = e.mobile;
      h.handleMobileLinking({
        links: {
          native: n,
          universal: o
        },
        name: e.name,
        id: t,
        image: a.lg
      });
    } else I.push("DesktopConnector", {
      DesktopConnector: {
        name: e.name,
        icon: e.image_url.lg,
        universal: e.desktop.universal || e.homepage,
        native: e.desktop.native
      }
    });
  }

  onConnectExtension(e) {
    h.getWalletId("") === e.id ? I.push("InjectedConnector") : I.push("InstallConnector", {
      InstallConnector: e
    });
  }

  onSearchChange(e) {
    const {
      value: t
    } = e.target;
    this.searchDebounce(t);
  }

  coinbaseConnectorTemplate() {
    try {
      const e = L.client().getConnectorById(Z.coinbaseWallet);
      return l`<w3m-wallet-button name="${e.name}" walletId="${e.id}" .onClick="${async () => h.handleConnectorConnection(Z.coinbaseWallet)}"></w3m-wallet-button>`;
    } catch {
      return null;
    }
  }

  render() {
    const {
      wallets: e,
      search: t
    } = S.state,
          {
      isStandalone: a
    } = p.state;
    let {
      listings: n
    } = this.search ? t : e;
    n = R.allowedExplorerListings(n);
    const o = this.loading && !n.length,
          r = this.search.length >= 3,
          i = !o && (!r || h.caseSafeIncludes(Z.coinbaseWallet, this.search));
    let c = !a && !W.isMobile() ? h.getExtensionWallets() : [],
        m = h.getCustomWallets();
    r && (c = c.filter(_ref45 => {
      let {
        name: O
      } = _ref45;
      return h.caseSafeIncludes(O, this.search);
    }), m = m.filter(_ref46 => {
      let {
        name: O
      } = _ref46;
      return h.caseSafeIncludes(O, this.search);
    }));
    const s = !this.loading && !n.length && !c.length && !i,
          d = Math.max(c.length, n.length),
          v = {
      "w3m-loading": o,
      "w3m-end-reached": this.endReached || !this.loading,
      "w3m-empty": s
    };
    return l`<w3m-modal-header><w3m-search-input .onChange="${this.onSearchChange.bind(this)}"></w3m-search-input></w3m-modal-header><w3m-modal-content class="${T(v)}"><div class="w3m-grid">${o ? null : [...Array(d)].map((O, C) => l`${m[C] ? l`<w3m-wallet-button name="${m[C].name}" walletId="${m[C].id}" .onClick="${() => this.onConnectCustom(m[C])}"></w3m-wallet-button>` : null} ${c[C] ? l`<w3m-wallet-button name="${c[C].name}" walletId="${c[C].id}" .onClick="${() => this.onConnectExtension(c[C])}"></w3m-wallet-button>` : null} ${n[C] ? l`<w3m-wallet-button src="${n[C].image_url.lg}" name="${n[C].name}" walletId="${n[C].id}" .onClick="${() => this.onConnectListing(n[C])}"></w3m-wallet-button>` : null}`)} ${i ? this.coinbaseConnectorTemplate() : null}</div><div class="w3m-placeholder-block">${s ? l`<w3m-text variant="large-bold" color="secondary">No results found</w3m-text>` : null} ${!s && this.loading ? l`<w3m-spinner></w3m-spinner>` : null}</div></w3m-modal-content>`;
  }

};
Q.styles = [u.globalCss, $n], xe([$()], Q.prototype, "loading", 2), xe([$()], Q.prototype, "firstFetch", 2), xe([$()], Q.prototype, "search", 2), xe([$()], Q.prototype, "endReached", 2), Q = xe([b("w3m-wallet-explorer-view")], Q);
export { We as W3mAccountButton, ae as W3mConnectButton, ne as W3mCoreButton, re as W3mModal, ie as W3mNetworkSwitch };